/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

/**
 * A single row in the Airtable "Action Items" table.
 *
 * Field names mirror Airtable column names. `id` is Airtable's record id
 * (`rec...`) — stable across renames of the Title field.
 */
export type ActionItem = {
  __typename?: 'ActionItem';
  createdDate?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMentioned?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * Free-text outcome captured when the card moves to Resolved.
   * Surfaces the Airtable "Outcome" column; null when the column is
   * empty or doesn't exist in the base yet.
   */
  outcome?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceReference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActiveOrgResult = {
  __typename?: 'ActiveOrgResult';
  organization?: Maybe<Organization>;
  /**
   * Caller's role in the active org (e.g. OWNER, ADMIN, MEMBER).
   * Null when there is no active org. Used by the UI to hide
   * admin-only affordances such as "Connect" / "Revoke" on shared
   * integrations (S8 RFC §4.9). Server-side enforcement still lives
   * in `requireOrgAdmin`; this field is the UX hint, not the gate.
   */
  role?: Maybe<Scalars['String']['output']>;
};

/** Input for adding a participant to a plan with global identity */
export type AddGlobalParticipantInput = {
  displayName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  role?: InputMaybe<ParticipantRole>;
};

/**
 * Lead view exposed to the admin surface. Unifies the two lead-capture
 * pipelines so the founder console sees every lead regardless of origin:
 *
 * - `leads` (Ahmed's standalone `captureLead`): structured `source`, `ops`,
 *   `opsOther`, `goals`, `stack`, `linkedin`, plus request metadata.
 * - `pilot_leads` (the React port's `submitPilotLead`): `kind`, `notes`,
 *   `visitorId`; identity arrives split as first/last name and is merged
 *   into `name` here.
 *
 * Fields that a given pipeline doesn't record are returned `null` (or `[]`
 * for `ops`). Exactly one of `source` / `kind` is set per row.
 */
export type AdminLead = {
  __typename?: 'AdminLead';
  company?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['JSONObject']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  goals?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Set for `pilot_leads`-collection rows (the React port). Null for `leads` rows. */
  kind?: Maybe<PilotLeadKind>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Freeform context blob. `pilot_leads` currently packs linkedin/ops/goals/stack
   * in here (see lead-api.js packNotes) until those are promoted to real fields.
   */
  notes?: Maybe<Scalars['String']['output']>;
  ops: Array<Scalars['String']['output']>;
  opsOther?: Maybe<Scalars['String']['output']>;
  referer?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  /** Set for `leads`-collection rows (Ahmed's pipeline). Null for `pilot_leads` rows. */
  source?: Maybe<LeadSource>;
  stack?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  /** Links a `pilot_leads` row to its `pilot_visitors` record. Null for `leads` rows. */
  visitorId?: Maybe<Scalars['String']['output']>;
};

/** A field the thread is expected to collect. */
export type AllowedField = {
  __typename?: 'AllowedField';
  description?: Maybe<Scalars['String']['output']>;
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: AllowedFieldType;
};

/** Input for allowed field. */
export type AllowedFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enumValues?: InputMaybe<Array<Scalars['String']['input']>>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  type: AllowedFieldType;
};

/** Field type for allowed fields. */
export enum AllowedFieldType {
  Boolean = 'boolean',
  Date = 'date',
  Enum = 'enum',
  EnumMulti = 'enum_multi',
  File = 'file',
  Number = 'number',
  String = 'string',
  StringLong = 'string_long'
}

export type AnalyzePlanGoalInput = {
  /** IDs of temp uploads to include as context for analysis. */
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  prompt: Scalars['String']['input'];
  userContext?: InputMaybe<UserContextInput>;
};

/**
 * S10 / ADR-0004 — anonymous-principal session bound to a single
 * runId. The caller exchanges `token` for the `AnonymousPrincipal`
 * on every subsequent GraphQL request via the `X-Anonymous-Token`
 * header. `expiresAt` is ISO-8601 and bounded by ADR-0004.
 */
export type AnonymousRunSession = {
  __typename?: 'AnonymousRunSession';
  expiresAt: Scalars['String']['output'];
  principalId: Scalars['ID']['output'];
  runId: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

export type AppNotification = {
  __typename?: 'AppNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Decision made by an approver on a step requiring approval */
export enum ApprovalDecision {
  Approved = 'APPROVED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Rejected = 'REJECTED'
}

/**
 * Record of an approval decision on a step.
 * Steps with ConsentLevel.REQUIRE_APPROVAL collect these before execution proceeds.
 */
export type ApprovalRecord = {
  __typename?: 'ApprovalRecord';
  approverEmail?: Maybe<Scalars['String']['output']>;
  approverName?: Maybe<Scalars['String']['output']>;
  /** User who made the approval decision */
  approverUserId: Scalars['String']['output'];
  /** Optional comment explaining the decision */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the decision was made */
  decidedAt: Scalars['String']['output'];
  /** The decision (approved, rejected, or changes requested) */
  decision: ApprovalDecision;
  id: Scalars['ID']['output'];
};

/**
 * An item assigned to a person (appears in their inbox).
 * Denormalized view for efficient inbox queries.
 */
export type AssignedItem = {
  __typename?: 'AssignedItem';
  assignedAt: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
  itemType: AssignedItemType;
  planId: Scalars['ID']['output'];
  planTitle: Scalars['String']['output'];
  status: StepStatus;
  stepTitle: Scalars['String']['output'];
};

/** Type of assigned item in participant's inbox */
export enum AssignedItemType {
  RequestThread = 'REQUEST_THREAD',
  Step = 'STEP'
}

/** Error that occurred during auto-execution of a step */
export type AutoExecuteError = {
  __typename?: 'AutoExecuteError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  stepId: Scalars['ID']['output'];
};

/** Result of executing all eligible steps in a plan automatically */
export type AutoExecuteResult = {
  __typename?: 'AutoExecuteResult';
  /** Errors that occurred during execution */
  errors: Array<AutoExecuteError>;
  /** Steps that were successfully executed */
  executed: Array<Scalars['ID']['output']>;
  /** Steps that were skipped (not eligible for auto-execution) */
  skipped: Array<Scalars['ID']['output']>;
};

export type AutomationAction = {
  __typename?: 'AutomationAction';
  agentConfig?: Maybe<Scalars['JSON']['output']>;
  agentProfile?: Maybe<Scalars['String']['output']>;
  bodyTemplate?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  headersTemplate?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  mode: AutomationActionMode;
  name?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  paramsTemplate?: Maybe<Scalars['JSON']['output']>;
  promptTemplate?: Maybe<Scalars['String']['output']>;
  timeoutMs?: Maybe<Scalars['Int']['output']>;
  toolRef?: Maybe<Scalars['String']['output']>;
};

export enum AutomationActionMode {
  Agent = 'AGENT',
  Tool = 'TOOL',
  Webhook = 'WEBHOOK'
}

export type AutomationAlert = {
  __typename?: 'AutomationAlert';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedAt?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  planId?: Maybe<Scalars['ID']['output']>;
  severity: Scalars['String']['output'];
  stepId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type AutomationQueueHealth = {
  __typename?: 'AutomationQueueHealth';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  deadLetter: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

/** Blocked reason category for context fillers */
export enum BlockedReasonCategory {
  AwaitingDependency = 'AWAITING_DEPENDENCY',
  AwaitingInput = 'AWAITING_INPUT',
  ExternalBlocker = 'EXTERNAL_BLOCKER',
  Unknown = 'UNKNOWN'
}

export type BlockedSourceItem = {
  __typename?: 'BlockedSourceItem';
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * SECURITY CRITICAL: The bounded result that crosses to parent.
 * Only contains validated allowedKeys.
 */
export type BoundedResult = {
  __typename?: 'BoundedResult';
  attachmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  confidence: Scalars['Float']['output'];
  confirmedAt: Scalars['String']['output'];
  fields: Scalars['JSON']['output'];
  summary: Scalars['String']['output'];
};

export type BrandCandidate = {
  __typename?: 'BrandCandidate';
  confidence: Scalars['Float']['output'];
  dedupeHash?: Maybe<Scalars['String']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  tokenType: BrandTokenType;
  value: Scalars['String']['output'];
};

export type BrandDiscoveryInput = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
  sourceUrl: Scalars['String']['input'];
};

export type BrandDiscoveryResult = {
  __typename?: 'BrandDiscoveryResult';
  brandCandidates: Array<BrandCandidate>;
  confidence: Scalars['Float']['output'];
  discoveredAt?: Maybe<Scalars['String']['output']>;
  selectedCandidates?: Maybe<BrandSelection>;
  sourceArtifacts: Array<Scalars['String']['output']>;
  status: BrandDiscoveryStatus;
  warnings: Array<Scalars['String']['output']>;
};

export enum BrandDiscoveryStatus {
  Discovered = 'DISCOVERED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Weak = 'WEAK'
}

export type BrandPalette = {
  __typename?: 'BrandPalette';
  background?: Maybe<Scalars['String']['output']>;
  primary: Scalars['String']['output'];
  secondary?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BrandPaletteInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  primary: Scalars['String']['input'];
  secondary?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BrandProfileImpact = {
  __typename?: 'BrandProfileImpact';
  migratableGuideIds: Array<Scalars['ID']['output']>;
  orgDefaultGuideCount: Scalars['Int']['output'];
  orgId: Scalars['ID']['output'];
  pinnedImportProfileGuideCount: Scalars['Int']['output'];
  profileId: Scalars['ID']['output'];
};

export enum BrandProfileStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type BrandSelection = {
  __typename?: 'BrandSelection';
  headerLogoUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  organizationDisplayName?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<BrandTone>;
};

export enum BrandTokenType {
  Logo = 'LOGO',
  Name = 'NAME',
  Palette = 'PALETTE',
  Tone = 'TONE'
}

export enum BrandTone {
  Formal = 'FORMAL',
  Friendly = 'FRIENDLY',
  Neutral = 'NEUTRAL'
}

export type CaptureLeadInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-form client context (active intake, current process slug, share-link
   * state). Capped server-side to keep documents small.
   */
  context?: InputMaybe<Scalars['JSONObject']['input']>;
  email: Scalars['String']['input'];
  goals?: InputMaybe<Scalars['String']['input']>;
  /** Honeypot — must be empty. Bots fill this field; humans never see it. */
  honeypot?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ops?: InputMaybe<Array<Scalars['String']['input']>>;
  opsOther?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  source: LeadSource;
  stack?: InputMaybe<Scalars['String']['input']>;
};

export type CaptureLeadResult = {
  __typename?: 'CaptureLeadResult';
  leadId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** A single message in a conversation */
export type ChatMessage = {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  /** Optional snapshot of context at time of message (for debugging/audit) */
  contextSnapshot?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  role: ChatRole;
  timestamp: Scalars['String']['output'];
};

export enum ChatRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  User = 'USER'
}

/**
 * S10 — outcome of a successful anonymous-run claim. The
 * AnonymousPrincipal is preserved (`claimedBy` set) for audit and
 * the listed RUN connections were rebound to the caller's user
 * principal.
 */
export type ClaimAnonymousRunResult = {
  __typename?: 'ClaimAnonymousRunResult';
  claimedPrincipalId: Scalars['ID']['output'];
  newOwnerPrincipalId: Scalars['ID']['output'];
  transferredConnectionCount: Scalars['Int']['output'];
};

export type ClaimPreviewResult = {
  __typename?: 'ClaimPreviewResult';
  /** Generation job ID for the full guide being created in the background. */
  generationJobId?: Maybe<Scalars['ID']['output']>;
  /** Magic link URL — only returned in emulator/dev mode for convenience. */
  magicLinkUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A clarifying question to ask the user before generating the plan */
export type ClarifyingQuestion = {
  __typename?: 'ClarifyingQuestion';
  choices?: Maybe<Array<Scalars['String']['output']>>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

export type ClarifyingQuestionInput = {
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  question: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

export type ClassificationOverride = {
  __typename?: 'ClassificationOverride';
  isProcess: Scalars['Boolean']['output'];
  setAt: Scalars['String']['output'];
  setBy: Scalars['String']['output'];
};

export type ClassificationResult = {
  __typename?: 'ClassificationResult';
  classifiedAt: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  doc_type_hint: Scalars['String']['output'];
  is_process: Scalars['Boolean']['output'];
  needs_fallback: Scalars['Boolean']['output'];
  references_process: Scalars['Boolean']['output'];
  signals: Array<Scalars['String']['output']>;
  wave: Scalars['String']['output'];
};

/** Result of confirming thread satisfaction. */
export type ConfirmThreadResult = {
  __typename?: 'ConfirmThreadResult';
  parentStepUpdated: Scalars['Boolean']['output'];
  requestThread: RequestThread;
  result: BoundedResult;
};

export type ConnectSessionResult = {
  __typename?: 'ConnectSessionResult';
  connectUrl: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/**
 * Returned by `connectionRequirement(...)` when a step is blocked on a
 * connection. The JIT UI uses `allowedTiers` + `defaultTier` to render
 * the tier picker and `consumerPitch` for human-readable copy.
 */
export type ConnectionRequirement = {
  __typename?: 'ConnectionRequirement';
  allowedTiers: Array<ConnectionTier>;
  consumerPitch?: Maybe<Scalars['String']['output']>;
  defaultTier: ConnectionTier;
  integrationId: Scalars['String']['output'];
  reason: ConnectionRequirementReason;
};

/**
 * Why a step needs a fresh connection. Drives the JIT Connect UX copy and
 * the creator's preview-mode fallback (see RFC §3.3 / §3.5).
 */
export enum ConnectionRequirementReason {
  ConsumerWithheld = 'CONSUMER_WITHHELD',
  Expired = 'EXPIRED',
  NoConnection = 'NO_CONNECTION',
  Revoked = 'REVOKED'
}

/**
 * Lifecycle status of a connection row.
 *
 * REVOKED is terminal — reconnecting produces a new row. This matches
 * Composio's "the remote token is actually gone" semantics.
 */
export enum ConnectionStatus {
  Active = 'ACTIVE',
  Disconnected = 'DISCONNECTED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

/**
 * The scope at which an IntegrationConnection is owned.
 *
 * - PLATFORM: owned by Planapus itself (e.g. our OpenRouter key).
 * - ORG: owned by an organization; shared across members.
 * - USER: owned by a single authenticated user Principal.
 * - RUN: ephemeral, bound to a single plan run (e.g. Plaid one-shot).
 */
export enum ConnectionTier {
  Org = 'ORG',
  Platform = 'PLATFORM',
  Run = 'RUN',
  User = 'USER'
}

/** Consent levels for automation execution */
export enum ConsentLevel {
  AllowAlways = 'ALLOW_ALWAYS',
  AllowWithinGuardrails = 'ALLOW_WITHIN_GUARDRAILS',
  RequireApproval = 'REQUIRE_APPROVAL'
}

/** Context requirement output for step analysis */
export type ContextRequirementOutput = {
  __typename?: 'ContextRequirementOutput';
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

/** A conversation thread, either scoped to a plan or global */
export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  messages: Array<ChatMessage>;
  /** Plan ID if scoped to a specific plan, null for global conversations */
  planId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CrawledDocumentRef = {
  __typename?: 'CrawledDocumentRef';
  downloadStatus: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  linkedFromPages: Array<LinkedPageRef>;
  mimeType: Scalars['String']['output'];
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  sourceItemId?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
};

export type CrawledPage = {
  __typename?: 'CrawledPage';
  contentPreview: Scalars['String']['output'];
  crawlId: Scalars['ID']['output'];
  crawledAt: Scalars['String']['output'];
  depth: Scalars['Int']['output'];
  documents: Array<CrawledDocumentRef>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  links: Array<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * Create-time input. `title` is required; everything else defaults at the
 * Airtable side (single-selects keep their column default; dates start empty).
 * Pass `status: "open"` to land the card in the merged Open column, etc.
 */
export type CreateActionItemInput = {
  dueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Input for creating a new intake request. */
export type CreateIntakeRequestInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  mode: IntakeMode;
  planId?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  stepId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Result of creating an intake request. */
export type CreateIntakeRequestResult = {
  __typename?: 'CreateIntakeRequestResult';
  intakeRequest: IntakeRequest;
  publicUrl: Scalars['String']['output'];
};

export type CreateOrganizationBrandProfileInput = {
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  createdFromImportId?: InputMaybe<Scalars['ID']['input']>;
  headerLogoUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
  organizationDisplayName?: InputMaybe<Scalars['String']['input']>;
  palette: BrandPaletteInput;
  provenance?: InputMaybe<Array<Scalars['String']['input']>>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BrandProfileStatus>;
  tone?: InputMaybe<BrandTone>;
};

export type CreatePilotInviteInput = {
  /** Defaults to CUSTOMER when omitted. */
  audience?: InputMaybe<PilotInviteAudience>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlanFromTemplateInput = {
  goal?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new request thread. */
export type CreateRequestThreadInput = {
  accessMode: ThreadAccessMode;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional delegate contact info for sending notification. */
  delegateTo?: InputMaybe<DelegateToInput>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  parentPlanId: Scalars['ID']['input'];
  parentStepId: Scalars['ID']['input'];
  requestSpec: RequestSpecInput;
};

/** Result of creating a request thread. */
export type CreateRequestThreadResult = {
  __typename?: 'CreateRequestThreadResult';
  publicUrl: Scalars['String']['output'];
  requestThread: RequestThread;
};

export type Deadline = {
  __typename?: 'Deadline';
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

/** Input for delegate contact information. */
export type DelegateToInput = {
  /** Email address or phone number */
  contact: Scalars['String']['input'];
  /** Delivery method: 'email' or 'sms' */
  method: Scalars['String']['input'];
};

export type DeleteSourceItemsResult = {
  __typename?: 'DeleteSourceItemsResult';
  blockedItems: Array<BlockedSourceItem>;
  deletedIds: Array<Scalars['ID']['output']>;
};

export type DependencyCitationRef = {
  __typename?: 'DependencyCitationRef';
  guideId: Scalars['ID']['output'];
  stepId: Scalars['ID']['output'];
};

export type DependencyGroupRef = {
  __typename?: 'DependencyGroupRef';
  groupId: Scalars['ID']['output'];
  groupName: Scalars['String']['output'];
};

export type DependencySuggestionRef = {
  __typename?: 'DependencySuggestionRef';
  suggestionId: Scalars['ID']['output'];
  suggestionName: Scalars['String']['output'];
};

/**
 * Result of AI extraction of list items from a step description.
 * Used for on-demand projection of checklist items.
 */
export type DescriptionExtraction = {
  __typename?: 'DescriptionExtraction';
  /** Whether the description contains a checklist (vs instructional prose) */
  hasItems: Scalars['Boolean']['output'];
  /** Extracted list items (empty if hasItems is false) */
  items: Array<Scalars['String']['output']>;
};

export type DocumentGroup = {
  __typename?: 'DocumentGroup';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupType: GroupType;
  id: Scalars['ID']['output'];
  /** The guide linked to this group (if any). Null if no guide has been generated. */
  linkedGuide?: Maybe<GuideLanding>;
  /** Members of this group (resolved from group_memberships). */
  members: Array<GroupMembership>;
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  versionHash: Scalars['String']['output'];
};

export type DocumentGroupWithGuideStatus = {
  __typename?: 'DocumentGroupWithGuideStatus';
  generatedAt?: Maybe<Scalars['String']['output']>;
  group: DocumentGroup;
  isOutOfDate: Scalars['Boolean']['output'];
  linkedGuide?: Maybe<GuideLanding>;
};

/** A finding from domain research */
export type DomainFinding = {
  __typename?: 'DomainFinding';
  confidence: Scalars['Float']['output'];
  details: Array<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export type DomainFindingInput = {
  confidence: Scalars['Float']['input'];
  details: Array<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

/** Research results gathered before plan generation */
export type DomainResearch = {
  __typename?: 'DomainResearch';
  findings: Array<DomainFinding>;
  generatedAt: Scalars['String']['output'];
  searchQueries: Array<Scalars['String']['output']>;
  sources: Array<Scalars['String']['output']>;
};

export type DomainResearchInput = {
  findings: Array<DomainFindingInput>;
  generatedAt: Scalars['String']['input'];
  searchQueries: Array<Scalars['String']['input']>;
  sources: Array<Scalars['String']['input']>;
};

export type DriveFile = {
  __typename?: 'DriveFile';
  iconLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  modifiedTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  webViewLink?: Maybe<Scalars['String']['output']>;
};

/** Effort-weighted progress accounting for item difficulty */
export type EffortWeightedProgress = {
  __typename?: 'EffortWeightedProgress';
  rationale: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

/** Result of enqueueing a job for background processing */
export type EnqueuedJob = {
  __typename?: 'EnqueuedJob';
  /** Unique job ID for tracking */
  jobId: Scalars['ID']['output'];
  /** Type of job that was enqueued */
  jobType: Scalars['String']['output'];
  /** Message to display to user */
  message: Scalars['String']['output'];
  /** Current state of the job */
  state: JobState;
};

export type EvalCaseExpected = {
  __typename?: 'EvalCaseExpected';
  audience: Scalars['String']['output'];
  guideable: Scalars['Boolean']['output'];
  topic: Scalars['String']['output'];
};

export type EvalCaseResult = {
  __typename?: 'EvalCaseResult';
  actual: EvalCaseExpected;
  diffs: Array<Scalars['String']['output']>;
  expected: EvalCaseExpected;
  pass: Scalars['Boolean']['output'];
  sourceItemTitle: Scalars['String']['output'];
  testCaseId: Scalars['String']['output'];
};

export type EvalExpected = {
  __typename?: 'EvalExpected';
  audience: Scalars['String']['output'];
  guideable: Scalars['Boolean']['output'];
  topic: Scalars['String']['output'];
};

export type EvalExpectedInput = {
  audience: Scalars['String']['input'];
  guideable: Scalars['Boolean']['input'];
  topic: Scalars['String']['input'];
};

export type EvalFieldAccuracy = {
  __typename?: 'EvalFieldAccuracy';
  correct: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EvalFieldAccuracyReport = {
  __typename?: 'EvalFieldAccuracyReport';
  audience: EvalFieldAccuracy;
  guideable: EvalFieldAccuracy;
  topic: EvalFieldAccuracy;
};

export type EvalPrompt = {
  __typename?: 'EvalPrompt';
  createdAt?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  lastEvalScore?: Maybe<EvalPromptScore>;
  name: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  prompt: Scalars['String']['output'];
};

export type EvalPromptScore = {
  __typename?: 'EvalPromptScore';
  accuracy: Scalars['Int']['output'];
  guideableAccuracy?: Maybe<Scalars['Int']['output']>;
  passed: Scalars['Int']['output'];
  ranAt: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  weightedScore?: Maybe<Scalars['Int']['output']>;
};

export type EvalReport = {
  __typename?: 'EvalReport';
  baselineReportId?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  fieldAccuracy: EvalFieldAccuracyReport;
  guideableScore: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  overallScore: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
  promptExists: Scalars['Boolean']['output'];
  promptName: Scalars['String']['output'];
  ranAt: Scalars['String']['output'];
  results: Array<EvalCaseResult>;
  totalCases: Scalars['Int']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  weightedScore?: Maybe<Scalars['Int']['output']>;
};

export type EvalReportSummary = {
  __typename?: 'EvalReportSummary';
  failed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  passed: Scalars['Int']['output'];
  promptExists: Scalars['Boolean']['output'];
  promptName: Scalars['String']['output'];
  ranAt: Scalars['String']['output'];
  totalCases: Scalars['Int']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  weightedScore?: Maybe<Scalars['Int']['output']>;
};

export type EvalTestCase = {
  __typename?: 'EvalTestCase';
  addedAt: Scalars['String']['output'];
  addedBy: Scalars['String']['output'];
  documentText?: Maybe<Scalars['String']['output']>;
  expected: EvalExpected;
  id: Scalars['ID']['output'];
  itemType: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  sourceItemId: Scalars['ID']['output'];
  sourceItemTitle: Scalars['String']['output'];
  storagePath?: Maybe<Scalars['String']['output']>;
};

export type ExecuteStepResult = {
  __typename?: 'ExecuteStepResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  planId: Scalars['ID']['output'];
  results: Array<ExecutionResult>;
  status: Scalars['String']['output'];
  stepId: Scalars['ID']['output'];
};

export type ExecutionError = {
  __typename?: 'ExecutionError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  stack?: Maybe<Scalars['String']['output']>;
};

export type ExecutionResult = {
  __typename?: 'ExecutionResult';
  actionId: Scalars['ID']['output'];
  completedAt: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  error?: Maybe<ExecutionError>;
  logs?: Maybe<Array<Scalars['String']['output']>>;
  output?: Maybe<Scalars['JSON']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  startedAt: Scalars['String']['output'];
  status: ExecutionResultStatus;
};

export enum ExecutionResultStatus {
  Failure = 'FAILURE',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  Timeout = 'TIMEOUT'
}

/**
 * Input for expanding a step into a subplan.
 * Creates a new Plan that serves as the execution of this step.
 */
export type ExpandStepInput = {
  planId: Scalars['ID']['input'];
  /**
   * User's prompt describing how they want to break down the step.
   * AI will generate a full plan based on this prompt and the parent plan/step context.
   */
  prompt: Scalars['String']['input'];
  stepId: Scalars['ID']['input'];
};

export type ExtractionMetadata = {
  __typename?: 'ExtractionMetadata';
  audience: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  entities: Array<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  topics: Array<Scalars['String']['output']>;
};

export enum ExtractionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/**
 * Constraint for a plan fact key - defines valid values.
 * Used for deterministic validation of user decisions.
 */
export type FactConstraint = {
  __typename?: 'FactConstraint';
  /** Allowed values for this fact (e.g., ["in_person", "certified_mail"]) */
  allowedValues: Array<Scalars['String']['output']>;
  /** Human-readable description of the decision */
  description?: Maybe<Scalars['String']['output']>;
  /** The fact key (e.g., "delivery_method") */
  key: Scalars['String']['output'];
  /** Whether this constraint is required (must have a valid value to proceed) */
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type FaqBlock = {
  __typename?: 'FaqBlock';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

/** Lightweight guide tile for the featured discovery grid. */
export type FeaturedGuide = {
  __typename?: 'FeaturedGuide';
  id: Scalars['ID']['output'];
  isOfficial: Scalars['Boolean']['output'];
  orgId?: Maybe<Scalars['ID']['output']>;
  orgSlug: Scalars['String']['output'];
  publisherOrgName?: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Signed URL for file upload. */
export type FileUploadUrl = {
  __typename?: 'FileUploadUrl';
  fileId: Scalars['ID']['output'];
  storagePath: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/**
 * Fuzzy context about overall plan progress.
 * Provides high-level visibility without revealing hidden step details.
 */
export type FuzzyPlanContext = {
  __typename?: 'FuzzyPlanContext';
  phases: Array<PhaseContext>;
  totalSteps: Scalars['Int']['output'];
  totals: StatusCounts;
  visibleSteps: Scalars['Int']['output'];
};

export type GenerateGuideFromGroupResult = {
  __typename?: 'GenerateGuideFromGroupResult';
  /** True if an existing guide was returned without creating a job. */
  existingGuide: Scalars['Boolean']['output'];
  /** The background job, if one was created. */
  generationJobId?: Maybe<Scalars['ID']['output']>;
  /** If a guide already exists, it is returned directly (no job created). */
  guide?: Maybe<GuideLanding>;
};

export type GeneratePlanInput = {
  /**
   * Pre-plan analysis result (from analyzePlanGoal query).
   * When provided, the plan will be grounded in research findings.
   */
  analysisResult?: InputMaybe<PlanAnalysisResultInput>;
  /** IDs of temp uploads to commit as plan artifacts when the plan is created. */
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Answers to clarifying questions from the analysis.
   * Keys are question IDs, values are user answers.
   */
  clarifyingAnswers?: InputMaybe<Scalars['JSON']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  prompt: Scalars['String']['input'];
  templateKey?: InputMaybe<Scalars['String']['input']>;
  userContext?: InputMaybe<UserContextInput>;
};

/** Source material used to generate a guide. */
export type GenerationSource = {
  __typename?: 'GenerationSource';
  createdAt: Scalars['String']['output'];
  createdByAccountId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  promptText: Scalars['String']['output'];
  uploadedDocumentIds: Array<Scalars['String']['output']>;
  urls: Array<Scalars['String']['output']>;
};

export enum GenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Idle = 'IDLE'
}

/**
 * A participant's membership in a specific plan.
 * Links a Person to a Plan with role information.
 */
export type GlobalParticipant = {
  __typename?: 'GlobalParticipant';
  accessLevel: ParticipantAccessLevel;
  addedAt: Scalars['String']['output'];
  addedBy: Scalars['String']['output'];
  person: Person;
  role: ParticipantRole;
  roleIds: Array<Scalars['ID']['output']>;
};

/** Goal interpretation from initial analysis */
export type GoalInterpretation = {
  __typename?: 'GoalInterpretation';
  implicitConstraints: Array<Scalars['String']['output']>;
  measurableOutcome: Scalars['String']['output'];
  whatUserWants: Scalars['String']['output'];
};

export type GoalInterpretationInput = {
  implicitConstraints: Array<Scalars['String']['input']>;
  measurableOutcome: Scalars['String']['input'];
  whatUserWants: Scalars['String']['input'];
};

export type GroupMembership = {
  __typename?: 'GroupMembership';
  assignedBy: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The source item (resolved). */
  sourceItem?: Maybe<SourceItem>;
  sourceItemId: Scalars['ID']['output'];
};

export type GroupSuggestion = {
  __typename?: 'GroupSuggestion';
  acceptedGroupId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  rationale: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  scoreBreakdown: ScoreBreakdown;
  sourceItems: Array<SourceItem>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum GroupType {
  Journey = 'JOURNEY',
  Owner = 'OWNER'
}

/** Guardrail for automation safety - defines limits and constraints */
export type Guardrail = {
  __typename?: 'Guardrail';
  config: Scalars['JSON']['output'];
  failureAction: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GuardrailInput = {
  config: Scalars['JSON']['input'];
  failureAction?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export enum GuideBrandMode {
  GuideOverride = 'GUIDE_OVERRIDE',
  ImportProfile = 'IMPORT_PROFILE',
  OrgDefault = 'ORG_DEFAULT'
}

/** Links a piece of guide content back to a source document for traceability. */
export type GuideCitation = {
  __typename?: 'GuideCitation';
  createdAt: Scalars['String']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  guideId: Scalars['ID']['output'];
  guideVersionId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** The source item (resolved). */
  sourceItem?: Maybe<SourceItem>;
  sourceItemId: Scalars['ID']['output'];
  sourceLocator?: Maybe<SourceLocator>;
  stepId: Scalars['ID']['output'];
};

/** Data returned for the Edit Guide page. */
export type GuideEditData = {
  __typename?: 'GuideEditData';
  draftVersion?: Maybe<GuideVersion>;
  generatedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOutOfDate?: Maybe<Scalars['Boolean']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  orgSlug: Scalars['String']['output'];
  publishedVersion?: Maybe<GuideVersion>;
  resolvedTheme: ResolvedGuideTheme;
  slug: Scalars['String']['output'];
  sourceGroupId?: Maybe<Scalars['ID']['output']>;
  theme?: Maybe<GuideTheme>;
  title: Scalars['String']['output'];
};

/** Public guide data for the landing page. */
export type GuideLanding = {
  __typename?: 'GuideLanding';
  applicantRoleId?: Maybe<Scalars['String']['output']>;
  /** Citations linking guide steps back to source documents. */
  citations: Array<GuideCitation>;
  deadlines: Array<Deadline>;
  description: Scalars['String']['output'];
  faqBlocks: Array<FaqBlock>;
  generatedAt?: Maybe<Scalars['String']['output']>;
  generationSourceId?: Maybe<Scalars['ID']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOutOfDate?: Maybe<Scalars['Boolean']['output']>;
  needsOwnerResolution?: Maybe<Scalars['Boolean']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  orgSlug: Scalars['String']['output'];
  ownerGroupId?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  resolvedTheme: ResolvedGuideTheme;
  slug: Scalars['String']['output'];
  sourceGroupId?: Maybe<Scalars['ID']['output']>;
  sourceGroupVersionHash?: Maybe<Scalars['String']['output']>;
  starterRoleId?: Maybe<Scalars['ID']['output']>;
  steps: Array<GuideStep>;
  templatePlanId?: Maybe<Scalars['ID']['output']>;
  theme?: Maybe<GuideTheme>;
  title: Scalars['String']['output'];
};

/** Info about starting a guide — tells frontend if role selection is needed. */
export type GuideStarterInfo = {
  __typename?: 'GuideStarterInfo';
  availableRoles: Array<PlanRole>;
  guideId: Scalars['ID']['output'];
  needsRoleSelection: Scalars['Boolean']['output'];
  preSelectedRoleId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type GuideStep = {
  __typename?: 'GuideStep';
  guideId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GuideTheme = {
  __typename?: 'GuideTheme';
  accessibilityAdjusted?: Maybe<Scalars['Boolean']['output']>;
  brandMode: GuideBrandMode;
  brandProfileId?: Maybe<Scalars['ID']['output']>;
  overrides?: Maybe<GuideThemeOverrides>;
  resolvedFromOrgId?: Maybe<Scalars['ID']['output']>;
  version: Scalars['Int']['output'];
};

export type GuideThemeInput = {
  brandMode: GuideBrandMode;
  brandProfileId?: InputMaybe<Scalars['ID']['input']>;
  overrides?: InputMaybe<GuideThemeOverridesInput>;
};

export type GuideThemeOverrides = {
  __typename?: 'GuideThemeOverrides';
  headerLogoUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  organizationDisplayName?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<BrandTone>;
};

export type GuideThemeOverridesInput = {
  headerLogoUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  organizationDisplayName?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<BrandTone>;
};

/** A versioned snapshot of guide generation inputs and outputs. */
export type GuideVersion = {
  __typename?: 'GuideVersion';
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['String']['output'];
  generatedOutput?: Maybe<GuideVersionOutput>;
  generationError?: Maybe<Scalars['String']['output']>;
  generationFileIds: Array<Scalars['String']['output']>;
  generationFiles: Array<GuideVersionFile>;
  generationPrompt: Scalars['String']['output'];
  generationSourceId?: Maybe<Scalars['ID']['output']>;
  generationStatus: GenerationStatus;
  guideId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  status: GuideVersionStatus;
  versionNumber: Scalars['Int']['output'];
};

/** A file attached to a guide version. */
export type GuideVersionFile = {
  __typename?: 'GuideVersionFile';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
};

/** Generated output stored on a guide version. */
export type GuideVersionOutput = {
  __typename?: 'GuideVersionOutput';
  applicantRoleId?: Maybe<Scalars['String']['output']>;
  deadlines: Array<Deadline>;
  description: Scalars['String']['output'];
  faqBlocks: Array<FaqBlock>;
  hero?: Maybe<Scalars['String']['output']>;
  starterRoleId?: Maybe<Scalars['ID']['output']>;
  steps: Array<GuideStep>;
  templatePlanId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export enum GuideVersionStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Superseded = 'SUPERSEDED'
}

/**
 * Summary of a hidden step (context filler).
 * Does not reveal step ID or title.
 */
export type HiddenStepSummary = {
  __typename?: 'HiddenStepSummary';
  blockedReasonCategory?: Maybe<BlockedReasonCategory>;
  phaseId: Scalars['ID']['output'];
  statusBucket: StatusBucket;
  titleRedacted: Scalars['Boolean']['output'];
};

/** Reference to an uploaded file in Firebase Storage. */
export type IntakeFileRef = {
  __typename?: 'IntakeFileRef';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  storagePath: Scalars['String']['output'];
};

/** Signed URL for file upload. */
export type IntakeFileUploadUrl = {
  __typename?: 'IntakeFileUploadUrl';
  fileId: Scalars['ID']['output'];
  storagePath: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum IntakeMode {
  Prompt = 'PROMPT',
  Schema = 'SCHEMA'
}

/** Public data visible on the intake form (no auth required). */
export type IntakePublicData = {
  __typename?: 'IntakePublicData';
  description?: Maybe<Scalars['String']['output']>;
  hasFreeFormMode: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  status: IntakeStatus;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * An intake request defines what data needs to be collected.
 * Can be created with an explicit schema or from a natural language prompt.
 */
export type IntakeRequest = {
  __typename?: 'IntakeRequest';
  callbackUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mode: IntakeMode;
  planId?: Maybe<Scalars['ID']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  publicUrl: Scalars['String']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
  status: IntakeStatus;
  stepId?: Maybe<Scalars['ID']['output']>;
  submission?: Maybe<IntakeSubmission>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum IntakeStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/**
 * An intake submission is the response from the user.
 * Contains structured data, free-form text, and/or files.
 */
export type IntakeSubmission = {
  __typename?: 'IntakeSubmission';
  createdAt: Scalars['String']['output'];
  fileRefs?: Maybe<Array<IntakeFileRef>>;
  id: Scalars['ID']['output'];
  normalizedResult?: Maybe<Scalars['JSON']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
  structuredDataInput?: Maybe<Scalars['JSON']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

/** Input for submitting an intake response. */
export type IntakeSubmitInput = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rawText?: InputMaybe<Scalars['String']['input']>;
  structuredData?: InputMaybe<Scalars['JSON']['input']>;
};

/** Result of submitting an intake response. */
export type IntakeSubmitResult = {
  __typename?: 'IntakeSubmitResult';
  normalizedResult?: Maybe<Scalars['JSON']['output']>;
  status: IntakeStatus;
  summary?: Maybe<Scalars['String']['output']>;
};

/**
 * A single entry in the integration manifest, projected for the UI catalog.
 * Sourced from `firebase/functions/src/connectors/platform/integrations.yaml`
 * via the catalog loader. Token material and Composio credentials are NEVER
 * exposed here — this is the public-shape view (RFC §7, ADR-0002 M2).
 */
export type IntegrationCatalogEntry = {
  __typename?: 'IntegrationCatalogEntry';
  allowedTiers: Array<ConnectionTier>;
  authType: Scalars['String']['output'];
  capabilities: Array<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  defaultTier: ConnectionTier;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  industries: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

/**
 * A single connection row in the four-tier model.
 *
 * Ownership key is (tier, orgId | principalId | runId); exactly one of
 * those is set per row. `usedByOrgIds` is the ORG→USER fallback audit
 * trail defined in ADR-0002 and RFC §3.3.
 */
export type IntegrationConnection = {
  __typename?: 'IntegrationConnection';
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  lastUsedByRunId?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  principalId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  runId?: Maybe<Scalars['String']['output']>;
  status: ConnectionStatus;
  tier: ConnectionTier;
  updatedAt: Scalars['String']['output'];
  usedByOrgIds: Array<Scalars['String']['output']>;
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  NotSent = 'NOT_SENT',
  Sent = 'SENT'
}

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['String']['output'];
  currentStage: JobStage;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputSnapshot?: Maybe<Scalars['JSON']['output']>;
  inputSummary: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  requestedByUserId: Scalars['String']['output'];
  resultData?: Maybe<Scalars['JSON']['output']>;
  resultRef?: Maybe<Scalars['ID']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
  type: JobType;
};

export type JobEvent = {
  __typename?: 'JobEvent';
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  stage: JobStage;
  timestamp: Scalars['String']['output'];
};

export enum JobStage {
  Analyzing = 'ANALYZING',
  CrawlingPages = 'CRAWLING_PAGES',
  DownloadingDocuments = 'DOWNLOADING_DOCUMENTS',
  FillingStepDetails = 'FILLING_STEP_DETAILS',
  Finalizing = 'FINALIZING',
  GeneratingDraftStructure = 'GENERATING_DRAFT_STRUCTURE',
  GeneratingPrompt = 'GENERATING_PROMPT',
  ImportingDocuments = 'IMPORTING_DOCUMENTS',
  Iterating = 'ITERATING',
  NormalizingAndValidating = 'NORMALIZING_AND_VALIDATING',
  Queued = 'QUEUED',
  RunningBaselineEval = 'RUNNING_BASELINE_EVAL',
  RunningEval = 'RUNNING_EVAL',
  SavingDraft = 'SAVING_DRAFT',
  Summarizing = 'SUMMARIZING',
  UploadingAndParsingFiles = 'UPLOADING_AND_PARSING_FILES',
  ValidatingInputs = 'VALIDATING_INPUTS'
}

/** State of a background job in the queue */
export enum JobState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Waiting = 'WAITING'
}

export enum JobStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export enum JobType {
  Analysis = 'ANALYSIS',
  EvalGenerateAndRun = 'EVAL_GENERATE_AND_RUN',
  EvalIterate = 'EVAL_ITERATE',
  EvalMultiModel = 'EVAL_MULTI_MODEL',
  EvalRerunReport = 'EVAL_RERUN_REPORT',
  EvalRun = 'EVAL_RUN',
  GroupGuideGeneration = 'GROUP_GUIDE_GENERATION',
  GroupSuggestion = 'GROUP_SUGGESTION',
  Guide = 'GUIDE',
  LibraryScan = 'LIBRARY_SCAN',
  Plan = 'PLAN',
  SourceAnalysis = 'SOURCE_ANALYSIS',
  SourceClassification = 'SOURCE_CLASSIFICATION',
  SourceSummarization = 'SOURCE_SUMMARIZATION',
  SourceTextExtraction = 'SOURCE_TEXT_EXTRACTION',
  WebCrawl = 'WEB_CRAWL'
}

/** Result of consuming a journey magic link token. */
export type JourneyMagicLinkConsumption = {
  __typename?: 'JourneyMagicLinkConsumption';
  applicantEmail?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  firebaseToken?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  processTitle?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

/** Result of validating a journey magic link token. */
export type JourneyMagicLinkValidation = {
  __typename?: 'JourneyMagicLinkValidation';
  applicantEmail?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  processTitle?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<JourneyRole>>;
  valid: Scalars['Boolean']['output'];
};

/** A role visible on the journey join page. */
export type JourneyRole = {
  __typename?: 'JourneyRole';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
};

/**
 * Lead capture from the public marketing surface (pilot-planapus.web.app).
 *
 * `captureLead` is intentionally anonymous: there is no caller identity to
 * verify. The resolver MUST NOT call `getUserIdFromContext`. Spam/abuse is
 * mitigated at the resolver layer (honeypot, basic shape validation).
 *
 * Captured leads land in the `leads` Firestore collection. That collection
 * is closed to client reads/writes by Firestore rules — the resolver is the
 * only writer.
 */
export enum LeadSource {
  /** "Email me this report" CTA on the sandbox. */
  EmailGate = 'EMAIL_GATE',
  /** Inline email gate on AI-generated reports. */
  ReportGate = 'REPORT_GATE',
  /** Two-step "Talk to us" modal in the simulator. */
  TalkToUs = 'TALK_TO_US'
}

export type LinkedPageRef = {
  __typename?: 'LinkedPageRef';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Result of requesting a login magic link email */
export type LoginMagicLinkResult = {
  __typename?: 'LoginMagicLinkResult';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Result of login magic link validation or consumption */
export type LoginMagicLinkValidationResult = {
  __typename?: 'LoginMagicLinkValidationResult';
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  firebaseToken?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

/** Result of magic link validation or consumption */
export type MagicLinkValidationResult = {
  __typename?: 'MagicLinkValidationResult';
  error?: Maybe<Scalars['String']['output']>;
  firebaseToken?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['ID']['output']>;
  participantName?: Maybe<Scalars['String']['output']>;
  planGoal?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  valid: Scalars['Boolean']['output'];
};

/** Input for message recipient data */
export type MessageRecipientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  sms?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  /** Accept a suggestion — creates a DocumentGroup + memberships. */
  acceptGroupSuggestion: DocumentGroup;
  /** Acknowledge an automation alert. */
  acknowledgeAlert: Scalars['Boolean']['output'];
  addEvalTestCase: Scalars['Boolean']['output'];
  /**
   * Add a participant to a plan using global identity.
   * Resolves existing person by email/phone or creates new one.
   */
  addGlobalParticipant: GlobalParticipant;
  /** Add a source item to a document group. */
  addGroupMember: GroupMembership;
  /** Add a participant to a plan */
  addParticipant: Plan;
  /** Add a role to a plan */
  addPlanRole: Plan;
  /** Add source items to a document group. */
  addSourceItemsToGroup: Array<GroupMembership>;
  /** Add a guardrail to a step. */
  addStepGuardrail: Plan;
  /**
   * Create a new action item in the Airtable table. Used by the "+" button
   * on each owner row. Returns the created record (with its assigned
   * Airtable id) so the client can insert it without a full refetch.
   */
  adminCreateActionItem: ActionItem;
  adminCreatePilotInvite: PilotInvite;
  adminReactivatePilotInvite: PilotInvite;
  adminRevokePilotInvite: PilotInvite;
  /**
   * Patch an action item. The most common use is moving a card between
   * columns (`status: "in-progress"`). Returns the updated record.
   */
  adminUpdateActionItem: ActionItem;
  adminUpdatePilotInvite: PilotInvite;
  /** Assign a step to a specific participant */
  assignStep: Plan;
  /**
   * Assign a step to a person (global identity version).
   * Also adds the item to the person's inbox.
   */
  assignStepToPerson: Plan;
  /**
   * Assign a step to a role.
   * The step will be automatically assigned to whoever is bound to that role.
   */
  assignStepToRole: Plan;
  /**
   * Bind a participant to a role.
   * All steps with this role's assignedRoleId will be auto-assigned to this person.
   * Also adds items to the person's inbox.
   */
  bindParticipantToRole: Plan;
  /** Cancel an intake request. */
  cancelIntakeRequest: IntakeRequest;
  /** Cancel a queued or running job. */
  cancelJob: StartJobResult;
  /** Cancel a request thread (requires auth, must own parent plan). */
  cancelRequestThread: RequestThread;
  captureLead: CaptureLeadResult;
  /**
   * S10 — claim an anonymous run on signup. Caller must present BOTH
   * a valid Firebase Bearer token (the new UserPrincipal) AND the
   * anonymous JWT inside `anonymousToken`. Atomically:
   *   - marks the AnonymousPrincipal as `claimedBy: <userId>` (NOT
   *     deleted; retained for audit per RFC §4.10)
   *   - rewrites `principalId` on every active RUN-tier connection
   *     bound to that anonymous principal so the new user owns them
   *     going forward
   *   - leaves REVOKED rows alone (audit history stays attached to
   *     the anonymous principal — they were terminal already)
   *
   * Returns the count of RUN connections that were transferred.
   */
  claimAnonymousRun: ClaimAnonymousRunResult;
  /**
   * Claim a preview plan by email. Sends a magic link that logs the user in
   * and gives them access to the preview plan. No authentication required.
   */
  claimPreviewPlan: ClaimPreviewResult;
  /** Classify existing source items by creating a background classification job. */
  classifySourceItems: Job;
  /** Clear conversation history for a plan or global scope */
  clearConversation: Scalars['Boolean']['output'];
  /** Commit temp uploads to the Source Library as SourceItems. */
  commitUploadsToSourceItems: Array<SourceItem>;
  /**
   * Confirm thread satisfaction (public for PUBLIC threads, auth for ASSIGNEE_ONLY).
   * Validates result against output contract and applies to parent step.
   */
  confirmThreadSatisfaction: ConfirmThreadResult;
  /**
   * Consume a journey magic link token and return Firebase auth token.
   * No authentication required.
   */
  consumeJourneyMagicLink: JourneyMagicLinkConsumption;
  /**
   * Consume a login magic link and get Firebase custom token.
   * This is the actual "sign in" action for email-based login - no auth required.
   */
  consumeLoginMagicLink: LoginMagicLinkValidationResult;
  /**
   * Consume a magic link and get Firebase custom token.
   * This is the actual "sign in" action - no auth required.
   */
  consumeMagicLink: MagicLinkValidationResult;
  /**
   * Start a Composio Connect Link session for a new connection at the given
   * tier. PLATFORM is admin-only and rejected here.
   */
  createConnectSession: ConnectSessionResult;
  /** Create a new document group. */
  createDocumentGroup: DocumentGroup;
  /**
   * Create a new intake request.
   * If mode=PROMPT, AI will generate the schema from the prompt.
   */
  createIntakeRequest: CreateIntakeRequestResult;
  createOrganization: Organization;
  createOrganizationBrandProfile: OrganizationBrandProfile;
  /** Create a new plan instance from a template */
  createPlanFromTemplate: Plan;
  /** Create a new request thread (requires auth, must own parent plan). */
  createRequestThread: CreateRequestThreadResult;
  /**
   * Create an intake request for a step (generates shareable public link).
   * Uses the step's description as the prompt to generate a schema.
   */
  createStepIntake: Plan;
  /**
   * Create a request thread for a step (generates shareable public chat link).
   * Uses AI to generate a RequestSpec from the prompt.
   * Returns the created thread with public URL.
   */
  createStepRequestThread: CreateRequestThreadResult;
  /** Delete a document group. Fails if a guide is linked. */
  deleteDocumentGroup: Scalars['Boolean']['output'];
  deleteEvalPrompt: Scalars['Boolean']['output'];
  deleteEvalReport: Scalars['Boolean']['output'];
  deleteEvalTestCase: Scalars['Boolean']['output'];
  /**
   * Delete a guide permanently.
   * Authentication required.
   */
  deleteGuide: Scalars['Boolean']['output'];
  /** Delete a plan */
  deletePlanapusPlan: Scalars['Boolean']['output'];
  /** Delete a single source item. Fails if dependencies exist. */
  deleteSourceItem: Scalars['Boolean']['output'];
  /** Delete multiple source items. Deletes those without dependencies, reports blocked ones. */
  deleteSourceItems: DeleteSourceItemsResult;
  /**
   * Delete a request thread from a step.
   * Removes the thread reference from the step and marks the thread as cancelled.
   */
  deleteStepRequestThread: Plan;
  /**
   * DEV ONLY: Bypass email verification and sign in directly.
   * This mutation ONLY works when running against Firebase emulators.
   * Returns an error in production environments.
   *
   * SECURITY: Enforced on the backend - checks FUNCTIONS_EMULATOR env var.
   */
  devLogin: LoginMagicLinkValidationResult;
  /** Discard a suggestion. */
  discardGroupSuggestion: Scalars['Boolean']['output'];
  discoverBrandFromUrl: BrandDiscoveryResult;
  /**
   * Enqueue all eligible steps for background execution.
   * Returns immediately with a job ID for tracking progress.
   */
  enqueueEligibleStepsExecution: EnqueuedJob;
  /**
   * Enqueue a step for background execution.
   * Returns immediately with a job ID for tracking progress.
   */
  enqueueStepExecution: EnqueuedJob;
  /** Trigger enrichment for a person by email. Returns the updated profile. */
  enrichPerson: PersonProfile;
  /**
   * Execute all eligible automation steps in a plan automatically.
   * Steps are eligible if they are AUTO kind, NOT_STARTED status,
   * have all dependencies met, and pass guardrail checks.
   * @deprecated Use enqueueEligibleStepsExecution for background processing
   */
  executeEligibleSteps: AutoExecuteResult;
  /**
   * Execute all automation actions for a step.
   * Returns execution results for each action.
   * @deprecated Use enqueueStepExecution for background processing
   */
  executeStep: ExecuteStepResult;
  /**
   * Expand a step into a subplan.
   * Creates a new Plan that serves as the execution of this step.
   *
   * The new plan:
   * - Is generated from the prompt using AI (same as generatePlanFromPrompt)
   * - Has context from the parent plan (goal, summary) and step (title, description)
   * - Links back to the parent via parentPlanId and parentStepId
   * - When completed, auto-completes the parent step
   *
   * The parent step's expansionPlanId is set to the new plan's ID.
   */
  expandStepIntoPlan: StartJobResult;
  /** Extract text from existing source items by creating a background extraction job. */
  extractSourceItems: Job;
  generateAndRunEval: Job;
  /** Kick off async suggestion generation. Returns the job. */
  generateGroupSuggestions: Job;
  /**
   * Generate a new guide from a natural language prompt using AI.
   * Authentication required.
   */
  generateGuide: GuideLanding;
  /**
   * Generate a guide from a journey document group.
   * Returns existing guide if one is already linked.
   */
  generateGuideFromGroup: GenerateGuideFromGroupResult;
  /**
   * Generate a plan from a natural language prompt.
   * Uses LangGraph to analyze the goal and create actionable steps with automation.
   */
  generatePlanFromPrompt: Plan;
  /**
   * Generate a lightweight preview outline. No authentication required.
   * Rate-limited to 5 requests per 10 minutes per IP.
   */
  generatePreviewOutline: PreviewPlanResult;
  /**
   * Get a signed upload URL for a file (no auth required, slug-based).
   * Returns a pre-signed URL for direct client-side upload to Firebase Storage.
   */
  getIntakeFileUploadUrl: IntakeFileUploadUrl;
  /**
   * Get a signed upload URL for a file (public for PUBLIC threads).
   * Returns a pre-signed URL for direct client-side upload.
   */
  getThreadFileUploadUrl: FileUploadUrl;
  iterateEval: Job;
  /** Mark a single in-app notification as read. */
  markNotificationRead: Scalars['Boolean']['output'];
  /**
   * Manually override the classification of a source item.
   * Sets classificationStatus to 'completed' so auto-classify skips it.
   */
  overrideSourceItemClassification?: Maybe<SourceItem>;
  /** Toggle step completion as a participant (limited to assigned steps). */
  participantToggleStepCompletion: Plan;
  /** Update step context as a participant (limited to assigned steps). */
  participantUpdateStep: Plan;
  /**
   * Post a message to a thread (public for PUBLIC threads, auth for ASSIGNEE_ONLY).
   * Returns AI response and updated satisfaction state.
   */
  postThreadMessage: PostThreadMessageResult;
  /**
   * Promote a RUN connection to USER at run completion. Guard: the
   * integration's `allowedTiers` must include USER. See RFC §3.3 / D2.
   */
  promoteConnectionToUser: IntegrationConnection;
  promoteOrganizationBrandProfile: OrganizationBrandProfile;
  /**
   * Publish a guide (sets publishedAt to now).
   * Authentication required.
   */
  publishGuide?: Maybe<GuideLanding>;
  /**
   * Publish a completed draft version, replacing the current published version.
   * Authentication required.
   */
  publishGuideDraft: GuideLanding;
  recalculateEvalReports: Scalars['Int']['output'];
  /**
   * Record per-run ORG→USER fallback consent from the consumer.
   * Scope is the run, not the whole account. See RFC §3.3 / ADR-0002.
   */
  recordOrgUserFallbackConsent: Scalars['Boolean']['output'];
  /**
   * Regenerate the draft version output using the AI pipeline.
   * Authentication required.
   */
  regenerateGuideDraft: GuideVersion;
  /**
   * Regenerate a guide from its source group.
   * Updates the draft with fresh content and a new version hash snapshot.
   */
  regenerateGuideFromGroup: GenerateGuideFromGroupResult;
  /**
   * Register a completed connection. Idempotent on (tier, ownerKey,
   * integrationId). Called by the Composio webhook or by the frontend
   * after the Connect popup closes — whichever wins. The server
   * synthesizes composioUserId from the tier and owner (`platform:planapus`,
   * `org:<id>`, `principal:<id>`, `run:<id>`) so the client only needs
   * to supply the Composio connected-account id.
   */
  registerConnection: IntegrationConnection;
  /**
   * Remove a participant from a plan (global identity version).
   * Does not delete the Person, only the plan membership.
   */
  removeGlobalParticipant: Scalars['Boolean']['output'];
  /** Remove a membership from a document group. */
  removeGroupMember: Scalars['Boolean']['output'];
  /** Remove a participant from a plan */
  removeParticipant: Plan;
  /**
   * Remove a role from a plan.
   * Steps assigned to this role will have their assignedRoleId cleared.
   */
  removePlanRole: Plan;
  /** Remove a guardrail from a step. */
  removeStepGuardrail: Plan;
  /** Remove intake from a step (clears intake data). */
  removeStepIntake: Plan;
  renameEvalPrompt: EvalPrompt;
  /**
   * Request a login magic link email (no auth required).
   * Sends an email with a magic link for authentication.
   * Rate limited to 3 per email per day.
   */
  requestLoginMagicLink: LoginMagicLinkResult;
  requestPilotInviteByEmail: RequestPilotInviteByEmailResult;
  rerunEvalCase: EvalReport;
  rerunEvalReport: Job;
  /** Resend invite email to a participant (requires plan ownership). */
  resendParticipantInvite: Plan;
  /**
   * Reset entire plan to initial state (for debugging).
   * Clears all step progress, facts, assessments, intake data, and conversation history.
   */
  resetPlan: Plan;
  /**
   * Reset a step to its initial state (for debugging).
   * Clears context, assessment, intake, and status history.
   */
  resetStep: Plan;
  /** Resubmit the connector request for a blocked step (same payload as original submit). */
  retryConnectorStep: Plan;
  /** Retry a permanently failed (dead letter) job. */
  retryDeadLetterJob?: Maybe<QueueJobStatus>;
  /** Retry a failed or canceled job. Resets it to QUEUED and re-enqueues. */
  retryJob: StartJobResult;
  /** Soft-revoke a connection (terminal). Reconnect creates a new row. */
  revokeConnection: Scalars['Boolean']['output'];
  runEval: Job;
  runMultiModelEval: Job;
  saveEvalPrompt: EvalPrompt;
  /**
   * Save a guide draft version with prompt and attachment IDs.
   * Creates or updates the draft version. Authentication required.
   */
  saveGuideDraft: GuideVersion;
  /** Scan the source library and run extraction/classification on unprocessed items. */
  scanLibrary: Job;
  /** Send a message to the AI assistant and get a response */
  sendChatMessage: SendChatMessageResponse;
  /** Send a message to a recipient via email (SendGrid) or SMS (Twilio) */
  sendMessageToRecipient: SendMessageResult;
  setActiveOrganization: ActiveOrgResult;
  /**
   * Update guide branding mode/profile/overrides.
   * Authentication required.
   */
  setGuideTheme: GuideLanding;
  setOrganizationDefaultBrandProfile: OrganizationBrandProfile;
  startAnalysis: StartJobResult;
  /**
   * S10 / ADR-0004 — start an anonymous principal session for a run.
   *
   * Used by the magic-link consumer flow: someone follows an invite
   * link to a run without a Planapus account, and we mint an
   * `AnonymousPrincipal` bound to that runId plus an HS256 JWT they
   * send back as `X-Anonymous-Token` on subsequent GraphQL requests.
   *
   * Public (no auth required). Anonymous principals can ONLY hold
   * RUN-tier connections — the resolver gates USER/ORG access by
   * principal type.
   *
   * TTL is bounded by `ttlSeconds` (default 14d, capped at 30d) per
   * ADR-0004. Idempotent: if an anonymous principal already exists
   * for the run, we re-issue a token bound to it instead of forking
   * a duplicate.
   */
  startAnonymousRunSession: AnonymousRunSession;
  startGuideGeneration: StartJobResult;
  /**
   * Start a new journey for an applicant.
   * Creates a Plan from the guide template and sends magic link email.
   * No authentication required.
   */
  startJourney: StartJourneyResult;
  startWebCrawl: StartJobResult;
  /**
   * Submit an intake response (no auth required, slug-based).
   * AI will normalize mixed inputs into schema-compliant structured data.
   */
  submitIntake: IntakeSubmitResult;
  /**
   * Public, no-auth lead capture for the /pilot page.
   * Writes to pilot_leads, links to the visitor record, and notifies founders.
   */
  submitPilotLead: PilotLeadResult;
  /**
   * Submit an approval decision for a step that requires approval.
   * If the step has ConsentLevel.REQUIRE_APPROVAL, this records the decision
   * and (if approved) triggers automation execution.
   */
  submitStepApproval: Plan;
  /**
   * Submit intake data inline for a step.
   * Runs AI extraction and applies results to the step.
   */
  submitStepIntakeInline: Plan;
  /** Toggle step completion status with dependency checking */
  toggleStepCompletion: Plan;
  /**
   * Public, no-auth visitor + event tracking endpoint for the /pilot page.
   * Upserts the visitor (merging Apollo/utm params), upserts the session,
   * appends events. Returns the canonical visitor + session IDs.
   */
  trackPilotEvents: TrackPilotEventsResult;
  /**
   * Unbind a participant from a role.
   * Removes auto-assigned inbox items (but not manual overrides).
   */
  unbindParticipantFromRole: Plan;
  /**
   * Unpublish a guide (clears publishedAt).
   * Authentication required.
   */
  unpublishGuide?: Maybe<GuideLanding>;
  /** Update a document group's name or description. */
  updateDocumentGroup: DocumentGroup;
  /** Update notification preferences for the authenticated user. */
  updateNotificationPreferences: NotificationPreferences;
  updateOrganizationBrandProfile: OrganizationBrandProfile;
  /** Update a participant's details */
  updateParticipant: Plan;
  /**
   * Update participant's access level and/or role bindings.
   * Use this to grant/revoke ADMIN access or bind participant to roles.
   */
  updateParticipantAccess: GlobalParticipant;
  /** Update participant's role in a plan. */
  updateParticipantRole: GlobalParticipant;
  /**
   * Update a person's global details.
   * Only allowed by plan owners who have this person in their plans.
   */
  updatePerson: Person;
  /** Update a role in a plan */
  updatePlanRole: Plan;
  /** Update step status manually (Planapus version) */
  updatePlanapusStepStatus: Plan;
  /** Update step consent level for automation. */
  updateStepConsentLevel: Plan;
  /** Update step context (notes, links) for partial completion */
  updateStepContext: Plan;
  /**
   * Update thread fields directly via form (public for PUBLIC threads, auth for ASSIGNEE_ONLY).
   * Validates fields against outputContract and updates satisfaction state.
   * Does NOT invoke LLM - fields are validated and merged directly.
   */
  updateThreadFields: UpdateThreadFieldsResult;
  validatePilotInvite: ValidatePilotInviteResult;
};


export type MutationAcceptGroupSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationAcknowledgeAlertArgs = {
  alertId: Scalars['ID']['input'];
};


export type MutationAddEvalTestCaseArgs = {
  expected: EvalExpectedInput;
  orgId: Scalars['ID']['input'];
  sourceItemId: Scalars['ID']['input'];
};


export type MutationAddGlobalParticipantArgs = {
  input: AddGlobalParticipantInput;
};


export type MutationAddGroupMemberArgs = {
  assignedBy: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  sourceItemId: Scalars['ID']['input'];
};


export type MutationAddParticipantArgs = {
  participant: ParticipantInput;
  planId: Scalars['ID']['input'];
};


export type MutationAddPlanRoleArgs = {
  planId: Scalars['ID']['input'];
  role: PlanRoleInput;
};


export type MutationAddSourceItemsToGroupArgs = {
  assignedBy: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  sourceItemIds: Array<Scalars['ID']['input']>;
};


export type MutationAddStepGuardrailArgs = {
  guardrail: GuardrailInput;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationAdminCreateActionItemArgs = {
  input: CreateActionItemInput;
};


export type MutationAdminCreatePilotInviteArgs = {
  input: CreatePilotInviteInput;
};


export type MutationAdminReactivatePilotInviteArgs = {
  code: Scalars['ID']['input'];
};


export type MutationAdminRevokePilotInviteArgs = {
  code: Scalars['ID']['input'];
};


export type MutationAdminUpdateActionItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateActionItemInput;
};


export type MutationAdminUpdatePilotInviteArgs = {
  code: Scalars['ID']['input'];
  input: UpdatePilotInviteInput;
};


export type MutationAssignStepArgs = {
  participantId?: InputMaybe<Scalars['ID']['input']>;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationAssignStepToPersonArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationAssignStepToRoleArgs = {
  planId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};


export type MutationBindParticipantToRoleArgs = {
  personId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationCancelIntakeRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCancelRequestThreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCaptureLeadArgs = {
  input: CaptureLeadInput;
};


export type MutationClaimAnonymousRunArgs = {
  anonymousToken: Scalars['String']['input'];
};


export type MutationClaimPreviewPlanArgs = {
  email: Scalars['String']['input'];
  previewPlanId: Scalars['ID']['input'];
};


export type MutationClassifySourceItemsArgs = {
  orgId: Scalars['ID']['input'];
  sourceItemIds: Array<Scalars['ID']['input']>;
};


export type MutationClearConversationArgs = {
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCommitUploadsToSourceItemsArgs = {
  orgId: Scalars['ID']['input'];
  tempUploadIds: Array<Scalars['ID']['input']>;
};


export type MutationConfirmThreadSatisfactionArgs = {
  slug: Scalars['String']['input'];
};


export type MutationConsumeJourneyMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationConsumeLoginMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationConsumeMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationCreateConnectSessionArgs = {
  integrationId: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  tier: ConnectionTier;
};


export type MutationCreateDocumentGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupType: GroupType;
  name: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationCreateIntakeRequestArgs = {
  input: CreateIntakeRequestInput;
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrganizationBrandProfileArgs = {
  input: CreateOrganizationBrandProfileInput;
};


export type MutationCreatePlanFromTemplateArgs = {
  overrides?: InputMaybe<CreatePlanFromTemplateInput>;
  templateId: Scalars['ID']['input'];
};


export type MutationCreateRequestThreadArgs = {
  input: CreateRequestThreadInput;
};


export type MutationCreateStepIntakeArgs = {
  planId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  stepId: Scalars['ID']['input'];
};


export type MutationCreateStepRequestThreadArgs = {
  planId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['ID']['input'];
};


export type MutationDeleteDocumentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEvalPromptArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteEvalReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEvalTestCaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGuideArgs = {
  guideId: Scalars['ID']['input'];
};


export type MutationDeletePlanapusPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSourceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSourceItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteStepRequestThreadArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type MutationDevLoginArgs = {
  email: Scalars['String']['input'];
};


export type MutationDiscardGroupSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationDiscoverBrandFromUrlArgs = {
  input: BrandDiscoveryInput;
};


export type MutationEnqueueEligibleStepsExecutionArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationEnqueueStepExecutionArgs = {
  cascade?: InputMaybe<Scalars['Boolean']['input']>;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationEnrichPersonArgs = {
  email: Scalars['String']['input'];
};


export type MutationExecuteEligibleStepsArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationExecuteStepArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationExpandStepIntoPlanArgs = {
  input: ExpandStepInput;
};


export type MutationExtractSourceItemsArgs = {
  orgId: Scalars['ID']['input'];
  sourceItemIds: Array<Scalars['ID']['input']>;
};


export type MutationGenerateAndRunEvalArgs = {
  modelName?: InputMaybe<Scalars['String']['input']>;
  promptName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateGroupSuggestionsArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationGenerateGuideArgs = {
  orgSlug?: InputMaybe<Scalars['String']['input']>;
  planInput?: InputMaybe<GeneratePlanInput>;
  prompt: Scalars['String']['input'];
};


export type MutationGenerateGuideFromGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type MutationGeneratePlanFromPromptArgs = {
  input: GeneratePlanInput;
};


export type MutationGeneratePreviewOutlineArgs = {
  prompt: Scalars['String']['input'];
};


export type MutationGetIntakeFileUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationGetThreadFileUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationIterateEvalArgs = {
  evalModelName: Scalars['String']['input'];
  generationModelNames: Array<Scalars['String']['input']>;
  iterations: Scalars['Int']['input'];
  promptName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkNotificationReadArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationOverrideSourceItemClassificationArgs = {
  id: Scalars['ID']['input'];
  isProcess: Scalars['Boolean']['input'];
};


export type MutationParticipantToggleStepCompletionArgs = {
  completed: Scalars['Boolean']['input'];
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationParticipantUpdateStepArgs = {
  context: StepContextInput;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationPostThreadMessageArgs = {
  input: PostThreadMessageInput;
  slug: Scalars['String']['input'];
};


export type MutationPromoteConnectionToUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPromoteOrganizationBrandProfileArgs = {
  input: PromoteOrganizationBrandProfileInput;
};


export type MutationPublishGuideArgs = {
  guideId: Scalars['ID']['input'];
};


export type MutationPublishGuideDraftArgs = {
  guideId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationRecordOrgUserFallbackConsentArgs = {
  approvedIntegrationIds: Array<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};


export type MutationRegenerateGuideDraftArgs = {
  guideId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationRegenerateGuideFromGroupArgs = {
  guideId: Scalars['ID']['input'];
};


export type MutationRegisterConnectionArgs = {
  composioConnectedAccountId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  tier: ConnectionTier;
};


export type MutationRemoveGlobalParticipantArgs = {
  personId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};


export type MutationRemoveGroupMemberArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationRemoveParticipantArgs = {
  participantId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};


export type MutationRemovePlanRoleArgs = {
  planId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationRemoveStepGuardrailArgs = {
  guardrailId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationRemoveStepIntakeArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationRenameEvalPromptArgs = {
  newName: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};


export type MutationRequestLoginMagicLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestPilotInviteByEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRerunEvalCaseArgs = {
  reportId: Scalars['String']['input'];
  testCaseId: Scalars['String']['input'];
};


export type MutationRerunEvalReportArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationResendParticipantInviteArgs = {
  participantId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};


export type MutationResetPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationResetStepArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationRetryConnectorStepArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationRetryDeadLetterJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationRetryJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationRevokeConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRunEvalArgs = {
  modelName?: InputMaybe<Scalars['String']['input']>;
  promptName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRunMultiModelEvalArgs = {
  modelNames: Array<Scalars['String']['input']>;
  promptName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveEvalPromptArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
};


export type MutationSaveGuideDraftArgs = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  guideId: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationScanLibraryArgs = {
  modelName?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  promptName?: InputMaybe<Scalars['String']['input']>;
  resetStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  resetTasks?: InputMaybe<Array<Scalars['String']['input']>>;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
  sourceItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendMessageToRecipientArgs = {
  input: SendMessageToRecipientInput;
};


export type MutationSetActiveOrganizationArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationSetGuideThemeArgs = {
  guideId: Scalars['ID']['input'];
  input: GuideThemeInput;
};


export type MutationSetOrganizationDefaultBrandProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type MutationStartAnalysisArgs = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  prompt: Scalars['String']['input'];
};


export type MutationStartAnonymousRunSessionArgs = {
  runId: Scalars['ID']['input'];
  ttlSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationStartGuideGenerationArgs = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orgSlug: Scalars['String']['input'];
  planInput?: InputMaybe<GeneratePlanInput>;
  prompt: Scalars['String']['input'];
};


export type MutationStartJourneyArgs = {
  additionalRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  applicantEmail: Scalars['String']['input'];
  guideSlug: Scalars['String']['input'];
  orgSlug: Scalars['String']['input'];
  starterRoleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationStartWebCrawlArgs = {
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  maxPages?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  seedUrl: Scalars['String']['input'];
  skipClassification?: InputMaybe<Scalars['Boolean']['input']>;
  skipExistingUrls?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubmitIntakeArgs = {
  input: IntakeSubmitInput;
  slug: Scalars['String']['input'];
};


export type MutationSubmitPilotLeadArgs = {
  input: PilotLeadInput;
};


export type MutationSubmitStepApprovalArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  decision: ApprovalDecision;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationSubmitStepIntakeInlineArgs = {
  input: IntakeSubmitInput;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationToggleStepCompletionArgs = {
  completed: Scalars['Boolean']['input'];
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationTrackPilotEventsArgs = {
  events: Array<PilotEventInput>;
  identify?: InputMaybe<PilotVisitorIdentifyInput>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  visitorId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnbindParticipantFromRoleArgs = {
  planId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationUnpublishGuideArgs = {
  guideId: Scalars['ID']['input'];
};


export type MutationUpdateDocumentGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNotificationPreferencesArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  digestFrequency?: InputMaybe<Scalars['String']['input']>;
  quietHoursEnd?: InputMaybe<Scalars['String']['input']>;
  quietHoursStart?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrganizationBrandProfileArgs = {
  input: UpdateOrganizationBrandProfileInput;
};


export type MutationUpdateParticipantArgs = {
  participantId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  updates: UpdateParticipantInput;
};


export type MutationUpdateParticipantAccessArgs = {
  accessLevel?: InputMaybe<ParticipantAccessLevel>;
  personId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateParticipantRoleArgs = {
  personId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  role: ParticipantRole;
};


export type MutationUpdatePersonArgs = {
  personId: Scalars['ID']['input'];
  updates: UpdatePersonInput;
};


export type MutationUpdatePlanRoleArgs = {
  planId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  updates: UpdatePlanRoleInput;
};


export type MutationUpdatePlanapusStepStatusArgs = {
  planId: Scalars['ID']['input'];
  status: StepStatus;
  stepId: Scalars['ID']['input'];
};


export type MutationUpdateStepConsentLevelArgs = {
  consentLevel: ConsentLevel;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationUpdateStepContextArgs = {
  context: StepContextInput;
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationUpdateThreadFieldsArgs = {
  input: UpdateThreadFieldsInput;
  slug: Scalars['String']['input'];
};


export type MutationValidatePilotInviteArgs = {
  code: Scalars['ID']['input'];
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  channels: Array<Scalars['String']['output']>;
  digestFrequency: Scalars['String']['output'];
  quietHoursEnd?: Maybe<Scalars['String']['output']>;
  quietHoursStart?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OpenRouterModelPricing = {
  __typename?: 'OpenRouterModelPricing';
  contextLength?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  inputPer1M: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  outputPer1M: Scalars['Float']['output'];
};

/**
 * Selected scenario + scripted values from Widget #1 (Operations Simulator).
 * Captured when a visitor books the executive walkthrough after a reveal.
 */
export type OperationsSimulatorPayloadInput = {
  coordinationCost?: InputMaybe<Scalars['String']['input']>;
  cycleTime?: InputMaybe<Scalars['String']['input']>;
  exceptionRate?: InputMaybe<Scalars['String']['input']>;
  scenarioId: Scalars['String']['input'];
  scenarioLabel: Scalars['String']['input'];
  volume?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Metadata-only audit row for Org Admins. Deliberately omits tokens,
 * composioConnectedAccountId, and any proxy handle (see M2 in RFC §9 and
 * ADR-0002).
 */
export type OrgAuditEntry = {
  __typename?: 'OrgAuditEntry';
  createdAt: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  lastUsedByRunId?: Maybe<Scalars['String']['output']>;
  principalId: Scalars['String']['output'];
  tier: ConnectionTier;
};

export type Organization = {
  __typename?: 'Organization';
  branding?: Maybe<OrganizationBrandingSettings>;
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBrandProfile = {
  __typename?: 'OrganizationBrandProfile';
  approvedBy?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  createdFromImportId?: Maybe<Scalars['ID']['output']>;
  headerLogoUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importedAssetRefs: Array<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  organizationDisplayName?: Maybe<Scalars['String']['output']>;
  palette: BrandPalette;
  provenance: Array<Scalars['String']['output']>;
  status: BrandProfileStatus;
  tone?: Maybe<BrandTone>;
  updatedAt: Scalars['String']['output'];
};

export type OrganizationBrandingSettings = {
  __typename?: 'OrganizationBrandingSettings';
  allowedProfileIds: Array<Scalars['ID']['output']>;
  defaultBrandProfileId?: Maybe<Scalars['ID']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * SECURITY CRITICAL: Output contract enforcement.
 * Only keys in allowedKeys can cross to parent.
 */
export type OutputContract = {
  __typename?: 'OutputContract';
  allowedKeys: Array<Scalars['String']['output']>;
  maxSizeBytes?: Maybe<Scalars['Int']['output']>;
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** Input for output contract. */
export type OutputContractInput = {
  allowedKeys: Array<Scalars['String']['input']>;
  maxSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * A participant is a person involved in executing a plan.
 * Can be the plan owner, a partner, a professional, or any other stakeholder.
 * @deprecated Use GlobalParticipant with Person for new code
 */
export type Participant = {
  __typename?: 'Participant';
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firebaseUid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteSentAt?: Maybe<Scalars['String']['output']>;
  inviteStatus?: Maybe<InviteStatus>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Access level for plan visibility */
export enum ParticipantAccessLevel {
  /** Full plan visibility - sees all steps */
  Admin = 'ADMIN',
  /** Limited visibility - only sees steps assigned to them via role or direct override */
  RoleMember = 'ROLE_MEMBER'
}

export type ParticipantInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Role of a participant in a plan */
export enum ParticipantRole {
  Collaborator = 'COLLABORATOR',
  Delegate = 'DELEGATE',
  Owner = 'OWNER'
}

/**
 * Simplified step representation for participant workspace.
 * Contains only the information needed for task execution.
 */
export type ParticipantStep = {
  __typename?: 'ParticipantStep';
  assignedViaRole?: Maybe<Scalars['String']['output']>;
  blocked: StepBlockedInfo;
  context?: Maybe<StepContext>;
  description?: Maybe<Scalars['String']['output']>;
  phaseLabel?: Maybe<Scalars['String']['output']>;
  status: StepStatus;
  stepId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Participant workspace view - a focused, single-screen experience for ROLE_MEMBER users.
 * Contains only the participant's assigned tasks and fuzzy context about overall progress.
 */
export type ParticipantWorkspaceView = {
  __typename?: 'ParticipantWorkspaceView';
  fuzzyContext: FuzzyPlanContext;
  mySteps: Array<ParticipantStep>;
  planId: Scalars['ID']['output'];
  planStatus: PlanStatus;
  planSummary: Scalars['String']['output'];
  planTitle: Scalars['String']['output'];
  roles: Array<WorkspaceRole>;
  updatedAt: Scalars['String']['output'];
  viewerPersonId: Scalars['ID']['output'];
  viewerRoleIds: Array<Scalars['ID']['output']>;
};

/**
 * A person with global identity across plans.
 * Identified by email or phone number.
 */
export type Person = {
  __typename?: 'Person';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type PersonProfile = {
  __typename?: 'PersonProfile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enrichedAt: Scalars['String']['output'];
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sources: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Phase context with aggregated counts. */
export type PhaseContext = {
  __typename?: 'PhaseContext';
  counts: StatusCounts;
  phaseId: Scalars['ID']['output'];
  phaseLabel: Scalars['String']['output'];
};

export type PhaseProgress = {
  __typename?: 'PhaseProgress';
  blockedSteps: Scalars['Int']['output'];
  completedSteps: Scalars['Int']['output'];
  inProgressSteps: Scalars['Int']['output'];
  percentComplete: Scalars['Float']['output'];
  phaseId: Scalars['ID']['output'];
  totalSteps: Scalars['Int']['output'];
};

/**
 * Aggregate summary of a phase.
 * Shows counts without revealing individual step details.
 */
export type PhaseSummary = {
  __typename?: 'PhaseSummary';
  countByStatusBucket: StatusBucketCounts;
  hiddenSteps: Scalars['Int']['output'];
  phaseId: Scalars['ID']['output'];
  phaseLabel: Scalars['String']['output'];
  totalSteps: Scalars['Int']['output'];
  visibleSteps: Scalars['Int']['output'];
};

export type PilotBreakdownPoint = {
  __typename?: 'PilotBreakdownPoint';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type PilotDashboardOverview = {
  __typename?: 'PilotDashboardOverview';
  campaignBreakdown: Array<PilotBreakdownPoint>;
  funnel: Array<PilotFunnelStage>;
  kpi: PilotKpiTile;
  sourceBreakdown: Array<PilotBreakdownPoint>;
  timeSeries: Array<PilotTimeSeriesPoint>;
};

export type PilotDateRangeInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type PilotEvent = {
  __typename?: 'PilotEvent';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  occurredAt: Scalars['String']['output'];
  payload?: Maybe<Scalars['JSONObject']['output']>;
  sessionId: Scalars['ID']['output'];
  visitorId: Scalars['ID']['output'];
};

/**
 * A single engagement event emitted by the page.
 * `name` is a free-form string; payload is arbitrary JSON.
 */
export type PilotEventInput = {
  name: Scalars['String']['input'];
  occurredAt: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type PilotFunnelStage = {
  __typename?: 'PilotFunnelStage';
  count: Scalars['Int']['output'];
  stage: PilotVisitorStage;
};

export type PilotInvite = {
  __typename?: 'PilotInvite';
  audience: PilotInviteAudience;
  /** The invite code IS the access token. Doc id in `pilot_invites/{code}`. */
  code: Scalars['ID']['output'];
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['String']['output']>;
  status: PilotInviteStatus;
  /** Fully-qualified URL the invitee opens (built server-side from PILOT_BASE_URL). */
  url: Scalars['String']['output'];
  useCount: Scalars['Int']['output'];
};

/**
 * Which surfaces the invite grants access to. CUSTOMER sees Story + Sandbox
 * (the working pilot). VC sees the Pitch deck only. Default: CUSTOMER.
 * Existing pre-audience invites are treated as CUSTOMER.
 */
export enum PilotInviteAudience {
  Customer = 'CUSTOMER',
  Vc = 'VC'
}

/**
 * Pilot access — invite-based gating for pilot.planapus.com.
 *
 * `validatePilotInvite` and `requestPilotInviteByEmail` are anonymous on purpose (a
 * visitor doesn't have a Planapus account yet). All `admin*` operations
 * require an `X-Admin-Token` header matching PLANAPUS_ADMIN_TOKEN. There
 * is no per-admin identity in v1 — three founders share the secret.
 */
export enum PilotInviteStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export type PilotKpiTile = {
  __typename?: 'PilotKpiTile';
  conversionRate: Scalars['Float']['output'];
  events: Scalars['Int']['output'];
  identifiedVisitors: Scalars['Int']['output'];
  leads: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

/**
 * Admin view of a pilot lead with linked visitor info.
 * Distinct from the public PilotLeadResult — exposes the full record.
 */
export type PilotLeadAdmin = {
  __typename?: 'PilotLeadAdmin';
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: PilotLeadKind;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  roiPayload?: Maybe<Scalars['JSONObject']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  simPayload?: Maybe<Scalars['JSONObject']['output']>;
  visitorId?: Maybe<Scalars['String']['output']>;
};

/**
 * Form fields collected by the pilot's lead CTAs. Visitor identity (when
 * available from Apollo URL params) is read separately from the visitor
 * record.
 *
 * `linkedin` / `ops` / `opsOther` / `goals` / `stack` are first-class
 * structured fields — they used to be packed into the freeform `notes`
 * blob client-side (lead-api.js packNotes), which made them unreadable by
 * the admin console and the Apollo CRM write-back. `notes` now carries
 * only genuinely freeform residual context (e.g. the visitor's intake
 * org profile).
 */
export type PilotLeadInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Scalars['String']['input']>;
  kind: PilotLeadKind;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ops?: InputMaybe<Array<Scalars['String']['input']>>;
  opsOther?: InputMaybe<Scalars['String']['input']>;
  roiPayload?: InputMaybe<RoiCalculatorPayloadInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  simPayload?: InputMaybe<OperationsSimulatorPayloadInput>;
  stack?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export enum PilotLeadKind {
  ExecWalkthrough = 'EXEC_WALKTHROUGH',
  FounderChat = 'FOUNDER_CHAT',
  OpsSimResult = 'OPS_SIM_RESULT',
  PilotApplication = 'PILOT_APPLICATION',
  RoiEmail = 'ROI_EMAIL'
}

export type PilotLeadResult = {
  __typename?: 'PilotLeadResult';
  leadId: Scalars['ID']['output'];
  ok: Scalars['Boolean']['output'];
};

export type PilotSession = {
  __typename?: 'PilotSession';
  eventCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastActiveAt: Scalars['String']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  visitorId: Scalars['ID']['output'];
};

export enum PilotSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PilotTimeSeriesPoint = {
  __typename?: 'PilotTimeSeriesPoint';
  date: Scalars['String']['output'];
  leads: Scalars['Int']['output'];
  visits: Scalars['Int']['output'];
};

export type PilotVisitor = {
  __typename?: 'PilotVisitor';
  attribution: PilotVisitorAttribution;
  eventCount: Scalars['Int']['output'];
  events: Array<PilotEvent>;
  firstSeenAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifiedAt?: Maybe<Scalars['String']['output']>;
  identity: PilotVisitorIdentity;
  lastSeenAt: Scalars['String']['output'];
  leadCount: Scalars['Int']['output'];
  leads: Array<PilotLeadAdmin>;
  rawParams?: Maybe<Scalars['JSONObject']['output']>;
  sessionCount: Scalars['Int']['output'];
  sessions: Array<PilotSession>;
  stage: PilotVisitorStage;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type PilotVisitorAttribution = {
  __typename?: 'PilotVisitorAttribution';
  apolloCampaignId?: Maybe<Scalars['String']['output']>;
  apolloContactId?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type PilotVisitorFilterInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<PilotVisitorStage>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Identity captured from Apollo / utm URL params on visit.
 * All fields optional; merged into the visitor record across visits.
 */
export type PilotVisitorIdentifyInput = {
  apolloCampaignId?: InputMaybe<Scalars['String']['input']>;
  apolloContactId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rawParams?: InputMaybe<Scalars['JSONObject']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type PilotVisitorIdentity = {
  __typename?: 'PilotVisitorIdentity';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PilotVisitorListResult = {
  __typename?: 'PilotVisitorListResult';
  hasMore: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  visitors: Array<PilotVisitor>;
};

export enum PilotVisitorSortField {
  EventCount = 'EVENT_COUNT',
  FirstSeen = 'FIRST_SEEN',
  LastSeen = 'LAST_SEEN',
  LeadCount = 'LEAD_COUNT'
}

export type PilotVisitorSortInput = {
  direction: PilotSortDirection;
  field: PilotVisitorSortField;
};

export enum PilotVisitorStage {
  EngagedCalculator = 'ENGAGED_CALCULATOR',
  EngagedSimulator = 'ENGAGED_SIMULATOR',
  OpenedDialog = 'OPENED_DIALOG',
  SubmittedLead = 'SUBMITTED_LEAD',
  Visited = 'VISITED'
}

export type Plan = {
  __typename?: 'Plan';
  artifacts?: Maybe<Array<PlanArtifact>>;
  createdAt: Scalars['String']['output'];
  derivedFromTemplateId?: Maybe<Scalars['ID']['output']>;
  evaluation?: Maybe<PlanEvaluation>;
  factConstraints?: Maybe<Array<FactConstraint>>;
  facts?: Maybe<Scalars['JSON']['output']>;
  generationSourceId?: Maybe<Scalars['ID']['output']>;
  goal: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  originalPrompt?: Maybe<Scalars['String']['output']>;
  parentPlanId?: Maybe<Scalars['ID']['output']>;
  parentStepId?: Maybe<Scalars['ID']['output']>;
  participants: Array<Participant>;
  pendingGenerationJobId?: Maybe<Scalars['ID']['output']>;
  phases: Array<PlanPhase>;
  roles: Array<PlanRole>;
  sourceGuideId?: Maybe<Scalars['ID']['output']>;
  status: PlanStatus;
  steps: Array<PlanStep>;
  suggestedSaaS?: Maybe<SuggestedSaaS>;
  summary: Scalars['String']['output'];
  templateKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Result of pre-plan analysis including research and clarifying questions */
export type PlanAnalysisResult = {
  __typename?: 'PlanAnalysisResult';
  clarifyingQuestions: Array<ClarifyingQuestion>;
  domainResearch: DomainResearch;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  goalInterpretation: GoalInterpretation;
  originalPrompt: Scalars['String']['output'];
  readyToGenerate: Scalars['Boolean']['output'];
};

/** Input version of analysis result for passing back to plan generation */
export type PlanAnalysisResultInput = {
  clarifyingQuestions: Array<ClarifyingQuestionInput>;
  domainResearch: DomainResearchInput;
  goalInterpretation: GoalInterpretationInput;
  originalPrompt: Scalars['String']['input'];
  readyToGenerate: Scalars['Boolean']['input'];
};

/**
 * A file artifact attached to a plan (image, document, spreadsheet).
 * Created when temp uploads are committed during plan generation.
 */
export type PlanArtifact = {
  __typename?: 'PlanArtifact';
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  planId: Scalars['ID']['output'];
  sizeBytes: Scalars['Int']['output'];
  storagePath: Scalars['String']['output'];
};

export type PlanEvaluation = {
  __typename?: 'PlanEvaluation';
  blockedStepIds: Array<Scalars['ID']['output']>;
  blockedSteps: Scalars['Int']['output'];
  completedSteps: Scalars['Int']['output'];
  evaluatedAt: Scalars['String']['output'];
  inProgressSteps: Scalars['Int']['output'];
  percentComplete: Scalars['Float']['output'];
  phaseProgress: Array<PhaseProgress>;
  readyToStartStepIds: Array<Scalars['ID']['output']>;
  totalSteps: Scalars['Int']['output'];
};

export type PlanEvent = {
  __typename?: 'PlanEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  planId: Scalars['ID']['output'];
  stepId?: Maybe<Scalars['ID']['output']>;
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * Lightweight plan summary with viewer's access level for that specific plan.
 * Used in plan list views where a user may be ADMIN in some plans and ROLE_MEMBER in others.
 *
 * Authorization note: Access is per-(planId, personId) scoped.
 * A person who is ADMIN in Plan A may be ROLE_MEMBER in Plan B.
 */
export type PlanListItem = {
  __typename?: 'PlanListItem';
  /** Human-readable label for UI display (e.g., 'Owner', 'Admin', 'Participant') */
  accessLabel: Scalars['String']['output'];
  /** Viewer's access level for THIS plan (ADMIN or ROLE_MEMBER) */
  accessLevel: ParticipantAccessLevel;
  /** Plan creation timestamp */
  createdAt: Scalars['String']['output'];
  /** Plan goal/title */
  goal: Scalars['String']['output'];
  /** Plan ID */
  id: Scalars['ID']['output'];
  /** Whether viewer is the plan owner */
  isOwner: Scalars['Boolean']['output'];
  /** Progress percentage (completed/total visible steps) */
  progressPercent: Scalars['Float']['output'];
  /** Plan status */
  status: PlanStatus;
  /** Plan summary (safe to show) */
  summary: Scalars['String']['output'];
  /** Count of total steps in the plan */
  totalStepCount: Scalars['Int']['output'];
  /** Plan last update timestamp */
  updatedAt: Scalars['String']['output'];
  /** Count of visible steps for the viewer */
  visibleStepCount: Scalars['Int']['output'];
};

export type PlanPhase = {
  __typename?: 'PlanPhase';
  description?: Maybe<Scalars['String']['output']>;
  estimatedDurationDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/**
 * A role represents a category of responsibility in a plan.
 * Roles are assigned to steps; participants are bound to roles.
 * Examples: "Customer", "CPA", "Attorney", "Contractor"
 */
export type PlanRole = {
  __typename?: 'PlanRole';
  /** Resolved email of the person assigned to this role (computed field). */
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  /** Resolved name of the person assigned to this role (computed field). */
  assigneeName?: Maybe<Scalars['String']['output']>;
  /** IDs of other roles that someone filling this role can also fill. */
  canFillRoleIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * The person currently bound to this role.
   * All steps with this role's assignedRoleId will be auto-assigned to this person.
   */
  defaultAssigneePersonId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this role is restricted (e.g., internal reviewer, admin).
   * Restricted roles are hidden from non-owner guide starters.
   */
  isRestricted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Whether the plan requires someone to fill this role before execution. */
  required: Scalars['Boolean']['output'];
  roleId: Scalars['ID']['output'];
};

export type PlanRoleInput = {
  canFillRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PlanStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  /**
   * Plan is being generated by AI in the background. No steps/phases are populated yet.
   * Transitions to ACTIVE once generation completes.
   */
  Generating = 'GENERATING'
}

export type PlanStep = {
  __typename?: 'PlanStep';
  actions?: Maybe<Array<AutomationAction>>;
  allowedFields?: Maybe<Array<StepAllowedField>>;
  applicability?: Maybe<StepApplicability>;
  approvalRecords?: Maybe<Array<ApprovalRecord>>;
  assessment?: Maybe<StepAssessment>;
  assignedRoleId?: Maybe<Scalars['ID']['output']>;
  assignedToId?: Maybe<Scalars['ID']['output']>;
  capabilities?: Maybe<StepCapabilities>;
  /**
   * Populated when `status = BLOCKED` and `statusReason` is connection-related.
   * Carries enough metadata for the UI to render the JIT Connect card without
   * issuing a side query (see RFC §3.1 / §3.3).
   */
  connectionRequirement?: Maybe<ConnectionRequirement>;
  consentLevel?: Maybe<ConsentLevel>;
  context?: Maybe<StepContext>;
  dependencyStatus?: Maybe<StepDependencyStatus>;
  dependsOn: Array<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  estimatedDurationDays?: Maybe<Scalars['Int']['output']>;
  executionResults?: Maybe<Array<ExecutionResult>>;
  expansionPlanId?: Maybe<Scalars['ID']['output']>;
  guardrails?: Maybe<Array<Guardrail>>;
  id: Scalars['ID']['output'];
  inferredRequirements?: Maybe<Array<RequiredItem>>;
  intake?: Maybe<StepIntakeData>;
  intent?: Maybe<StepIntent>;
  kind: StepKind;
  metadata?: Maybe<Scalars['JSON']['output']>;
  parentStepId?: Maybe<Scalars['ID']['output']>;
  phaseId: Scalars['ID']['output'];
  producesFact?: Maybe<Scalars['String']['output']>;
  requestThreads?: Maybe<Array<StepRequestThread>>;
  skills?: Maybe<Array<SkillRef>>;
  status: StepStatus;
  statusHistory: Array<StepStatusEvent>;
  /**
   * Typed reason accompanying a `BLOCKED` status. Set by the step executor
   * when the connection resolver returns a non-RESOLVED outcome (S3.4).
   */
  statusReason?: Maybe<StepStatusReason>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  verificationStrategy?: Maybe<VerificationStrategy>;
};

/** Summary data for the plan list dashboard strip */
export type PlansSummary = {
  __typename?: 'PlansSummary';
  /** Number of blocked steps */
  blockedCount: Scalars['Int']['output'];
  /** List of plan IDs with blockers */
  blockedPlanIds: Array<Scalars['ID']['output']>;
  /** Number of completed steps across all plans */
  completedSteps: Scalars['Int']['output'];
  /** Timestamp when summary was generated */
  generatedAt: Scalars['String']['output'];
  /** Recent activity description */
  recentActivity?: Maybe<Scalars['String']['output']>;
  /** Human-readable summary text generated by AI */
  summaryText: Scalars['String']['output'];
  /** Total number of plans */
  totalPlans: Scalars['Int']['output'];
  /** Total number of steps across all plans */
  totalSteps: Scalars['Int']['output'];
};

/**
 * Platform Admin view of a PLATFORM-tier integration's health.
 * Backed by the sweeper from eng S12; per-integration health probe
 * shape extended in C9 of the Composio migration so operators can see
 * the underlying Composio toolkit reachability message + latency
 * without a deploy.
 */
export type PlatformIntegrationStatus = {
  __typename?: 'PlatformIntegrationStatus';
  /**
   * Composio toolkit slug for this integration (from
   * `integrations.yaml`). Surfaced to the Platform Admin UI so the
   * "Open in Composio" deep-link builds against the real Composio
   * slug — not all Planapus integration ids equal the Composio slug
   * (e.g. `google-drive` → `googledrive`, `microsoft-teams` →
   * `microsoft_teams`, `google-mail` → `gmail`, `google-calendar` →
   * `googlecalendar`). Null when Composio doesn't carry the toolkit
   * (SharePoint-style catalog gap); the UI uses null as the typed
   * signal that the integration is code-path-only.
   */
  composioToolkitSlug?: Maybe<Scalars['String']['output']>;
  health: Scalars['String']['output'];
  /**
   * Human-readable detail from the connector's `healthCheck()` probe.
   * Populated by the Composio platform connector with strings like
   * "Composio toolkit gmail reachable", "no Composio toolkit slug
   * (code-path-only connector)", or the underlying error message when
   * the probe failed. Null when the probe wasn't run (e.g. connector
   * not configured). NOTE: free-form human detail only — UI must NOT
   * switch on this string. The typed "is this code-path-only?" signal
   * is `composioToolkitSlug == null` (see below).
   */
  healthMessage?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  lastHealthCheckAt: Scalars['String']['output'];
  /**
   * Wall-clock latency of the last `healthCheck()` probe, in
   * milliseconds. Null when the probe didn't actually hit Composio
   * (catalog-gap / code-path-only) or wasn't run.
   */
  latencyMs?: Maybe<Scalars['Int']['output']>;
  rollingCallCount24h: Scalars['Int']['output'];
  rollingErrorRate24h: Scalars['Float']['output'];
};

/** Input for posting a message to a thread. */
export type PostThreadMessageInput = {
  content: Scalars['String']['input'];
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Result of posting a message to a thread.
 * Includes AI response and updated satisfaction state.
 */
export type PostThreadMessageResult = {
  __typename?: 'PostThreadMessageResult';
  assistantMessage?: Maybe<ThreadMessage>;
  requestThread: RequestThread;
  satisfactionState: SatisfactionState;
  userMessage: ThreadMessage;
};

export type PreviewOutline = {
  __typename?: 'PreviewOutline';
  estimatedTimeline: Scalars['String']['output'];
  steps: Array<PreviewOutlineStep>;
  title: Scalars['String']['output'];
};

export type PreviewOutlineStep = {
  __typename?: 'PreviewOutlineStep';
  automatable: Scalars['Boolean']['output'];
  automationHint?: Maybe<Scalars['String']['output']>;
  estimatedDuration: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PreviewPlanResult = {
  __typename?: 'PreviewPlanResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  outline?: Maybe<PreviewOutline>;
  status: Scalars['String']['output'];
};

/**
 * Projected view of a plan based on viewer's access level.
 * ADMIN sees full plan, ROLE_MEMBER sees filtered view with context fillers.
 */
export type ProjectedPlanView = {
  __typename?: 'ProjectedPlanView';
  createdAt: Scalars['String']['output'];
  goal: Scalars['String']['output'];
  hiddenStepFillers: Array<HiddenStepSummary>;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  phaseSummaries: Array<PhaseSummary>;
  phases: Array<PlanPhase>;
  status: PlanStatus;
  summary: Scalars['String']['output'];
  viewerAccessLevel: ParticipantAccessLevel;
  viewerPersonId: Scalars['ID']['output'];
  viewerRoleIds: Array<Scalars['ID']['output']>;
  visibleSteps: Array<PlanStep>;
};

export type PromoteOrganizationBrandProfileInput = {
  migratePinnedImportProfileGuides?: InputMaybe<Scalars['Boolean']['input']>;
  profileId: Scalars['ID']['input'];
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Structured reference to the fact/answer that caused a task to be pruned. */
export type PrunedTrigger = {
  __typename?: 'PrunedTrigger';
  /** Human-readable explanation of the trigger */
  description?: Maybe<Scalars['String']['output']>;
  /** The fact key that triggered pruning (e.g., "delivery_method") */
  factKey: Scalars['String']['output'];
  /** The value that was selected (e.g., "certified_mail") */
  factValue: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  activeOrganization: ActiveOrgResult;
  /**
   * Returns every record in the Airtable "Action Items" table. The
   * kanban is small enough that pagination on the client isn't worth
   * the complexity; the connector caps at 1000 records as a safety
   * guardrail.
   */
  adminListActionItems: Array<ActionItem>;
  adminListLeads: Array<AdminLead>;
  adminListPilotInvites: Array<PilotInvite>;
  /**
   * Analyze a goal before generating a plan.
   * Performs domain research and generates clarifying questions.
   * Use this before generatePlanFromPrompt for better results.
   */
  analyzePlanGoal: PlanAnalysisResult;
  /**
   * Analyze a step's context to determine capabilities, missing context,
   * and recommended skills for execution.
   */
  analyzeStepContext: StepAnalysisResult;
  /** Get active (unacknowledged) alerts. */
  automationAlerts: Array<AutomationAlert>;
  /** Get queue health metrics for the automation system. */
  automationQueueHealth?: Maybe<AutomationQueueHealth>;
  checkSlugAvailability: SlugAvailability;
  /**
   * JIT requirement lookup used by a step UI when rendering the Connect CTA.
   * Returns null when the step already has an active resolved connection.
   */
  connectionRequirement?: Maybe<ConnectionRequirement>;
  /** Get a document group by ID. */
  documentGroup?: Maybe<DocumentGroup>;
  /** List members of a document group with their source items. */
  documentGroupMembers: Array<GroupMembership>;
  /** List document groups for an organization. */
  documentGroups: Array<DocumentGroup>;
  /** List files from the user's Google Drive connection via Composio. */
  driveFiles: Array<DriveFile>;
  evalPrompt?: Maybe<EvalPrompt>;
  evalPrompts: Array<EvalPrompt>;
  evalReport?: Maybe<EvalReport>;
  evalReports: Array<EvalReportSummary>;
  evalTestCases: Array<EvalTestCase>;
  /**
   * Extract checklist items from a step description using AI.
   * Returns items if description contains a list (ingredients, supplies, documents, etc.).
   * Returns null/empty if description is instructional prose.
   *
   * Results should be cached client-side by stepId to avoid repeated calls.
   * Uses GPT-4o-mini for fast, cheap extraction.
   */
  extractDescriptionItems: DescriptionExtraction;
  /**
   * List featured public guides for the discovery grid.
   * No authentication required.
   */
  featuredGuides: Array<FeaturedGuide>;
  /** Get conversation history for a plan or global scope */
  getConversation?: Maybe<Conversation>;
  /** Get aggregated summary for all user's plans (for dashboard strip) */
  getPlansSummary: PlansSummary;
  /**
   * Get a public plan by ID (no auth required).
   * Returns null if not found or not public (isPublic must be true).
   */
  getPublicPlan?: Maybe<Plan>;
  /**
   * Get a public template by its templateKey (no auth required).
   * Returns null if not found or not public.
   */
  getPublicTemplate?: Maybe<Plan>;
  /** List group suggestions for an organization. */
  groupSuggestions: Array<GroupSuggestion>;
  /** Get the guide linked to a source group. */
  guideBySourceGroup?: Maybe<GuideLanding>;
  /** List citations for a guide, optionally filtered by step. */
  guideCitations: Array<GuideCitation>;
  /**
   * Get guide edit data with published and draft versions.
   * Authentication required.
   */
  guideEditData?: Maybe<GuideEditData>;
  /**
   * Get guide landing page data by org slug and guide slug.
   * No authentication required.
   */
  guideLanding?: Maybe<GuideLanding>;
  /**
   * Get info about starting a guide — whether role selection is needed.
   * No authentication required.
   */
  guideStarterInfo?: Maybe<GuideStarterInfo>;
  /**
   * Get intake form data by slug (no auth required).
   * Returns public data needed to render the intake form.
   */
  intakePublic?: Maybe<IntakePublicData>;
  /** Get intake request by ID (requires ownership). */
  intakeRequest?: Maybe<IntakeRequest>;
  /** List intake requests (optionally filter by plan/step). */
  intakeRequests: Array<IntakeRequest>;
  /**
   * Read-only projection of the integration manifest, optionally filtered
   * by which tier a caller wants to connect at (e.g. the Org Integrations
   * page passes `tier: ORG` to hide consumer-only integrations like Plaid).
   * Always sorted by priority (P0 first), then by name.
   */
  integrationCatalog: Array<IntegrationCatalogEntry>;
  job?: Maybe<Job>;
  jobEventCount: Scalars['Int']['output'];
  jobEvents: Array<JobEvent>;
  /**
   * Get the status of a background job by ID.
   * Returns null if job not found.
   */
  jobStatus?: Maybe<QueueJobStatus>;
  /** List all published guides. Authentication required. */
  listGuides: Array<GuideLanding>;
  /** List all available plan templates */
  listPlanTemplates: Array<Plan>;
  /**
   * Get all plans accessible to the current user with per-plan access metadata.
   *
   * Returns a unified list of:
   * - Plans where user is the owner (accessLevel=ADMIN, isOwner=true)
   * - Plans where user is a participant (accessLevel=ADMIN or ROLE_MEMBER)
   *
   * Each plan includes the viewer's specific access level for that plan.
   * Use this for plan list/home page to show accurate access labels.
   *
   * Authorization: Access is per-(planId, personId) scoped.
   */
  myAccessiblePlans: Array<PlanListItem>;
  /**
   * Get current user's inbox of assigned items.
   * Requires authentication via magic link or Firebase auth.
   */
  myAssignedItems: Array<AssignedItem>;
  /** USER + RUN connections owned by the calling principal. */
  myConnections: Array<IntegrationConnection>;
  /** Get the authenticated user's notification preferences. */
  myNotificationPreferences: NotificationPreferences;
  /** Get the authenticated user's notification feed. */
  myNotifications: Array<AppNotification>;
  myOrganizations: Array<Organization>;
  /**
   * List all unique participants the owner has added across their plans.
   * Useful for autocomplete when adding participants to new plans.
   */
  myParticipants: Array<Person>;
  /** Get the unread notification count for the authenticated user. */
  myUnreadNotificationCount: Scalars['Int']['output'];
  openRouterModels: Array<OpenRouterModelPricing>;
  /**
   * Org-admin metadata audit over members' connections that touched runs
   * in this org. Never returns tokens (see M2, ADR-0002).
   */
  orgConnectionAudit: Array<OrgAuditEntry>;
  /** ORG-tier connections for an organization the caller belongs to. */
  orgConnections: Array<IntegrationConnection>;
  orgJobs: Array<Job>;
  orgWebCrawls: Array<WebCrawl>;
  organizationBrandProfileImpact: BrandProfileImpact;
  organizationBrandProfiles: Array<OrganizationBrandProfile>;
  /**
   * Get plan as a participant (requires participant auth).
   * Returns the plan if the authenticated user is a participant.
   */
  participantPlan?: Maybe<Plan>;
  /**
   * Get participant workspace view for ROLE_MEMBER users.
   * Returns a focused, single-screen experience for task execution.
   * Only available to ROLE_MEMBER participants (not owners or ADMINs).
   */
  participantWorkspace?: Maybe<ParticipantWorkspaceView>;
  /** Get a person by ID */
  person?: Maybe<Person>;
  /** Get an enriched person profile by email. */
  personProfile?: Maybe<PersonProfile>;
  /** Platform-admin only. Aggregated dashboard metrics. */
  pilotDashboardOverview: PilotDashboardOverview;
  /** Platform-admin only. Single visitor with sessions + events + linked leads. */
  pilotVisitor?: Maybe<PilotVisitor>;
  /** Platform-admin only. Paginated, filterable list of visitors. */
  pilotVisitors: PilotVisitorListResult;
  /** Get alerts for a specific plan. */
  planAlerts: Array<AutomationAlert>;
  /** Get the event log for a plan (execution history). */
  planEventLog: Array<PlanEvent>;
  /**
   * Get participants for a specific plan (global identity version).
   * Returns GlobalParticipant with resolved Person objects.
   */
  planParticipants: Array<GlobalParticipant>;
  /** Get a plan by ID (requires ownership) */
  planapusPlan?: Maybe<Plan>;
  /** Get all plans for current user */
  planapusPlans: Array<Plan>;
  /** Platform Admin dashboard view — S12. */
  platformIntegrations: Array<PlatformIntegrationStatus>;
  /** Get a preview plan by ID. No authentication required. */
  previewPlan?: Maybe<PreviewPlanResult>;
  /**
   * Get projected plan view based on viewer's access level.
   * - Owner/ADMIN: full plan visibility
   * - ROLE_MEMBER: filtered view with only assigned steps, plus context fillers
   * Requires authentication.
   */
  projectedPlan?: Maybe<ProjectedPlanView>;
  /** Get request thread by ID (requires auth, must own parent plan). */
  requestThread?: Maybe<RequestThread>;
  /**
   * Get thread data by slug (public for PUBLIC threads, auth for ASSIGNEE_ONLY).
   * Returns limited public view for security.
   */
  requestThreadPublic?: Maybe<RequestThreadPublicData>;
  /** Get all threads for a step (requires auth, must own parent plan). */
  requestThreadsForStep: Array<RequestThread>;
  /** RUN-tier connections on a run the caller owns (or their org owns). */
  runConnections: Array<IntegrationConnection>;
  /** Search owner's participants by name or email. */
  searchMyParticipants: Array<Person>;
  /** Search person profiles by query string (prefix match on email). */
  searchPersonProfiles: Array<PersonProfile>;
  /** Get a single source item by ID. */
  sourceItem?: Maybe<SourceItem>;
  /** Check what depends on a source item before deleting it. */
  sourceItemDependencies: SourceItemDependency;
  /** Get tree nodes for the Source Library left pane. */
  sourceItemTree: Array<SourceItemTreeNode>;
  /** List all source items for an organization. */
  sourceItems: Array<SourceItem>;
  /** Paginated, filterable source items for the Source Library right pane. */
  sourceItemsConnection: SourceItemConnection;
  /**
   * Validate a journey magic link token (without consuming it).
   * No authentication required.
   */
  validateJourneyMagicLink: JourneyMagicLinkValidation;
  /**
   * Validate a login magic link token (no auth required).
   * Returns email for the login page preview.
   */
  validateLoginMagicLink: LoginMagicLinkValidationResult;
  /**
   * Validate a magic link token (no auth required).
   * Returns plan/participant info for the join page preview.
   */
  validateMagicLink: MagicLinkValidationResult;
  webCrawl?: Maybe<WebCrawl>;
  webCrawlPages: Array<CrawledPage>;
};


export type QueryAdminListLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAnalyzePlanGoalArgs = {
  input: AnalyzePlanGoalInput;
};


export type QueryAnalyzeStepContextArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type QueryAutomationAlertsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckSlugAvailabilityArgs = {
  slug: Scalars['String']['input'];
};


export type QueryConnectionRequirementArgs = {
  runId: Scalars['ID']['input'];
  stepId: Scalars['String']['input'];
};


export type QueryDocumentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupMembersArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryDocumentGroupsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryDriveFilesArgs = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEvalPromptArgs = {
  name: Scalars['String']['input'];
};


export type QueryEvalReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryExtractDescriptionItemsArgs = {
  description: Scalars['String']['input'];
};


export type QueryGetConversationArgs = {
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPublicPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryGetPublicTemplateArgs = {
  templateKey: Scalars['String']['input'];
};


export type QueryGroupSuggestionsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryGuideBySourceGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryGuideCitationsArgs = {
  guideId: Scalars['ID']['input'];
  stepId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGuideEditDataArgs = {
  guideId: Scalars['ID']['input'];
};


export type QueryGuideLandingArgs = {
  guideSlug: Scalars['String']['input'];
  orgSlug: Scalars['String']['input'];
};


export type QueryGuideStarterInfoArgs = {
  guideSlug: Scalars['String']['input'];
  orgSlug: Scalars['String']['input'];
};


export type QueryIntakePublicArgs = {
  slug: Scalars['String']['input'];
};


export type QueryIntakeRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntakeRequestsArgs = {
  planId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<IntakeStatus>;
  stepId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIntegrationCatalogArgs = {
  tier?: InputMaybe<ConnectionTier>;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobEventCountArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobEventsArgs = {
  jobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryMyAccessiblePlansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PlanStatus>;
};


export type QueryMyAssignedItemsArgs = {
  itemType?: InputMaybe<AssignedItemType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StepStatus>;
};


export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpenRouterModelsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOrgConnectionAuditArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryOrgConnectionsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryOrgJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  status?: InputMaybe<Array<JobStatus>>;
};


export type QueryOrgWebCrawlsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryOrganizationBrandProfileImpactArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryOrganizationBrandProfilesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BrandProfileStatus>;
};


export type QueryParticipantPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryParticipantWorkspaceArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonProfileArgs = {
  email: Scalars['String']['input'];
};


export type QueryPilotDashboardOverviewArgs = {
  range: PilotDateRangeInput;
};


export type QueryPilotVisitorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPilotVisitorsArgs = {
  filter?: InputMaybe<PilotVisitorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PilotVisitorSortInput>;
};


export type QueryPlanAlertsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  planId: Scalars['ID']['input'];
};


export type QueryPlanEventLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  planId: Scalars['ID']['input'];
};


export type QueryPlanParticipantsArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPlanapusPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanapusPlansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PlanStatus>;
};


export type QueryPreviewPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectedPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryRequestThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequestThreadPublicArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRequestThreadsForStepArgs = {
  planId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type QueryRunConnectionsArgs = {
  runId: Scalars['ID']['input'];
};


export type QuerySearchMyParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchPersonProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySourceItemArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySourceItemDependenciesArgs = {
  sourceItemId: Scalars['ID']['input'];
};


export type QuerySourceItemTreeArgs = {
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  orgId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySourceItemsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QuerySourceItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryValidateJourneyMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type QueryValidateLoginMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type QueryValidateMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type QueryWebCrawlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebCrawlPagesArgs = {
  crawlId: Scalars['ID']['input'];
};

/** Status of a background job */
export type QueueJobStatus = {
  __typename?: 'QueueJobStatus';
  /** Number of attempts made */
  attemptsMade: Scalars['Int']['output'];
  /** Error message if failed */
  failedReason?: Maybe<Scalars['String']['output']>;
  /** Timestamp when job finished */
  finishedOn?: Maybe<Scalars['Float']['output']>;
  /** Unique job ID */
  jobId: Scalars['ID']['output'];
  /** Type of job */
  jobType: Scalars['String']['output'];
  /** Timestamp when job started processing */
  processedOn?: Maybe<Scalars['Float']['output']>;
  /** Progress percentage (0-100) */
  progress: Scalars['Int']['output'];
  /** Result data if completed (JSON) */
  result?: Maybe<Scalars['JSON']['output']>;
  /** Current state of the job */
  state: JobState;
  /** Timestamp when job was added (ms since epoch) */
  timestamp: Scalars['Float']['output'];
};

/** Suggestion for updating downstream steps when upstream changes */
export type ReflowSuggestion = {
  __typename?: 'ReflowSuggestion';
  affectedStepId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  requiresApproval: Scalars['Boolean']['output'];
  suggestedChanges: Scalars['JSON']['output'];
};

export type RequestPilotInviteByEmailResult = {
  __typename?: 'RequestPilotInviteByEmailResult';
  /** Always true — anti-enumeration. The email is sent only if an active invite is bound to it. */
  sent: Scalars['Boolean']['output'];
};

/**
 * Defines what data the thread is collecting.
 * This is the ONLY parent context visible to the thread LLM.
 */
export type RequestSpec = {
  __typename?: 'RequestSpec';
  allowedFields: Array<AllowedField>;
  ask: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  outputContract: OutputContract;
  uiMode?: Maybe<RequestUiMode>;
};

/** Input for request specification. */
export type RequestSpecInput = {
  allowedFields: Array<AllowedFieldInput>;
  ask: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  outputContract: OutputContractInput;
  uiMode?: InputMaybe<RequestUiMode>;
};

/**
 * A sandboxed chat thread for collecting data from external parties.
 * Context-isolated from the parent plan.
 */
export type RequestThread = {
  __typename?: 'RequestThread';
  accessMode: ThreadAccessMode;
  assigneeIds?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages: Array<ThreadMessage>;
  parentPlanId: Scalars['ID']['output'];
  parentStepId: Scalars['ID']['output'];
  parentStepTitle?: Maybe<Scalars['String']['output']>;
  publicUrl: Scalars['String']['output'];
  requestSpec: RequestSpec;
  result?: Maybe<BoundedResult>;
  satisfactionState?: Maybe<SatisfactionState>;
  slug: Scalars['String']['output'];
  status: RequestThreadStatus;
  updatedAt: Scalars['String']['output'];
  uploads: Array<ThreadUpload>;
};

/**
 * Public data visible to thread participants (no auth required for PUBLIC threads).
 * Limited view for security.
 */
export type RequestThreadPublicData = {
  __typename?: 'RequestThreadPublicData';
  accessMode: ThreadAccessMode;
  id: Scalars['ID']['output'];
  messages: Array<ThreadMessage>;
  parentStepTitle?: Maybe<Scalars['String']['output']>;
  requestSpec: RequestSpec;
  satisfactionState?: Maybe<SatisfactionState>;
  status: RequestThreadStatus;
  uploads: Array<ThreadUpload>;
};

/**
 * Thread status lifecycle:
 * OPEN -> READY -> SATISFIED
 *      -> EXPIRED | CANCELLED
 */
export enum RequestThreadStatus {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Ready = 'READY',
  Satisfied = 'SATISFIED'
}

/** UI mode for request thread rendering. */
export enum RequestUiMode {
  Auto = 'auto',
  Chat = 'chat',
  Form = 'form'
}

/** A required item for step completion */
export type RequiredItem = {
  __typename?: 'RequiredItem';
  /** Category determines if this item blocks completion */
  category?: Maybe<RequiredItemCategory>;
  /** For CONDITIONAL items: the condition that must be true for this to be required */
  condition?: Maybe<Scalars['String']['output']>;
  /** For CONDITIONAL items: whether the condition is currently met */
  conditionMet?: Maybe<Scalars['Boolean']['output']>;
  evidence?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  status: RequiredItemStatus;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Category of a requirement - determines if it blocks completion */
export enum RequiredItemCategory {
  /** Only required if its condition is true (e.g., 'if you cannot find it...') */
  Conditional = 'CONDITIONAL',
  /** Nice-to-have enrichment - shown but never blocks completion */
  Optional = 'OPTIONAL',
  /** Primary objective - must be satisfied to mark step complete */
  Required = 'REQUIRED'
}

/** Status of a required item for step completion */
export enum RequiredItemStatus {
  Done = 'DONE',
  Missing = 'MISSING',
  Partial = 'PARTIAL'
}

export type ResolvedGuideTheme = {
  __typename?: 'ResolvedGuideTheme';
  accessibilityAdjusted: Scalars['Boolean']['output'];
  backgroundColor: Scalars['String']['output'];
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  ctaTextColor: Scalars['String']['output'];
  headerLogoUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  organizationDisplayName: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  profileId?: Maybe<Scalars['ID']['output']>;
  secondaryColor: Scalars['String']['output'];
  source: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  tone?: Maybe<BrandTone>;
  warnings: Array<Scalars['String']['output']>;
};

export enum ReviewStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Unreviewed = 'UNREVIEWED'
}

/**
 * Slider state + computed scenarios from Widget #2 (ROI Calculator).
 * Captured when a visitor clicks "Email me this number with the assumptions."
 */
export type RoiCalculatorPayloadInput = {
  aggressiveTotal: Scalars['Float']['input'];
  automationRate: Scalars['Float']['input'];
  conservativeTotal: Scalars['Float']['input'];
  hourlyCost: Scalars['Float']['input'];
  hoursPerOperation: Scalars['Float']['input'];
  leakageRecoveryPts: Scalars['Float']['input'];
  midTotal: Scalars['Float']['input'];
  vendorSpend: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
};

/**
 * AI-evaluated satisfaction state.
 * Updated after each message to track progress.
 */
export type SatisfactionState = {
  __typename?: 'SatisfactionState';
  confidence: Scalars['Float']['output'];
  evaluatedAt: Scalars['String']['output'];
  extractedFields: Scalars['JSON']['output'];
  isReady: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  progressSummary: Scalars['String']['output'];
};

export type ScoreBreakdown = {
  __typename?: 'ScoreBreakdown';
  contentSimilarity: Scalars['Float']['output'];
  goalClarity: Scalars['Float']['output'];
  personaFit: Scalars['Float']['output'];
  sharedEntities: Scalars['Float']['output'];
  urlNeighborhood: Scalars['Float']['output'];
};

export type SendChatMessageInput = {
  /** The message content from the user */
  message: Scalars['String']['input'];
  /** Plan ID to scope the conversation (null for global chat) */
  planId?: InputMaybe<Scalars['ID']['input']>;
  /** Step ID if message is related to a specific step (triggers assessment) */
  stepId?: InputMaybe<Scalars['ID']['input']>;
};

/** Response from sending a chat message */
export type SendChatMessageResponse = {
  __typename?: 'SendChatMessageResponse';
  /** The assistant's response */
  assistantMessage: ChatMessage;
  /** Auto-action taken (e.g., step auto-completed) */
  autoAction?: Maybe<StepAutoAction>;
  /** Updated conversation */
  conversation: Conversation;
  /** The user's message that was sent */
  userMessage: ChatMessage;
};

/** Result of sending messages */
export type SendMessageResult = {
  __typename?: 'SendMessageResult';
  /** Number of successful emails sent */
  emailSuccess: Scalars['Int']['output'];
  /** Number of failed deliveries */
  failed: Scalars['Int']['output'];
  /** Number of successful SMS sent */
  smsSuccess: Scalars['Int']['output'];
  /** Total number of participants */
  total: Scalars['Int']['output'];
};

/** Input for sending a message to a single recipient */
export type SendMessageToRecipientInput = {
  /** HTML content (for email, optional) */
  html?: InputMaybe<Scalars['String']['input']>;
  /** Recipient to send message to */
  recipient: MessageRecipientInput;
  /** Message subject (for email) */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Message text content */
  text: Scalars['String']['input'];
};

/** Reference to a skill that can execute a step */
export type SkillRef = {
  __typename?: 'SkillRef';
  id: Scalars['ID']['output'];
  intent?: Maybe<StepIntent>;
  name: Scalars['String']['output'];
  source: SkillSource;
  subType?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** Source of a skill definition */
export enum SkillSource {
  Custom = 'CUSTOM',
  System = 'SYSTEM',
  Template = 'TEMPLATE'
}

export type SlugAvailability = {
  __typename?: 'SlugAvailability';
  available: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type SourceAnalysisResult = {
  __typename?: 'SourceAnalysisResult';
  analyzedAt: Scalars['String']['output'];
  audience?: Maybe<Scalars['String']['output']>;
  flags: Array<Scalars['String']['output']>;
  guide_title?: Maybe<Scalars['String']['output']>;
  guideable: Scalars['Boolean']['output'];
  guideable_rationale: Scalars['String']['output'];
  model: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  topic: Scalars['String']['output'];
  wave: Scalars['String']['output'];
};

export type SourceItem = {
  __typename?: 'SourceItem';
  analysis?: Maybe<SourceAnalysisResult>;
  analysisStatus?: Maybe<Scalars['String']['output']>;
  classificationOverride?: Maybe<ClassificationOverride>;
  classificationStatus?: Maybe<Scalars['String']['output']>;
  classificationWave1?: Maybe<ClassificationResult>;
  classificationWave2?: Maybe<ClassificationResult>;
  createdAt: Scalars['String']['output'];
  extractedText?: Maybe<Scalars['String']['output']>;
  extractionMetadata?: Maybe<ExtractionMetadata>;
  extractionStatus: ExtractionStatus;
  id: Scalars['ID']['output'];
  linkedFromPages?: Maybe<Array<SourceItemLinkedPage>>;
  mimeType?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
  primaryOwnerGroupId?: Maybe<Scalars['ID']['output']>;
  reviewStatus: ReviewStatus;
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  summarizationStatus?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SourceItemConnection = {
  __typename?: 'SourceItemConnection';
  edges: Array<SourceItemEdge>;
  pageInfo: SourceItemPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SourceItemDependency = {
  __typename?: 'SourceItemDependency';
  canDelete: Scalars['Boolean']['output'];
  citations: Array<DependencyCitationRef>;
  groupMemberships: Array<DependencyGroupRef>;
  suggestions: Array<DependencySuggestionRef>;
};

export type SourceItemEdge = {
  __typename?: 'SourceItemEdge';
  cursor: Scalars['String']['output'];
  node: SourceItem;
};

export type SourceItemFilter = {
  /** Filter by analysis status: pending, processing, completed, failed. */
  analysisStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by audience from analysis: External, Internal, Both. */
  audience?: InputMaybe<Scalars['String']['input']>;
  extractionStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by classification result: true = process, false = not a process. Omit for any. */
  isProcess?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the item references a process: true = yes, false = no. Omit for any. */
  referencesProcess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by summarization status: pending, processing, completed, skipped, failed. */
  summarizationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by analysis topic (case-insensitive substring match). */
  topic?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter for items that have not been classified yet. */
  unclassified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SourceItemLinkedPage = {
  __typename?: 'SourceItemLinkedPage';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SourceItemPageInfo = {
  __typename?: 'SourceItemPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type SourceItemTreeNode = {
  __typename?: 'SourceItemTreeNode';
  count: Scalars['Int']['output'];
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Source locator pointing to a specific place within a source document. */
export type SourceLocator = {
  __typename?: 'SourceLocator';
  heading?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  paragraphIndex?: Maybe<Scalars['Int']['output']>;
  selector?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartJobResult = {
  __typename?: 'StartJobResult';
  deduplicated: Scalars['Boolean']['output'];
  jobId: Scalars['ID']['output'];
  resultRef?: Maybe<Scalars['ID']['output']>;
  status: JobStatus;
};

/** Result of starting a journey (creates a Plan from a Guide template). */
export type StartJourneyResult = {
  __typename?: 'StartJourneyResult';
  message: Scalars['String']['output'];
  planId: Scalars['ID']['output'];
};

/** Status bucket for hidden step summaries */
export enum StatusBucket {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Done = 'DONE',
  Pending = 'PENDING'
}

/** Status bucket counts for phase summary. */
export type StatusBucketCounts = {
  __typename?: 'StatusBucketCounts';
  active: Scalars['Int']['output'];
  blocked: Scalars['Int']['output'];
  done: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

/** Status counts for progress tracking. */
export type StatusCounts = {
  __typename?: 'StatusCounts';
  blocked: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  todo: Scalars['Int']['output'];
};

/**
 * Form field spec for a step (resolved at plan creation, e.g. from AI extraction).
 * Same shape as request thread AllowedField; used for inline step forms.
 */
export type StepAllowedField = {
  __typename?: 'StepAllowedField';
  description?: Maybe<Scalars['String']['output']>;
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

/** Result of analyzing a step's context and capabilities */
export type StepAnalysisResult = {
  __typename?: 'StepAnalysisResult';
  capabilities: StepCapabilities;
  missingContext: Array<ContextRequirementOutput>;
  recommendedSkills: Array<SkillRef>;
  stepId: Scalars['ID']['output'];
};

/**
 * Step applicability based on plan facts/user decisions.
 * Used for conditional paths (e.g., in-person vs certified mail).
 */
export type StepApplicability = {
  __typename?: 'StepApplicability';
  /** Whether the step is currently applicable */
  applicable: Scalars['Boolean']['output'];
  /** Which plan facts this step's applicability depends on */
  dependsOnFacts?: Maybe<Array<Scalars['String']['output']>>;
  /** When applicability was last evaluated */
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The specific fact/answer that triggered pruning (structured reference).
   * Example: { key: "delivery_method", value: "certified_mail" }
   */
  prunedTrigger?: Maybe<PrunedTrigger>;
  /** Reason why step is not applicable (null if applicable) */
  reason?: Maybe<Scalars['String']['output']>;
};

/** AI assessment of step completion status and progress */
export type StepAssessment = {
  __typename?: 'StepAssessment';
  completionConfidence: Scalars['Float']['output'];
  eligibleForCompletion: Scalars['Boolean']['output'];
  /** Facts extracted during this step's assessment (e.g., user decisions, collected values) */
  extractedFacts?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isComplete: Scalars['Boolean']['output'];
  progress: StepProgress;
  suggestedNext: SuggestedNextActions;
  timestamp: Scalars['String']['output'];
  triggeredBy: Scalars['String']['output'];
};

/** Action taken automatically by the system after evaluating user message */
export type StepAutoAction = {
  __typename?: 'StepAutoAction';
  /** Type of action taken */
  action: StepAutoActionType;
  /** Human-readable message about the action */
  message: Scalars['String']['output'];
  /** ID of the next step to advance to (null if no next step) */
  nextStepId?: Maybe<Scalars['ID']['output']>;
  /** Title of the next step (null if no next step) */
  nextStepTitle?: Maybe<Scalars['String']['output']>;
  /** ID of the step that was acted upon */
  stepId: Scalars['ID']['output'];
  /** Title of the step that was acted upon */
  stepTitle: Scalars['String']['output'];
};

export enum StepAutoActionType {
  /** Step was automatically marked as complete */
  Completed = 'COMPLETED',
  /** All steps in the plan are now complete */
  PlanComplete = 'PLAN_COMPLETE'
}

/**
 * Blocked status information for a step.
 * Reveals count of hidden prerequisites but never their IDs or titles.
 */
export type StepBlockedInfo = {
  __typename?: 'StepBlockedInfo';
  blockedReason?: Maybe<Scalars['String']['output']>;
  canStart: Scalars['Boolean']['output'];
  hiddenPrereqCount: Scalars['Int']['output'];
  isBlocked: Scalars['Boolean']['output'];
  visiblePrereqIds: Array<Scalars['ID']['output']>;
};

/** Step capabilities - what AI can do for this step */
export type StepCapabilities = {
  __typename?: 'StepCapabilities';
  canDraft: Scalars['Boolean']['output'];
  canExecute: Scalars['Boolean']['output'];
  canRecommend: Scalars['Boolean']['output'];
  canResearch: Scalars['Boolean']['output'];
  requiresExternalInput: Scalars['Boolean']['output'];
  requiresHumanDecision: Scalars['Boolean']['output'];
};

export type StepContext = {
  __typename?: 'StepContext';
  /**
   * Structured output data extracted from automation execution.
   * Contains summary, keyPoints, sources, and other intent-specific data.
   * Populated by the output-extractor after successful step execution.
   */
  collectedData?: Maybe<Scalars['JSON']['output']>;
  /** Timeline of connector events: submitted, poll_attempt, completed/blocked. */
  connectorActivityLog?: Maybe<Scalars['JSON']['output']>;
  /** Result of connector poll when complete (success or failure). */
  connectorPollResult?: Maybe<Scalars['JSON']['output']>;
  /** Fetched connector response body (e.g. FOIA agency reply) when poll completes successfully. */
  connectorResponse?: Maybe<Scalars['JSON']['output']>;
  /** Async connector wait context (e.g. requestId) set after connector submit. */
  connectorWait?: Maybe<Scalars['JSON']['output']>;
  /** Last submit input used for connector (for Resubmit when step is blocked). */
  lastConnectorSubmitInput?: Maybe<Scalars['JSON']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  lastUpdatedByUserId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Result data from polling an external service (for POLLING verification steps). */
  pollResult?: Maybe<Scalars['JSON']['output']>;
  /** Result data from a webhook callback (for WEBHOOK verification steps). */
  webhookResult?: Maybe<Scalars['JSON']['output']>;
};

export type StepContextInput = {
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Dependency relationship between steps for reflow */
export type StepDependency = {
  __typename?: 'StepDependency';
  affectedFields: Array<Scalars['String']['output']>;
  dependencyType: Scalars['String']['output'];
  dependsOn: Array<Scalars['ID']['output']>;
  stepId: Scalars['ID']['output'];
};

/**
 * Computed dependency status for a step.
 * Calculated by backend considering ALL dependencies, including hidden ones.
 * ROLE_MEMBER participants should rely on this for accurate blocking information.
 */
export type StepDependencyStatus = {
  __typename?: 'StepDependencyStatus';
  /** Whether all dependencies (visible and hidden) are complete */
  allSatisfied: Scalars['Boolean']['output'];
  /** Count of incomplete dependencies that are hidden from the viewer */
  blockedByHiddenSteps: Scalars['Int']['output'];
  /** Human-readable reason if blocked */
  blockedReason?: Maybe<Scalars['String']['output']>;
  /** Whether this step can be started (NOT_STARTED + all deps satisfied) */
  canStart: Scalars['Boolean']['output'];
  /** IDs of visible incomplete dependencies (for UI display) */
  visibleBlockingStepIds: Array<Scalars['ID']['output']>;
};

/**
 * Data collection (intake) information for a step.
 * Supports both inline submission and shareable public links.
 */
export type StepIntakeData = {
  __typename?: 'StepIntakeData';
  fileRefs?: Maybe<Array<IntakeFileRef>>;
  intakeRequestId: Scalars['ID']['output'];
  normalizedResult?: Maybe<Scalars['JSON']['output']>;
  publicUrl: Scalars['String']['output'];
  rawText?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
  status: IntakeStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export enum StepIntent {
  Calculation = 'CALCULATION',
  CollectDocument = 'COLLECT_DOCUMENT',
  Coordinate = 'COORDINATE',
  Custom = 'CUSTOM',
  DataEntry = 'DATA_ENTRY',
  ExternalSubmission = 'EXTERNAL_SUBMISSION',
  GatherInfo = 'GATHER_INFO',
  Negotiation = 'NEGOTIATION',
  Payment = 'PAYMENT',
  Research = 'RESEARCH',
  ReviewApprove = 'REVIEW_APPROVE',
  Schedule = 'SCHEDULE',
  SendNotification = 'SEND_NOTIFICATION',
  SendSignature = 'SEND_SIGNATURE'
}

export enum StepKind {
  Automation = 'AUTOMATION',
  Human = 'HUMAN',
  Mixed = 'MIXED'
}

/** Progress metrics for step completion */
export type StepProgress = {
  __typename?: 'StepProgress';
  effortWeighted: EffortWeightedProgress;
  structured: StructuredProgress;
};

/**
 * Reference to a request thread created for this step.
 * Tracks delegated data collection via chat.
 */
export type StepRequestThread = {
  __typename?: 'StepRequestThread';
  createdAt: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  result?: Maybe<StepThreadResult>;
  slug: Scalars['String']['output'];
  status: RequestThreadStatus;
  threadId: Scalars['ID']['output'];
};

export enum StepStatus {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  /** Step is not applicable based on user decisions (e.g., chose different path) */
  Skipped = 'SKIPPED',
  /** Step was dispatched and is waiting for external confirmation (webhook/polling/user) */
  WaitingExternal = 'WAITING_EXTERNAL'
}

export type StepStatusEvent = {
  __typename?: 'StepStatusEvent';
  changedAt: Scalars['String']['output'];
  changedByUserId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: StepStatus;
};

/**
 * Typed reason accompanying `StepStatus.BLOCKED`. Added in S3.4 so the UI
 * can render the JIT Connect card and choose the right escalation copy
 * without parsing free-form strings. See RFC §3.1 / §3.3.
 */
export enum StepStatusReason {
  /** No active connection exists for the required integration. */
  ConnectionRequired = 'CONNECTION_REQUIRED',
  /** The consumer has not consented to an ORG→USER fallback for this run. */
  ConsumerWithheldFallback = 'CONSUMER_WITHHELD_FALLBACK',
  /** An ORG connection is in a failed state; the Org Admin must reconnect. */
  OrgReconnectRequired = 'ORG_RECONNECT_REQUIRED',
  /**
   * S11 — preview run is forced to the creator's USER connection but
   * the creator hasn't connected the integration yet. Distinct from
   * CONNECTION_REQUIRED so the UI can render preview-specific copy
   * ("connect your test account") without changing the live consumer
   * Connect prompt.
   */
  PreviewNeedsUser = 'PREVIEW_NEEDS_USER'
}

/**
 * Result from a completed request thread.
 * Contains the extracted facts that flow back to the step/plan.
 */
export type StepThreadResult = {
  __typename?: 'StepThreadResult';
  completedAt: Scalars['String']['output'];
  fields: Scalars['JSON']['output'];
  summary: Scalars['String']['output'];
};

/** Structured progress metrics based on required items */
export type StructuredProgress = {
  __typename?: 'StructuredProgress';
  doneCount: Scalars['Int']['output'];
  fraction: Scalars['Float']['output'];
  requiredItems: Array<RequiredItem>;
  totalCount: Scalars['Int']['output'];
};

/** Suggested next actions when step is incomplete */
export type SuggestedNextActions = {
  __typename?: 'SuggestedNextActions';
  missingInfoQuestions: Array<Scalars['String']['output']>;
  recommendedActions: Array<Scalars['String']['output']>;
};

export type SuggestedSaaS = {
  __typename?: 'SuggestedSaaS';
  communication?: Maybe<Array<Scalars['String']['output']>>;
  esign?: Maybe<Array<Scalars['String']['output']>>;
  pm?: Maybe<Array<Scalars['String']['output']>>;
  storage?: Maybe<Array<Scalars['String']['output']>>;
};

/** Access control mode for the thread. */
export enum ThreadAccessMode {
  AssigneeOnly = 'ASSIGNEE_ONLY',
  Public = 'PUBLIC'
}

/** A message in the thread conversation. */
export type ThreadMessage = {
  __typename?: 'ThreadMessage';
  attachmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  senderId?: Maybe<Scalars['ID']['output']>;
  timestamp: Scalars['String']['output'];
};

/**
 * A file uploaded to the thread.
 * Scoped to thread only - not visible to parent.
 */
export type ThreadUpload = {
  __typename?: 'ThreadUpload';
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['String']['output'];
};

export type TrackPilotEventsResult = {
  __typename?: 'TrackPilotEventsResult';
  accepted: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
  sessionId: Scalars['ID']['output'];
  visitorId: Scalars['ID']['output'];
};

/** Partial update — only the fields you pass are written. */
export type UpdateActionItemInput = {
  dueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationBrandProfileInput = {
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  headerLogoUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationDisplayName?: InputMaybe<Scalars['String']['input']>;
  palette?: InputMaybe<BrandPaletteInput>;
  profileId: Scalars['ID']['input'];
  provenance?: InputMaybe<Array<Scalars['String']['input']>>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BrandProfileStatus>;
  tone?: InputMaybe<BrandTone>;
};

export type UpdateParticipantInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a person's details */
export type UpdatePersonInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Partial update — only the fields you pass are written. */
export type UpdatePilotInviteInput = {
  audience?: InputMaybe<PilotInviteAudience>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanRoleInput = {
  canFillRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultAssigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating thread fields directly via form. */
export type UpdateThreadFieldsInput = {
  fields: Scalars['JSON']['input'];
};

/** Result of updating thread fields via form (no chat messages involved). */
export type UpdateThreadFieldsResult = {
  __typename?: 'UpdateThreadFieldsResult';
  /**
   * Validation errors for specific fields (key -> error message).
   * Empty if all fields validated successfully.
   */
  fieldErrors?: Maybe<Scalars['JSON']['output']>;
  requestThread: RequestThread;
  satisfactionState: SatisfactionState;
};

export type UserContextInput = {
  budget?: InputMaybe<Scalars['Float']['input']>;
  constraints?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatePilotInviteResult = {
  __typename?: 'ValidatePilotInviteResult';
  audience?: Maybe<PilotInviteAudience>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

/**
 * How the system verifies that a step has completed after execution.
 * Drives async monitoring behavior in Phase 4.
 */
export enum VerificationStrategy {
  /** Step completes synchronously - result is known immediately (e.g., research, calculation) */
  Immediate = 'IMMEDIATE',
  /** System must poll an external service for completion status (fallback when no webhook available) */
  Polling = 'POLLING',
  /** Only a human can confirm completion (e.g., physical tasks, in-person meetings) */
  UserConfirm = 'USER_CONFIRM',
  /** External service will call back via webhook when done (e.g., e-signature, calendar booking) */
  Webhook = 'WEBHOOK'
}

export type WebCrawl = {
  __typename?: 'WebCrawl';
  allowedDomains?: Maybe<Array<Scalars['String']['output']>>;
  brandExtraction?: Maybe<BrandDiscoveryResult>;
  createdAt: Scalars['String']['output'];
  documentsFound: Scalars['Int']['output'];
  documentsImported: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['String']['output']>;
  generationJobId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  maxDepth: Scalars['Int']['output'];
  maxPages: Scalars['Int']['output'];
  orgId: Scalars['ID']['output'];
  pagesCrawled: Scalars['Int']['output'];
  pagesDiscovered: Scalars['Int']['output'];
  requestedByUserId: Scalars['String']['output'];
  seedUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Role summary for participant workspace, showing who is assigned to each role. */
export type WorkspaceRole = {
  __typename?: 'WorkspaceRole';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isViewer: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActionItem: ResolverTypeWrapper<ActionItem>;
  ActiveOrgResult: ResolverTypeWrapper<ActiveOrgResult>;
  AddGlobalParticipantInput: AddGlobalParticipantInput;
  AdminLead: ResolverTypeWrapper<AdminLead>;
  AllowedField: ResolverTypeWrapper<AllowedField>;
  AllowedFieldInput: AllowedFieldInput;
  AllowedFieldType: AllowedFieldType;
  AnalyzePlanGoalInput: AnalyzePlanGoalInput;
  AnonymousRunSession: ResolverTypeWrapper<AnonymousRunSession>;
  AppNotification: ResolverTypeWrapper<AppNotification>;
  ApprovalDecision: ApprovalDecision;
  ApprovalRecord: ResolverTypeWrapper<ApprovalRecord>;
  AssignedItem: ResolverTypeWrapper<AssignedItem>;
  AssignedItemType: AssignedItemType;
  AutoExecuteError: ResolverTypeWrapper<AutoExecuteError>;
  AutoExecuteResult: ResolverTypeWrapper<AutoExecuteResult>;
  AutomationAction: ResolverTypeWrapper<AutomationAction>;
  AutomationActionMode: AutomationActionMode;
  AutomationAlert: ResolverTypeWrapper<AutomationAlert>;
  AutomationQueueHealth: ResolverTypeWrapper<AutomationQueueHealth>;
  BlockedReasonCategory: BlockedReasonCategory;
  BlockedSourceItem: ResolverTypeWrapper<BlockedSourceItem>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BoundedResult: ResolverTypeWrapper<BoundedResult>;
  BrandCandidate: ResolverTypeWrapper<BrandCandidate>;
  BrandDiscoveryInput: BrandDiscoveryInput;
  BrandDiscoveryResult: ResolverTypeWrapper<BrandDiscoveryResult>;
  BrandDiscoveryStatus: BrandDiscoveryStatus;
  BrandPalette: ResolverTypeWrapper<BrandPalette>;
  BrandPaletteInput: BrandPaletteInput;
  BrandProfileImpact: ResolverTypeWrapper<BrandProfileImpact>;
  BrandProfileStatus: BrandProfileStatus;
  BrandSelection: ResolverTypeWrapper<BrandSelection>;
  BrandTokenType: BrandTokenType;
  BrandTone: BrandTone;
  CaptureLeadInput: CaptureLeadInput;
  CaptureLeadResult: ResolverTypeWrapper<CaptureLeadResult>;
  ChatMessage: ResolverTypeWrapper<ChatMessage>;
  ChatRole: ChatRole;
  ClaimAnonymousRunResult: ResolverTypeWrapper<ClaimAnonymousRunResult>;
  ClaimPreviewResult: ResolverTypeWrapper<ClaimPreviewResult>;
  ClarifyingQuestion: ResolverTypeWrapper<ClarifyingQuestion>;
  ClarifyingQuestionInput: ClarifyingQuestionInput;
  ClassificationOverride: ResolverTypeWrapper<ClassificationOverride>;
  ClassificationResult: ResolverTypeWrapper<ClassificationResult>;
  ConfirmThreadResult: ResolverTypeWrapper<ConfirmThreadResult>;
  ConnectSessionResult: ResolverTypeWrapper<ConnectSessionResult>;
  ConnectionRequirement: ResolverTypeWrapper<ConnectionRequirement>;
  ConnectionRequirementReason: ConnectionRequirementReason;
  ConnectionStatus: ConnectionStatus;
  ConnectionTier: ConnectionTier;
  ConsentLevel: ConsentLevel;
  ContextRequirementOutput: ResolverTypeWrapper<ContextRequirementOutput>;
  Conversation: ResolverTypeWrapper<Conversation>;
  CrawledDocumentRef: ResolverTypeWrapper<CrawledDocumentRef>;
  CrawledPage: ResolverTypeWrapper<CrawledPage>;
  CreateActionItemInput: CreateActionItemInput;
  CreateIntakeRequestInput: CreateIntakeRequestInput;
  CreateIntakeRequestResult: ResolverTypeWrapper<CreateIntakeRequestResult>;
  CreateOrganizationBrandProfileInput: CreateOrganizationBrandProfileInput;
  CreatePilotInviteInput: CreatePilotInviteInput;
  CreatePlanFromTemplateInput: CreatePlanFromTemplateInput;
  CreateRequestThreadInput: CreateRequestThreadInput;
  CreateRequestThreadResult: ResolverTypeWrapper<CreateRequestThreadResult>;
  Deadline: ResolverTypeWrapper<Deadline>;
  DelegateToInput: DelegateToInput;
  DeleteSourceItemsResult: ResolverTypeWrapper<DeleteSourceItemsResult>;
  DependencyCitationRef: ResolverTypeWrapper<DependencyCitationRef>;
  DependencyGroupRef: ResolverTypeWrapper<DependencyGroupRef>;
  DependencySuggestionRef: ResolverTypeWrapper<DependencySuggestionRef>;
  DescriptionExtraction: ResolverTypeWrapper<DescriptionExtraction>;
  DocumentGroup: ResolverTypeWrapper<DocumentGroup>;
  DocumentGroupWithGuideStatus: ResolverTypeWrapper<DocumentGroupWithGuideStatus>;
  DomainFinding: ResolverTypeWrapper<DomainFinding>;
  DomainFindingInput: DomainFindingInput;
  DomainResearch: ResolverTypeWrapper<DomainResearch>;
  DomainResearchInput: DomainResearchInput;
  DriveFile: ResolverTypeWrapper<DriveFile>;
  EffortWeightedProgress: ResolverTypeWrapper<EffortWeightedProgress>;
  EnqueuedJob: ResolverTypeWrapper<EnqueuedJob>;
  EvalCaseExpected: ResolverTypeWrapper<EvalCaseExpected>;
  EvalCaseResult: ResolverTypeWrapper<EvalCaseResult>;
  EvalExpected: ResolverTypeWrapper<EvalExpected>;
  EvalExpectedInput: EvalExpectedInput;
  EvalFieldAccuracy: ResolverTypeWrapper<EvalFieldAccuracy>;
  EvalFieldAccuracyReport: ResolverTypeWrapper<EvalFieldAccuracyReport>;
  EvalPrompt: ResolverTypeWrapper<EvalPrompt>;
  EvalPromptScore: ResolverTypeWrapper<EvalPromptScore>;
  EvalReport: ResolverTypeWrapper<EvalReport>;
  EvalReportSummary: ResolverTypeWrapper<EvalReportSummary>;
  EvalTestCase: ResolverTypeWrapper<EvalTestCase>;
  ExecuteStepResult: ResolverTypeWrapper<ExecuteStepResult>;
  ExecutionError: ResolverTypeWrapper<ExecutionError>;
  ExecutionResult: ResolverTypeWrapper<ExecutionResult>;
  ExecutionResultStatus: ExecutionResultStatus;
  ExpandStepInput: ExpandStepInput;
  ExtractionMetadata: ResolverTypeWrapper<ExtractionMetadata>;
  ExtractionStatus: ExtractionStatus;
  FactConstraint: ResolverTypeWrapper<FactConstraint>;
  FaqBlock: ResolverTypeWrapper<FaqBlock>;
  FeaturedGuide: ResolverTypeWrapper<FeaturedGuide>;
  FileUploadUrl: ResolverTypeWrapper<FileUploadUrl>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FuzzyPlanContext: ResolverTypeWrapper<FuzzyPlanContext>;
  GenerateGuideFromGroupResult: ResolverTypeWrapper<GenerateGuideFromGroupResult>;
  GeneratePlanInput: GeneratePlanInput;
  GenerationSource: ResolverTypeWrapper<GenerationSource>;
  GenerationStatus: GenerationStatus;
  GlobalParticipant: ResolverTypeWrapper<GlobalParticipant>;
  GoalInterpretation: ResolverTypeWrapper<GoalInterpretation>;
  GoalInterpretationInput: GoalInterpretationInput;
  GroupMembership: ResolverTypeWrapper<GroupMembership>;
  GroupSuggestion: ResolverTypeWrapper<GroupSuggestion>;
  GroupType: GroupType;
  Guardrail: ResolverTypeWrapper<Guardrail>;
  GuardrailInput: GuardrailInput;
  GuideBrandMode: GuideBrandMode;
  GuideCitation: ResolverTypeWrapper<GuideCitation>;
  GuideEditData: ResolverTypeWrapper<GuideEditData>;
  GuideLanding: ResolverTypeWrapper<GuideLanding>;
  GuideStarterInfo: ResolverTypeWrapper<GuideStarterInfo>;
  GuideStep: ResolverTypeWrapper<GuideStep>;
  GuideTheme: ResolverTypeWrapper<GuideTheme>;
  GuideThemeInput: GuideThemeInput;
  GuideThemeOverrides: ResolverTypeWrapper<GuideThemeOverrides>;
  GuideThemeOverridesInput: GuideThemeOverridesInput;
  GuideVersion: ResolverTypeWrapper<GuideVersion>;
  GuideVersionFile: ResolverTypeWrapper<GuideVersionFile>;
  GuideVersionOutput: ResolverTypeWrapper<GuideVersionOutput>;
  GuideVersionStatus: GuideVersionStatus;
  HiddenStepSummary: ResolverTypeWrapper<HiddenStepSummary>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntakeFileRef: ResolverTypeWrapper<IntakeFileRef>;
  IntakeFileUploadUrl: ResolverTypeWrapper<IntakeFileUploadUrl>;
  IntakeMode: IntakeMode;
  IntakePublicData: ResolverTypeWrapper<IntakePublicData>;
  IntakeRequest: ResolverTypeWrapper<IntakeRequest>;
  IntakeStatus: IntakeStatus;
  IntakeSubmission: ResolverTypeWrapper<IntakeSubmission>;
  IntakeSubmitInput: IntakeSubmitInput;
  IntakeSubmitResult: ResolverTypeWrapper<IntakeSubmitResult>;
  IntegrationCatalogEntry: ResolverTypeWrapper<IntegrationCatalogEntry>;
  IntegrationConnection: ResolverTypeWrapper<IntegrationConnection>;
  InviteStatus: InviteStatus;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  Job: ResolverTypeWrapper<Job>;
  JobEvent: ResolverTypeWrapper<JobEvent>;
  JobStage: JobStage;
  JobState: JobState;
  JobStatus: JobStatus;
  JobType: JobType;
  JourneyMagicLinkConsumption: ResolverTypeWrapper<JourneyMagicLinkConsumption>;
  JourneyMagicLinkValidation: ResolverTypeWrapper<JourneyMagicLinkValidation>;
  JourneyRole: ResolverTypeWrapper<JourneyRole>;
  LeadSource: LeadSource;
  LinkedPageRef: ResolverTypeWrapper<LinkedPageRef>;
  LocationInput: LocationInput;
  LoginMagicLinkResult: ResolverTypeWrapper<LoginMagicLinkResult>;
  LoginMagicLinkValidationResult: ResolverTypeWrapper<LoginMagicLinkValidationResult>;
  MagicLinkValidationResult: ResolverTypeWrapper<MagicLinkValidationResult>;
  MessageRecipientInput: MessageRecipientInput;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NotificationPreferences: ResolverTypeWrapper<NotificationPreferences>;
  OpenRouterModelPricing: ResolverTypeWrapper<OpenRouterModelPricing>;
  OperationsSimulatorPayloadInput: OperationsSimulatorPayloadInput;
  OrgAuditEntry: ResolverTypeWrapper<OrgAuditEntry>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationBrandProfile: ResolverTypeWrapper<OrganizationBrandProfile>;
  OrganizationBrandingSettings: ResolverTypeWrapper<OrganizationBrandingSettings>;
  OrganizationMembership: ResolverTypeWrapper<OrganizationMembership>;
  OutputContract: ResolverTypeWrapper<OutputContract>;
  OutputContractInput: OutputContractInput;
  Participant: ResolverTypeWrapper<Participant>;
  ParticipantAccessLevel: ParticipantAccessLevel;
  ParticipantInput: ParticipantInput;
  ParticipantRole: ParticipantRole;
  ParticipantStep: ResolverTypeWrapper<ParticipantStep>;
  ParticipantWorkspaceView: ResolverTypeWrapper<ParticipantWorkspaceView>;
  Person: ResolverTypeWrapper<Person>;
  PersonProfile: ResolverTypeWrapper<PersonProfile>;
  PhaseContext: ResolverTypeWrapper<PhaseContext>;
  PhaseProgress: ResolverTypeWrapper<PhaseProgress>;
  PhaseSummary: ResolverTypeWrapper<PhaseSummary>;
  PilotBreakdownPoint: ResolverTypeWrapper<PilotBreakdownPoint>;
  PilotDashboardOverview: ResolverTypeWrapper<PilotDashboardOverview>;
  PilotDateRangeInput: PilotDateRangeInput;
  PilotEvent: ResolverTypeWrapper<PilotEvent>;
  PilotEventInput: PilotEventInput;
  PilotFunnelStage: ResolverTypeWrapper<PilotFunnelStage>;
  PilotInvite: ResolverTypeWrapper<PilotInvite>;
  PilotInviteAudience: PilotInviteAudience;
  PilotInviteStatus: PilotInviteStatus;
  PilotKpiTile: ResolverTypeWrapper<PilotKpiTile>;
  PilotLeadAdmin: ResolverTypeWrapper<PilotLeadAdmin>;
  PilotLeadInput: PilotLeadInput;
  PilotLeadKind: PilotLeadKind;
  PilotLeadResult: ResolverTypeWrapper<PilotLeadResult>;
  PilotSession: ResolverTypeWrapper<PilotSession>;
  PilotSortDirection: PilotSortDirection;
  PilotTimeSeriesPoint: ResolverTypeWrapper<PilotTimeSeriesPoint>;
  PilotVisitor: ResolverTypeWrapper<PilotVisitor>;
  PilotVisitorAttribution: ResolverTypeWrapper<PilotVisitorAttribution>;
  PilotVisitorFilterInput: PilotVisitorFilterInput;
  PilotVisitorIdentifyInput: PilotVisitorIdentifyInput;
  PilotVisitorIdentity: ResolverTypeWrapper<PilotVisitorIdentity>;
  PilotVisitorListResult: ResolverTypeWrapper<PilotVisitorListResult>;
  PilotVisitorSortField: PilotVisitorSortField;
  PilotVisitorSortInput: PilotVisitorSortInput;
  PilotVisitorStage: PilotVisitorStage;
  Plan: ResolverTypeWrapper<Plan>;
  PlanAnalysisResult: ResolverTypeWrapper<PlanAnalysisResult>;
  PlanAnalysisResultInput: PlanAnalysisResultInput;
  PlanArtifact: ResolverTypeWrapper<PlanArtifact>;
  PlanEvaluation: ResolverTypeWrapper<PlanEvaluation>;
  PlanEvent: ResolverTypeWrapper<PlanEvent>;
  PlanListItem: ResolverTypeWrapper<PlanListItem>;
  PlanPhase: ResolverTypeWrapper<PlanPhase>;
  PlanRole: ResolverTypeWrapper<PlanRole>;
  PlanRoleInput: PlanRoleInput;
  PlanStatus: PlanStatus;
  PlanStep: ResolverTypeWrapper<PlanStep>;
  PlansSummary: ResolverTypeWrapper<PlansSummary>;
  PlatformIntegrationStatus: ResolverTypeWrapper<PlatformIntegrationStatus>;
  PostThreadMessageInput: PostThreadMessageInput;
  PostThreadMessageResult: ResolverTypeWrapper<PostThreadMessageResult>;
  PreviewOutline: ResolverTypeWrapper<PreviewOutline>;
  PreviewOutlineStep: ResolverTypeWrapper<PreviewOutlineStep>;
  PreviewPlanResult: ResolverTypeWrapper<PreviewPlanResult>;
  ProjectedPlanView: ResolverTypeWrapper<ProjectedPlanView>;
  PromoteOrganizationBrandProfileInput: PromoteOrganizationBrandProfileInput;
  PrunedTrigger: ResolverTypeWrapper<PrunedTrigger>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  QueueJobStatus: ResolverTypeWrapper<QueueJobStatus>;
  ReflowSuggestion: ResolverTypeWrapper<ReflowSuggestion>;
  RequestPilotInviteByEmailResult: ResolverTypeWrapper<RequestPilotInviteByEmailResult>;
  RequestSpec: ResolverTypeWrapper<RequestSpec>;
  RequestSpecInput: RequestSpecInput;
  RequestThread: ResolverTypeWrapper<RequestThread>;
  RequestThreadPublicData: ResolverTypeWrapper<RequestThreadPublicData>;
  RequestThreadStatus: RequestThreadStatus;
  RequestUIMode: RequestUiMode;
  RequiredItem: ResolverTypeWrapper<RequiredItem>;
  RequiredItemCategory: RequiredItemCategory;
  RequiredItemStatus: RequiredItemStatus;
  ResolvedGuideTheme: ResolverTypeWrapper<ResolvedGuideTheme>;
  ReviewStatus: ReviewStatus;
  RoiCalculatorPayloadInput: RoiCalculatorPayloadInput;
  SatisfactionState: ResolverTypeWrapper<SatisfactionState>;
  ScoreBreakdown: ResolverTypeWrapper<ScoreBreakdown>;
  SendChatMessageInput: SendChatMessageInput;
  SendChatMessageResponse: ResolverTypeWrapper<SendChatMessageResponse>;
  SendMessageResult: ResolverTypeWrapper<SendMessageResult>;
  SendMessageToRecipientInput: SendMessageToRecipientInput;
  SkillRef: ResolverTypeWrapper<SkillRef>;
  SkillSource: SkillSource;
  SlugAvailability: ResolverTypeWrapper<SlugAvailability>;
  SourceAnalysisResult: ResolverTypeWrapper<SourceAnalysisResult>;
  SourceItem: ResolverTypeWrapper<SourceItem>;
  SourceItemConnection: ResolverTypeWrapper<SourceItemConnection>;
  SourceItemDependency: ResolverTypeWrapper<SourceItemDependency>;
  SourceItemEdge: ResolverTypeWrapper<SourceItemEdge>;
  SourceItemFilter: SourceItemFilter;
  SourceItemLinkedPage: ResolverTypeWrapper<SourceItemLinkedPage>;
  SourceItemPageInfo: ResolverTypeWrapper<SourceItemPageInfo>;
  SourceItemTreeNode: ResolverTypeWrapper<SourceItemTreeNode>;
  SourceLocator: ResolverTypeWrapper<SourceLocator>;
  StartJobResult: ResolverTypeWrapper<StartJobResult>;
  StartJourneyResult: ResolverTypeWrapper<StartJourneyResult>;
  StatusBucket: StatusBucket;
  StatusBucketCounts: ResolverTypeWrapper<StatusBucketCounts>;
  StatusCounts: ResolverTypeWrapper<StatusCounts>;
  StepAllowedField: ResolverTypeWrapper<StepAllowedField>;
  StepAnalysisResult: ResolverTypeWrapper<StepAnalysisResult>;
  StepApplicability: ResolverTypeWrapper<StepApplicability>;
  StepAssessment: ResolverTypeWrapper<StepAssessment>;
  StepAutoAction: ResolverTypeWrapper<StepAutoAction>;
  StepAutoActionType: StepAutoActionType;
  StepBlockedInfo: ResolverTypeWrapper<StepBlockedInfo>;
  StepCapabilities: ResolverTypeWrapper<StepCapabilities>;
  StepContext: ResolverTypeWrapper<StepContext>;
  StepContextInput: StepContextInput;
  StepDependency: ResolverTypeWrapper<StepDependency>;
  StepDependencyStatus: ResolverTypeWrapper<StepDependencyStatus>;
  StepIntakeData: ResolverTypeWrapper<StepIntakeData>;
  StepIntent: StepIntent;
  StepKind: StepKind;
  StepProgress: ResolverTypeWrapper<StepProgress>;
  StepRequestThread: ResolverTypeWrapper<StepRequestThread>;
  StepStatus: StepStatus;
  StepStatusEvent: ResolverTypeWrapper<StepStatusEvent>;
  StepStatusReason: StepStatusReason;
  StepThreadResult: ResolverTypeWrapper<StepThreadResult>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StructuredProgress: ResolverTypeWrapper<StructuredProgress>;
  SuggestedNextActions: ResolverTypeWrapper<SuggestedNextActions>;
  SuggestedSaaS: ResolverTypeWrapper<SuggestedSaaS>;
  ThreadAccessMode: ThreadAccessMode;
  ThreadMessage: ResolverTypeWrapper<ThreadMessage>;
  ThreadUpload: ResolverTypeWrapper<ThreadUpload>;
  TrackPilotEventsResult: ResolverTypeWrapper<TrackPilotEventsResult>;
  UpdateActionItemInput: UpdateActionItemInput;
  UpdateOrganizationBrandProfileInput: UpdateOrganizationBrandProfileInput;
  UpdateParticipantInput: UpdateParticipantInput;
  UpdatePersonInput: UpdatePersonInput;
  UpdatePilotInviteInput: UpdatePilotInviteInput;
  UpdatePlanRoleInput: UpdatePlanRoleInput;
  UpdateThreadFieldsInput: UpdateThreadFieldsInput;
  UpdateThreadFieldsResult: ResolverTypeWrapper<UpdateThreadFieldsResult>;
  UserContextInput: UserContextInput;
  ValidatePilotInviteResult: ResolverTypeWrapper<ValidatePilotInviteResult>;
  VerificationStrategy: VerificationStrategy;
  WebCrawl: ResolverTypeWrapper<WebCrawl>;
  WorkspaceRole: ResolverTypeWrapper<WorkspaceRole>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActionItem: ActionItem;
  ActiveOrgResult: ActiveOrgResult;
  AddGlobalParticipantInput: AddGlobalParticipantInput;
  AdminLead: AdminLead;
  AllowedField: AllowedField;
  AllowedFieldInput: AllowedFieldInput;
  AnalyzePlanGoalInput: AnalyzePlanGoalInput;
  AnonymousRunSession: AnonymousRunSession;
  AppNotification: AppNotification;
  ApprovalRecord: ApprovalRecord;
  AssignedItem: AssignedItem;
  AutoExecuteError: AutoExecuteError;
  AutoExecuteResult: AutoExecuteResult;
  AutomationAction: AutomationAction;
  AutomationAlert: AutomationAlert;
  AutomationQueueHealth: AutomationQueueHealth;
  BlockedSourceItem: BlockedSourceItem;
  Boolean: Scalars['Boolean']['output'];
  BoundedResult: BoundedResult;
  BrandCandidate: BrandCandidate;
  BrandDiscoveryInput: BrandDiscoveryInput;
  BrandDiscoveryResult: BrandDiscoveryResult;
  BrandPalette: BrandPalette;
  BrandPaletteInput: BrandPaletteInput;
  BrandProfileImpact: BrandProfileImpact;
  BrandSelection: BrandSelection;
  CaptureLeadInput: CaptureLeadInput;
  CaptureLeadResult: CaptureLeadResult;
  ChatMessage: ChatMessage;
  ClaimAnonymousRunResult: ClaimAnonymousRunResult;
  ClaimPreviewResult: ClaimPreviewResult;
  ClarifyingQuestion: ClarifyingQuestion;
  ClarifyingQuestionInput: ClarifyingQuestionInput;
  ClassificationOverride: ClassificationOverride;
  ClassificationResult: ClassificationResult;
  ConfirmThreadResult: ConfirmThreadResult;
  ConnectSessionResult: ConnectSessionResult;
  ConnectionRequirement: ConnectionRequirement;
  ContextRequirementOutput: ContextRequirementOutput;
  Conversation: Conversation;
  CrawledDocumentRef: CrawledDocumentRef;
  CrawledPage: CrawledPage;
  CreateActionItemInput: CreateActionItemInput;
  CreateIntakeRequestInput: CreateIntakeRequestInput;
  CreateIntakeRequestResult: CreateIntakeRequestResult;
  CreateOrganizationBrandProfileInput: CreateOrganizationBrandProfileInput;
  CreatePilotInviteInput: CreatePilotInviteInput;
  CreatePlanFromTemplateInput: CreatePlanFromTemplateInput;
  CreateRequestThreadInput: CreateRequestThreadInput;
  CreateRequestThreadResult: CreateRequestThreadResult;
  Deadline: Deadline;
  DelegateToInput: DelegateToInput;
  DeleteSourceItemsResult: DeleteSourceItemsResult;
  DependencyCitationRef: DependencyCitationRef;
  DependencyGroupRef: DependencyGroupRef;
  DependencySuggestionRef: DependencySuggestionRef;
  DescriptionExtraction: DescriptionExtraction;
  DocumentGroup: DocumentGroup;
  DocumentGroupWithGuideStatus: DocumentGroupWithGuideStatus;
  DomainFinding: DomainFinding;
  DomainFindingInput: DomainFindingInput;
  DomainResearch: DomainResearch;
  DomainResearchInput: DomainResearchInput;
  DriveFile: DriveFile;
  EffortWeightedProgress: EffortWeightedProgress;
  EnqueuedJob: EnqueuedJob;
  EvalCaseExpected: EvalCaseExpected;
  EvalCaseResult: EvalCaseResult;
  EvalExpected: EvalExpected;
  EvalExpectedInput: EvalExpectedInput;
  EvalFieldAccuracy: EvalFieldAccuracy;
  EvalFieldAccuracyReport: EvalFieldAccuracyReport;
  EvalPrompt: EvalPrompt;
  EvalPromptScore: EvalPromptScore;
  EvalReport: EvalReport;
  EvalReportSummary: EvalReportSummary;
  EvalTestCase: EvalTestCase;
  ExecuteStepResult: ExecuteStepResult;
  ExecutionError: ExecutionError;
  ExecutionResult: ExecutionResult;
  ExpandStepInput: ExpandStepInput;
  ExtractionMetadata: ExtractionMetadata;
  FactConstraint: FactConstraint;
  FaqBlock: FaqBlock;
  FeaturedGuide: FeaturedGuide;
  FileUploadUrl: FileUploadUrl;
  Float: Scalars['Float']['output'];
  FuzzyPlanContext: FuzzyPlanContext;
  GenerateGuideFromGroupResult: GenerateGuideFromGroupResult;
  GeneratePlanInput: GeneratePlanInput;
  GenerationSource: GenerationSource;
  GlobalParticipant: GlobalParticipant;
  GoalInterpretation: GoalInterpretation;
  GoalInterpretationInput: GoalInterpretationInput;
  GroupMembership: GroupMembership;
  GroupSuggestion: GroupSuggestion;
  Guardrail: Guardrail;
  GuardrailInput: GuardrailInput;
  GuideCitation: GuideCitation;
  GuideEditData: GuideEditData;
  GuideLanding: GuideLanding;
  GuideStarterInfo: GuideStarterInfo;
  GuideStep: GuideStep;
  GuideTheme: GuideTheme;
  GuideThemeInput: GuideThemeInput;
  GuideThemeOverrides: GuideThemeOverrides;
  GuideThemeOverridesInput: GuideThemeOverridesInput;
  GuideVersion: GuideVersion;
  GuideVersionFile: GuideVersionFile;
  GuideVersionOutput: GuideVersionOutput;
  HiddenStepSummary: HiddenStepSummary;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  IntakeFileRef: IntakeFileRef;
  IntakeFileUploadUrl: IntakeFileUploadUrl;
  IntakePublicData: IntakePublicData;
  IntakeRequest: IntakeRequest;
  IntakeSubmission: IntakeSubmission;
  IntakeSubmitInput: IntakeSubmitInput;
  IntakeSubmitResult: IntakeSubmitResult;
  IntegrationCatalogEntry: IntegrationCatalogEntry;
  IntegrationConnection: IntegrationConnection;
  JSON: Scalars['JSON']['output'];
  JSONObject: Scalars['JSONObject']['output'];
  Job: Job;
  JobEvent: JobEvent;
  JourneyMagicLinkConsumption: JourneyMagicLinkConsumption;
  JourneyMagicLinkValidation: JourneyMagicLinkValidation;
  JourneyRole: JourneyRole;
  LinkedPageRef: LinkedPageRef;
  LocationInput: LocationInput;
  LoginMagicLinkResult: LoginMagicLinkResult;
  LoginMagicLinkValidationResult: LoginMagicLinkValidationResult;
  MagicLinkValidationResult: MagicLinkValidationResult;
  MessageRecipientInput: MessageRecipientInput;
  Mutation: Record<PropertyKey, never>;
  NotificationPreferences: NotificationPreferences;
  OpenRouterModelPricing: OpenRouterModelPricing;
  OperationsSimulatorPayloadInput: OperationsSimulatorPayloadInput;
  OrgAuditEntry: OrgAuditEntry;
  Organization: Organization;
  OrganizationBrandProfile: OrganizationBrandProfile;
  OrganizationBrandingSettings: OrganizationBrandingSettings;
  OrganizationMembership: OrganizationMembership;
  OutputContract: OutputContract;
  OutputContractInput: OutputContractInput;
  Participant: Participant;
  ParticipantInput: ParticipantInput;
  ParticipantStep: ParticipantStep;
  ParticipantWorkspaceView: ParticipantWorkspaceView;
  Person: Person;
  PersonProfile: PersonProfile;
  PhaseContext: PhaseContext;
  PhaseProgress: PhaseProgress;
  PhaseSummary: PhaseSummary;
  PilotBreakdownPoint: PilotBreakdownPoint;
  PilotDashboardOverview: PilotDashboardOverview;
  PilotDateRangeInput: PilotDateRangeInput;
  PilotEvent: PilotEvent;
  PilotEventInput: PilotEventInput;
  PilotFunnelStage: PilotFunnelStage;
  PilotInvite: PilotInvite;
  PilotKpiTile: PilotKpiTile;
  PilotLeadAdmin: PilotLeadAdmin;
  PilotLeadInput: PilotLeadInput;
  PilotLeadResult: PilotLeadResult;
  PilotSession: PilotSession;
  PilotTimeSeriesPoint: PilotTimeSeriesPoint;
  PilotVisitor: PilotVisitor;
  PilotVisitorAttribution: PilotVisitorAttribution;
  PilotVisitorFilterInput: PilotVisitorFilterInput;
  PilotVisitorIdentifyInput: PilotVisitorIdentifyInput;
  PilotVisitorIdentity: PilotVisitorIdentity;
  PilotVisitorListResult: PilotVisitorListResult;
  PilotVisitorSortInput: PilotVisitorSortInput;
  Plan: Plan;
  PlanAnalysisResult: PlanAnalysisResult;
  PlanAnalysisResultInput: PlanAnalysisResultInput;
  PlanArtifact: PlanArtifact;
  PlanEvaluation: PlanEvaluation;
  PlanEvent: PlanEvent;
  PlanListItem: PlanListItem;
  PlanPhase: PlanPhase;
  PlanRole: PlanRole;
  PlanRoleInput: PlanRoleInput;
  PlanStep: PlanStep;
  PlansSummary: PlansSummary;
  PlatformIntegrationStatus: PlatformIntegrationStatus;
  PostThreadMessageInput: PostThreadMessageInput;
  PostThreadMessageResult: PostThreadMessageResult;
  PreviewOutline: PreviewOutline;
  PreviewOutlineStep: PreviewOutlineStep;
  PreviewPlanResult: PreviewPlanResult;
  ProjectedPlanView: ProjectedPlanView;
  PromoteOrganizationBrandProfileInput: PromoteOrganizationBrandProfileInput;
  PrunedTrigger: PrunedTrigger;
  Query: Record<PropertyKey, never>;
  QueueJobStatus: QueueJobStatus;
  ReflowSuggestion: ReflowSuggestion;
  RequestPilotInviteByEmailResult: RequestPilotInviteByEmailResult;
  RequestSpec: RequestSpec;
  RequestSpecInput: RequestSpecInput;
  RequestThread: RequestThread;
  RequestThreadPublicData: RequestThreadPublicData;
  RequiredItem: RequiredItem;
  ResolvedGuideTheme: ResolvedGuideTheme;
  RoiCalculatorPayloadInput: RoiCalculatorPayloadInput;
  SatisfactionState: SatisfactionState;
  ScoreBreakdown: ScoreBreakdown;
  SendChatMessageInput: SendChatMessageInput;
  SendChatMessageResponse: SendChatMessageResponse;
  SendMessageResult: SendMessageResult;
  SendMessageToRecipientInput: SendMessageToRecipientInput;
  SkillRef: SkillRef;
  SlugAvailability: SlugAvailability;
  SourceAnalysisResult: SourceAnalysisResult;
  SourceItem: SourceItem;
  SourceItemConnection: SourceItemConnection;
  SourceItemDependency: SourceItemDependency;
  SourceItemEdge: SourceItemEdge;
  SourceItemFilter: SourceItemFilter;
  SourceItemLinkedPage: SourceItemLinkedPage;
  SourceItemPageInfo: SourceItemPageInfo;
  SourceItemTreeNode: SourceItemTreeNode;
  SourceLocator: SourceLocator;
  StartJobResult: StartJobResult;
  StartJourneyResult: StartJourneyResult;
  StatusBucketCounts: StatusBucketCounts;
  StatusCounts: StatusCounts;
  StepAllowedField: StepAllowedField;
  StepAnalysisResult: StepAnalysisResult;
  StepApplicability: StepApplicability;
  StepAssessment: StepAssessment;
  StepAutoAction: StepAutoAction;
  StepBlockedInfo: StepBlockedInfo;
  StepCapabilities: StepCapabilities;
  StepContext: StepContext;
  StepContextInput: StepContextInput;
  StepDependency: StepDependency;
  StepDependencyStatus: StepDependencyStatus;
  StepIntakeData: StepIntakeData;
  StepProgress: StepProgress;
  StepRequestThread: StepRequestThread;
  StepStatusEvent: StepStatusEvent;
  StepThreadResult: StepThreadResult;
  String: Scalars['String']['output'];
  StructuredProgress: StructuredProgress;
  SuggestedNextActions: SuggestedNextActions;
  SuggestedSaaS: SuggestedSaaS;
  ThreadMessage: ThreadMessage;
  ThreadUpload: ThreadUpload;
  TrackPilotEventsResult: TrackPilotEventsResult;
  UpdateActionItemInput: UpdateActionItemInput;
  UpdateOrganizationBrandProfileInput: UpdateOrganizationBrandProfileInput;
  UpdateParticipantInput: UpdateParticipantInput;
  UpdatePersonInput: UpdatePersonInput;
  UpdatePilotInviteInput: UpdatePilotInviteInput;
  UpdatePlanRoleInput: UpdatePlanRoleInput;
  UpdateThreadFieldsInput: UpdateThreadFieldsInput;
  UpdateThreadFieldsResult: UpdateThreadFieldsResult;
  UserContextInput: UserContextInput;
  ValidatePilotInviteResult: ValidatePilotInviteResult;
  WebCrawl: WebCrawl;
  WorkspaceRole: WorkspaceRole;
};

export type ActionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionItem'] = ResolversParentTypes['ActionItem']> = {
  createdDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastMentioned?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ActiveOrgResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveOrgResult'] = ResolversParentTypes['ActiveOrgResult']> = {
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminLeadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminLead'] = ResolversParentTypes['AdminLead']> = {
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<Maybe<ResolversTypes['PilotLeadKind']>, ParentType, ContextType>;
  linkedin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ops?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  opsOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['LeadSource']>, ParentType, ContextType>;
  stack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AllowedFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllowedField'] = ResolversParentTypes['AllowedField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enumValues?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AllowedFieldType'], ParentType, ContextType>;
};

export type AnonymousRunSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnonymousRunSession'] = ResolversParentTypes['AnonymousRunSession']> = {
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  principalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  runId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AppNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppNotification'] = ResolversParentTypes['AppNotification']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ApprovalRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApprovalRecord'] = ResolversParentTypes['ApprovalRecord']> = {
  approverEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approverName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approverUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decidedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decision?: Resolver<ResolversTypes['ApprovalDecision'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AssignedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignedItem'] = ResolversParentTypes['AssignedItem']> = {
  assignedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemType?: Resolver<ResolversTypes['AssignedItemType'], ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  planTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StepStatus'], ParentType, ContextType>;
  stepTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AutoExecuteErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoExecuteError'] = ResolversParentTypes['AutoExecuteError']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AutoExecuteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoExecuteResult'] = ResolversParentTypes['AutoExecuteResult']> = {
  errors?: Resolver<Array<ResolversTypes['AutoExecuteError']>, ParentType, ContextType>;
  executed?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  skipped?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type AutomationActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomationAction'] = ResolversParentTypes['AutomationAction']> = {
  agentConfig?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  agentProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bodyTemplate?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headersTemplate?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['AutomationActionMode'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paramsTemplate?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  promptTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeoutMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toolRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AutomationAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomationAlert'] = ResolversParentTypes['AutomationAlert']> = {
  acknowledged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  acknowledgedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  planId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stepId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AutomationQueueHealthResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomationQueueHealth'] = ResolversParentTypes['AutomationQueueHealth']> = {
  active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deadLetter?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  delayed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  waiting?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type BlockedSourceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockedSourceItem'] = ResolversParentTypes['BlockedSourceItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BoundedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BoundedResult'] = ResolversParentTypes['BoundedResult']> = {
  attachmentIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BrandCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandCandidate'] = ResolversParentTypes['BrandCandidate']> = {
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dedupeHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rationale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenType?: Resolver<ResolversTypes['BrandTokenType'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BrandDiscoveryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandDiscoveryResult'] = ResolversParentTypes['BrandDiscoveryResult']> = {
  brandCandidates?: Resolver<Array<ResolversTypes['BrandCandidate']>, ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  discoveredAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selectedCandidates?: Resolver<Maybe<ResolversTypes['BrandSelection']>, ParentType, ContextType>;
  sourceArtifacts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BrandDiscoveryStatus'], ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BrandPaletteResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandPalette'] = ResolversParentTypes['BrandPalette']> = {
  background?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surface?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BrandProfileImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandProfileImpact'] = ResolversParentTypes['BrandProfileImpact']> = {
  migratableGuideIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  orgDefaultGuideCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pinnedImportProfileGuideCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type BrandSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandSelection'] = ResolversParentTypes['BrandSelection']> = {
  headerLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tone?: Resolver<Maybe<ResolversTypes['BrandTone']>, ParentType, ContextType>;
};

export type CaptureLeadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaptureLeadResult'] = ResolversParentTypes['CaptureLeadResult']> = {
  leadId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ChatMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessage'] = ResolversParentTypes['ChatMessage']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contextSnapshot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['ChatRole'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClaimAnonymousRunResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClaimAnonymousRunResult'] = ResolversParentTypes['ClaimAnonymousRunResult']> = {
  claimedPrincipalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newOwnerPrincipalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transferredConnectionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ClaimPreviewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClaimPreviewResult'] = ResolversParentTypes['ClaimPreviewResult']> = {
  generationJobId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  magicLinkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ClarifyingQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClarifyingQuestion'] = ResolversParentTypes['ClarifyingQuestion']> = {
  choices?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  defaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  why?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClassificationOverrideResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClassificationOverride'] = ResolversParentTypes['ClassificationOverride']> = {
  isProcess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  setAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  setBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClassificationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClassificationResult'] = ResolversParentTypes['ClassificationResult']> = {
  classifiedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  doc_type_hint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  is_process?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  needs_fallback?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  references_process?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  signals?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  wave?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ConfirmThreadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmThreadResult'] = ResolversParentTypes['ConfirmThreadResult']> = {
  parentStepUpdated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestThread?: Resolver<ResolversTypes['RequestThread'], ParentType, ContextType>;
  result?: Resolver<ResolversTypes['BoundedResult'], ParentType, ContextType>;
};

export type ConnectSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectSessionResult'] = ResolversParentTypes['ConnectSessionResult']> = {
  connectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ConnectionRequirementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionRequirement'] = ResolversParentTypes['ConnectionRequirement']> = {
  allowedTiers?: Resolver<Array<ResolversTypes['ConnectionTier']>, ParentType, ContextType>;
  consumerPitch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTier?: Resolver<ResolversTypes['ConnectionTier'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['ConnectionRequirementReason'], ParentType, ContextType>;
};

export type ContextRequirementOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContextRequirementOutput'] = ResolversParentTypes['ContextRequirementOutput']> = {
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ConversationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Conversation'] = ResolversParentTypes['Conversation']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ChatMessage']>, ParentType, ContextType>;
  planId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CrawledDocumentRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrawledDocumentRef'] = ResolversParentTypes['CrawledDocumentRef']> = {
  downloadStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedFromPages?: Resolver<Array<ResolversTypes['LinkedPageRef']>, ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizeBytes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceItemId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CrawledPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrawledPage'] = ResolversParentTypes['CrawledPage']> = {
  contentPreview?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  crawlId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  crawledAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['CrawledDocumentRef']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  links?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CreateIntakeRequestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateIntakeRequestResult'] = ResolversParentTypes['CreateIntakeRequestResult']> = {
  intakeRequest?: Resolver<ResolversTypes['IntakeRequest'], ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CreateRequestThreadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRequestThreadResult'] = ResolversParentTypes['CreateRequestThreadResult']> = {
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestThread?: Resolver<ResolversTypes['RequestThread'], ParentType, ContextType>;
};

export type DeadlineResolvers<ContextType = any, ParentType extends ResolversParentTypes['Deadline'] = ResolversParentTypes['Deadline']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DeleteSourceItemsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSourceItemsResult'] = ResolversParentTypes['DeleteSourceItemsResult']> = {
  blockedItems?: Resolver<Array<ResolversTypes['BlockedSourceItem']>, ParentType, ContextType>;
  deletedIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type DependencyCitationRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['DependencyCitationRef'] = ResolversParentTypes['DependencyCitationRef']> = {
  guideId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type DependencyGroupRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['DependencyGroupRef'] = ResolversParentTypes['DependencyGroupRef']> = {
  groupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  groupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DependencySuggestionRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['DependencySuggestionRef'] = ResolversParentTypes['DependencySuggestionRef']> = {
  suggestionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  suggestionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DescriptionExtractionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DescriptionExtraction'] = ResolversParentTypes['DescriptionExtraction']> = {
  hasItems?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DocumentGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentGroup'] = ResolversParentTypes['DocumentGroup']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupType?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  linkedGuide?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['GroupMembership']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  versionHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DocumentGroupWithGuideStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentGroupWithGuideStatus'] = ResolversParentTypes['DocumentGroupWithGuideStatus']> = {
  generatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  group?: Resolver<ResolversTypes['DocumentGroup'], ParentType, ContextType>;
  isOutOfDate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedGuide?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType>;
};

export type DomainFindingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainFinding'] = ResolversParentTypes['DomainFinding']> = {
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  details?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DomainResearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainResearch'] = ResolversParentTypes['DomainResearch']> = {
  findings?: Resolver<Array<ResolversTypes['DomainFinding']>, ParentType, ContextType>;
  generatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  searchQueries?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  sources?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DriveFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['DriveFile'] = ResolversParentTypes['DriveFile']> = {
  iconLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modifiedTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webViewLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type EffortWeightedProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['EffortWeightedProgress'] = ResolversParentTypes['EffortWeightedProgress']> = {
  rationale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type EnqueuedJobResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnqueuedJob'] = ResolversParentTypes['EnqueuedJob']> = {
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobState'], ParentType, ContextType>;
};

export type EvalCaseExpectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalCaseExpected'] = ResolversParentTypes['EvalCaseExpected']> = {
  audience?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  guideable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvalCaseResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalCaseResult'] = ResolversParentTypes['EvalCaseResult']> = {
  actual?: Resolver<ResolversTypes['EvalCaseExpected'], ParentType, ContextType>;
  diffs?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  expected?: Resolver<ResolversTypes['EvalCaseExpected'], ParentType, ContextType>;
  pass?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceItemTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  testCaseId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvalExpectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalExpected'] = ResolversParentTypes['EvalExpected']> = {
  audience?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  guideable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvalFieldAccuracyResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalFieldAccuracy'] = ResolversParentTypes['EvalFieldAccuracy']> = {
  correct?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type EvalFieldAccuracyReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalFieldAccuracyReport'] = ResolversParentTypes['EvalFieldAccuracyReport']> = {
  audience?: Resolver<ResolversTypes['EvalFieldAccuracy'], ParentType, ContextType>;
  guideable?: Resolver<ResolversTypes['EvalFieldAccuracy'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['EvalFieldAccuracy'], ParentType, ContextType>;
};

export type EvalPromptResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalPrompt'] = ResolversParentTypes['EvalPrompt']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastEvalScore?: Resolver<Maybe<ResolversTypes['EvalPromptScore']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prompt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvalPromptScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalPromptScore'] = ResolversParentTypes['EvalPromptScore']> = {
  accuracy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  guideableAccuracy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ranAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reportId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  weightedScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type EvalReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalReport'] = ResolversParentTypes['EvalReport']> = {
  baselineReportId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fieldAccuracy?: Resolver<ResolversTypes['EvalFieldAccuracyReport'], ParentType, ContextType>;
  guideableScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  modelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  overallScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  promptExists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  promptName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ranAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['EvalCaseResult']>, ParentType, ContextType>;
  totalCases?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weightedScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type EvalReportSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalReportSummary'] = ResolversParentTypes['EvalReportSummary']> = {
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  modelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  promptExists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  promptName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ranAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCases?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weightedScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type EvalTestCaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalTestCase'] = ResolversParentTypes['EvalTestCase']> = {
  addedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expected?: Resolver<ResolversTypes['EvalExpected'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceItemTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ExecuteStepResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteStepResult'] = ResolversParentTypes['ExecuteStepResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['ExecutionResult']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type ExecutionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutionError'] = ResolversParentTypes['ExecutionError']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ExecutionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutionResult'] = ResolversParentTypes['ExecutionResult']> = {
  actionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  completedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  durationMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['ExecutionError']>, ParentType, ContextType>;
  logs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  output?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ExecutionResultStatus'], ParentType, ContextType>;
};

export type ExtractionMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtractionMetadata'] = ResolversParentTypes['ExtractionMetadata']> = {
  audience?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FactConstraintResolvers<ContextType = any, ParentType extends ResolversParentTypes['FactConstraint'] = ResolversParentTypes['FactConstraint']> = {
  allowedValues?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type FaqBlockResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqBlock'] = ResolversParentTypes['FaqBlock']> = {
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FeaturedGuideResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedGuide'] = ResolversParentTypes['FeaturedGuide']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOfficial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  orgSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publisherOrgName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FileUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileUploadUrl'] = ResolversParentTypes['FileUploadUrl']> = {
  fileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  storagePath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FuzzyPlanContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['FuzzyPlanContext'] = ResolversParentTypes['FuzzyPlanContext']> = {
  phases?: Resolver<Array<ResolversTypes['PhaseContext']>, ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['StatusCounts'], ParentType, ContextType>;
  visibleSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type GenerateGuideFromGroupResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateGuideFromGroupResult'] = ResolversParentTypes['GenerateGuideFromGroupResult']> = {
  existingGuide?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  generationJobId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  guide?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType>;
};

export type GenerationSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerationSource'] = ResolversParentTypes['GenerationSource']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdByAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  promptText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadedDocumentIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  urls?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type GlobalParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalParticipant'] = ResolversParentTypes['GlobalParticipant']> = {
  accessLevel?: Resolver<ResolversTypes['ParticipantAccessLevel'], ParentType, ContextType>;
  addedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<ResolversTypes['Person'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['ParticipantRole'], ParentType, ContextType>;
  roleIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type GoalInterpretationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoalInterpretation'] = ResolversParentTypes['GoalInterpretation']> = {
  implicitConstraints?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  measurableOutcome?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  whatUserWants?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GroupMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupMembership'] = ResolversParentTypes['GroupMembership']> = {
  assignedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceItem?: Resolver<Maybe<ResolversTypes['SourceItem']>, ParentType, ContextType>;
  sourceItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type GroupSuggestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupSuggestion'] = ResolversParentTypes['GroupSuggestion']> = {
  acceptedGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rationale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreBreakdown?: Resolver<ResolversTypes['ScoreBreakdown'], ParentType, ContextType>;
  sourceItems?: Resolver<Array<ResolversTypes['SourceItem']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GuardrailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Guardrail'] = ResolversParentTypes['Guardrail']> = {
  config?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  failureAction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GuideCitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideCitation'] = ResolversParentTypes['GuideCitation']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  excerpt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guideId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  guideVersionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceItem?: Resolver<Maybe<ResolversTypes['SourceItem']>, ParentType, ContextType>;
  sourceItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceLocator?: Resolver<Maybe<ResolversTypes['SourceLocator']>, ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type GuideEditDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideEditData'] = ResolversParentTypes['GuideEditData']> = {
  draftVersion?: Resolver<Maybe<ResolversTypes['GuideVersion']>, ParentType, ContextType>;
  generatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOutOfDate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  orgSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedVersion?: Resolver<Maybe<ResolversTypes['GuideVersion']>, ParentType, ContextType>;
  resolvedTheme?: Resolver<ResolversTypes['ResolvedGuideTheme'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  theme?: Resolver<Maybe<ResolversTypes['GuideTheme']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GuideLandingResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideLanding'] = ResolversParentTypes['GuideLanding']> = {
  applicantRoleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  citations?: Resolver<Array<ResolversTypes['GuideCitation']>, ParentType, ContextType>;
  deadlines?: Resolver<Array<ResolversTypes['Deadline']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  faqBlocks?: Resolver<Array<ResolversTypes['FaqBlock']>, ParentType, ContextType>;
  generatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generationSourceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOutOfDate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  needsOwnerResolution?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  orgSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedTheme?: Resolver<ResolversTypes['ResolvedGuideTheme'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sourceGroupVersionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  starterRoleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['GuideStep']>, ParentType, ContextType>;
  templatePlanId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  theme?: Resolver<Maybe<ResolversTypes['GuideTheme']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GuideStarterInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideStarterInfo'] = ResolversParentTypes['GuideStarterInfo']> = {
  availableRoles?: Resolver<Array<ResolversTypes['PlanRole']>, ParentType, ContextType>;
  guideId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  needsRoleSelection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  preSelectedRoleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GuideStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideStep'] = ResolversParentTypes['GuideStep']> = {
  guideId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GuideThemeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideTheme'] = ResolversParentTypes['GuideTheme']> = {
  accessibilityAdjusted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  brandMode?: Resolver<ResolversTypes['GuideBrandMode'], ParentType, ContextType>;
  brandProfileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  overrides?: Resolver<Maybe<ResolversTypes['GuideThemeOverrides']>, ParentType, ContextType>;
  resolvedFromOrgId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type GuideThemeOverridesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideThemeOverrides'] = ResolversParentTypes['GuideThemeOverrides']> = {
  headerLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tone?: Resolver<Maybe<ResolversTypes['BrandTone']>, ParentType, ContextType>;
};

export type GuideVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideVersion'] = ResolversParentTypes['GuideVersion']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  generatedOutput?: Resolver<Maybe<ResolversTypes['GuideVersionOutput']>, ParentType, ContextType>;
  generationError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generationFileIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  generationFiles?: Resolver<Array<ResolversTypes['GuideVersionFile']>, ParentType, ContextType>;
  generationPrompt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  generationSourceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  generationStatus?: Resolver<ResolversTypes['GenerationStatus'], ParentType, ContextType>;
  guideId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['GuideVersionStatus'], ParentType, ContextType>;
  versionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type GuideVersionFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideVersionFile'] = ResolversParentTypes['GuideVersionFile']> = {
  downloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizeBytes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type GuideVersionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuideVersionOutput'] = ResolversParentTypes['GuideVersionOutput']> = {
  applicantRoleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deadlines?: Resolver<Array<ResolversTypes['Deadline']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  faqBlocks?: Resolver<Array<ResolversTypes['FaqBlock']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  starterRoleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['GuideStep']>, ParentType, ContextType>;
  templatePlanId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type HiddenStepSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiddenStepSummary'] = ResolversParentTypes['HiddenStepSummary']> = {
  blockedReasonCategory?: Resolver<Maybe<ResolversTypes['BlockedReasonCategory']>, ParentType, ContextType>;
  phaseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statusBucket?: Resolver<ResolversTypes['StatusBucket'], ParentType, ContextType>;
  titleRedacted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type IntakeFileRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeFileRef'] = ResolversParentTypes['IntakeFileRef']> = {
  downloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  storagePath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IntakeFileUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeFileUploadUrl'] = ResolversParentTypes['IntakeFileUploadUrl']> = {
  fileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  storagePath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IntakePublicDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakePublicData'] = ResolversParentTypes['IntakePublicData']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasFreeFormMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IntakeStatus'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IntakeRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeRequest'] = ResolversParentTypes['IntakeRequest']> = {
  callbackUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['IntakeMode'], ParentType, ContextType>;
  planId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  prompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IntakeStatus'], ParentType, ContextType>;
  stepId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  submission?: Resolver<Maybe<ResolversTypes['IntakeSubmission']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IntakeSubmissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeSubmission'] = ResolversParentTypes['IntakeSubmission']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileRefs?: Resolver<Maybe<Array<ResolversTypes['IntakeFileRef']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  normalizedResult?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  structuredDataInput?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  submittedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IntakeSubmitResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeSubmitResult'] = ResolversParentTypes['IntakeSubmitResult']> = {
  normalizedResult?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IntakeStatus'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IntegrationCatalogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationCatalogEntry'] = ResolversParentTypes['IntegrationCatalogEntry']> = {
  allowedTiers?: Resolver<Array<ResolversTypes['ConnectionTier']>, ParentType, ContextType>;
  authType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  capabilities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultTier?: Resolver<ResolversTypes['ConnectionTier'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  industries?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IntegrationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationConnection'] = ResolversParentTypes['IntegrationConnection']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUsedByRunId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  principalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ConnectionStatus'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['ConnectionTier'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usedByOrgIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type JobResolvers<ContextType = any, ParentType extends ResolversParentTypes['Job'] = ResolversParentTypes['Job']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentStage?: Resolver<ResolversTypes['JobStage'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputSnapshot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  inputSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  requestedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resultData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  resultRef?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['JobType'], ParentType, ContextType>;
};

export type JobEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobEvent'] = ResolversParentTypes['JobEvent']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['JobStage'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type JourneyMagicLinkConsumptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JourneyMagicLinkConsumption'] = ResolversParentTypes['JourneyMagicLinkConsumption']> = {
  applicantEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firebaseToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  processTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type JourneyMagicLinkValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['JourneyMagicLinkValidation'] = ResolversParentTypes['JourneyMagicLinkValidation']> = {
  applicantEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  processTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['JourneyRole']>>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type JourneyRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['JourneyRole'] = ResolversParentTypes['JourneyRole']> = {
  assigneeEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assigneeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type LinkedPageRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedPageRef'] = ResolversParentTypes['LinkedPageRef']> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LoginMagicLinkResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginMagicLinkResult'] = ResolversParentTypes['LoginMagicLinkResult']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type LoginMagicLinkValidationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginMagicLinkValidationResult'] = ResolversParentTypes['LoginMagicLinkValidationResult']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firebaseToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type MagicLinkValidationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MagicLinkValidationResult'] = ResolversParentTypes['MagicLinkValidationResult']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firebaseToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participantId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  participantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planGoal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  _empty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acceptGroupSuggestion?: Resolver<ResolversTypes['DocumentGroup'], ParentType, ContextType, RequireFields<MutationAcceptGroupSuggestionArgs, 'suggestionId'>>;
  acknowledgeAlert?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAcknowledgeAlertArgs, 'alertId'>>;
  addEvalTestCase?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddEvalTestCaseArgs, 'expected' | 'orgId' | 'sourceItemId'>>;
  addGlobalParticipant?: Resolver<ResolversTypes['GlobalParticipant'], ParentType, ContextType, RequireFields<MutationAddGlobalParticipantArgs, 'input'>>;
  addGroupMember?: Resolver<ResolversTypes['GroupMembership'], ParentType, ContextType, RequireFields<MutationAddGroupMemberArgs, 'assignedBy' | 'groupId' | 'sourceItemId'>>;
  addParticipant?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationAddParticipantArgs, 'participant' | 'planId'>>;
  addPlanRole?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationAddPlanRoleArgs, 'planId' | 'role'>>;
  addSourceItemsToGroup?: Resolver<Array<ResolversTypes['GroupMembership']>, ParentType, ContextType, RequireFields<MutationAddSourceItemsToGroupArgs, 'assignedBy' | 'groupId' | 'sourceItemIds'>>;
  addStepGuardrail?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationAddStepGuardrailArgs, 'guardrail' | 'planId' | 'stepId'>>;
  adminCreateActionItem?: Resolver<ResolversTypes['ActionItem'], ParentType, ContextType, RequireFields<MutationAdminCreateActionItemArgs, 'input'>>;
  adminCreatePilotInvite?: Resolver<ResolversTypes['PilotInvite'], ParentType, ContextType, RequireFields<MutationAdminCreatePilotInviteArgs, 'input'>>;
  adminReactivatePilotInvite?: Resolver<ResolversTypes['PilotInvite'], ParentType, ContextType, RequireFields<MutationAdminReactivatePilotInviteArgs, 'code'>>;
  adminRevokePilotInvite?: Resolver<ResolversTypes['PilotInvite'], ParentType, ContextType, RequireFields<MutationAdminRevokePilotInviteArgs, 'code'>>;
  adminUpdateActionItem?: Resolver<ResolversTypes['ActionItem'], ParentType, ContextType, RequireFields<MutationAdminUpdateActionItemArgs, 'id' | 'input'>>;
  adminUpdatePilotInvite?: Resolver<ResolversTypes['PilotInvite'], ParentType, ContextType, RequireFields<MutationAdminUpdatePilotInviteArgs, 'code' | 'input'>>;
  assignStep?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationAssignStepArgs, 'planId' | 'stepId'>>;
  assignStepToPerson?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationAssignStepToPersonArgs, 'planId' | 'stepId'>>;
  assignStepToRole?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationAssignStepToRoleArgs, 'planId' | 'stepId'>>;
  bindParticipantToRole?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationBindParticipantToRoleArgs, 'personId' | 'planId' | 'roleId'>>;
  cancelIntakeRequest?: Resolver<ResolversTypes['IntakeRequest'], ParentType, ContextType, RequireFields<MutationCancelIntakeRequestArgs, 'id'>>;
  cancelJob?: Resolver<ResolversTypes['StartJobResult'], ParentType, ContextType, RequireFields<MutationCancelJobArgs, 'jobId'>>;
  cancelRequestThread?: Resolver<ResolversTypes['RequestThread'], ParentType, ContextType, RequireFields<MutationCancelRequestThreadArgs, 'id'>>;
  captureLead?: Resolver<ResolversTypes['CaptureLeadResult'], ParentType, ContextType, RequireFields<MutationCaptureLeadArgs, 'input'>>;
  claimAnonymousRun?: Resolver<ResolversTypes['ClaimAnonymousRunResult'], ParentType, ContextType, RequireFields<MutationClaimAnonymousRunArgs, 'anonymousToken'>>;
  claimPreviewPlan?: Resolver<ResolversTypes['ClaimPreviewResult'], ParentType, ContextType, RequireFields<MutationClaimPreviewPlanArgs, 'email' | 'previewPlanId'>>;
  classifySourceItems?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationClassifySourceItemsArgs, 'orgId' | 'sourceItemIds'>>;
  clearConversation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<MutationClearConversationArgs>>;
  commitUploadsToSourceItems?: Resolver<Array<ResolversTypes['SourceItem']>, ParentType, ContextType, RequireFields<MutationCommitUploadsToSourceItemsArgs, 'orgId' | 'tempUploadIds'>>;
  confirmThreadSatisfaction?: Resolver<ResolversTypes['ConfirmThreadResult'], ParentType, ContextType, RequireFields<MutationConfirmThreadSatisfactionArgs, 'slug'>>;
  consumeJourneyMagicLink?: Resolver<ResolversTypes['JourneyMagicLinkConsumption'], ParentType, ContextType, RequireFields<MutationConsumeJourneyMagicLinkArgs, 'token'>>;
  consumeLoginMagicLink?: Resolver<ResolversTypes['LoginMagicLinkValidationResult'], ParentType, ContextType, RequireFields<MutationConsumeLoginMagicLinkArgs, 'token'>>;
  consumeMagicLink?: Resolver<ResolversTypes['MagicLinkValidationResult'], ParentType, ContextType, RequireFields<MutationConsumeMagicLinkArgs, 'token'>>;
  createConnectSession?: Resolver<ResolversTypes['ConnectSessionResult'], ParentType, ContextType, RequireFields<MutationCreateConnectSessionArgs, 'integrationId' | 'tier'>>;
  createDocumentGroup?: Resolver<ResolversTypes['DocumentGroup'], ParentType, ContextType, RequireFields<MutationCreateDocumentGroupArgs, 'groupType' | 'name' | 'orgId'>>;
  createIntakeRequest?: Resolver<ResolversTypes['CreateIntakeRequestResult'], ParentType, ContextType, RequireFields<MutationCreateIntakeRequestArgs, 'input'>>;
  createOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'name'>>;
  createOrganizationBrandProfile?: Resolver<ResolversTypes['OrganizationBrandProfile'], ParentType, ContextType, RequireFields<MutationCreateOrganizationBrandProfileArgs, 'input'>>;
  createPlanFromTemplate?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationCreatePlanFromTemplateArgs, 'templateId'>>;
  createRequestThread?: Resolver<ResolversTypes['CreateRequestThreadResult'], ParentType, ContextType, RequireFields<MutationCreateRequestThreadArgs, 'input'>>;
  createStepIntake?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationCreateStepIntakeArgs, 'planId' | 'stepId'>>;
  createStepRequestThread?: Resolver<ResolversTypes['CreateRequestThreadResult'], ParentType, ContextType, RequireFields<MutationCreateStepRequestThreadArgs, 'planId' | 'stepId'>>;
  deleteDocumentGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDocumentGroupArgs, 'id'>>;
  deleteEvalPrompt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEvalPromptArgs, 'name'>>;
  deleteEvalReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEvalReportArgs, 'id'>>;
  deleteEvalTestCase?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEvalTestCaseArgs, 'id'>>;
  deleteGuide?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteGuideArgs, 'guideId'>>;
  deletePlanapusPlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeletePlanapusPlanArgs, 'id'>>;
  deleteSourceItem?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteSourceItemArgs, 'id'>>;
  deleteSourceItems?: Resolver<ResolversTypes['DeleteSourceItemsResult'], ParentType, ContextType, RequireFields<MutationDeleteSourceItemsArgs, 'ids'>>;
  deleteStepRequestThread?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationDeleteStepRequestThreadArgs, 'planId' | 'stepId' | 'threadId'>>;
  devLogin?: Resolver<ResolversTypes['LoginMagicLinkValidationResult'], ParentType, ContextType, RequireFields<MutationDevLoginArgs, 'email'>>;
  discardGroupSuggestion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDiscardGroupSuggestionArgs, 'suggestionId'>>;
  discoverBrandFromUrl?: Resolver<ResolversTypes['BrandDiscoveryResult'], ParentType, ContextType, RequireFields<MutationDiscoverBrandFromUrlArgs, 'input'>>;
  enqueueEligibleStepsExecution?: Resolver<ResolversTypes['EnqueuedJob'], ParentType, ContextType, RequireFields<MutationEnqueueEligibleStepsExecutionArgs, 'planId'>>;
  enqueueStepExecution?: Resolver<ResolversTypes['EnqueuedJob'], ParentType, ContextType, RequireFields<MutationEnqueueStepExecutionArgs, 'planId' | 'stepId'>>;
  enrichPerson?: Resolver<ResolversTypes['PersonProfile'], ParentType, ContextType, RequireFields<MutationEnrichPersonArgs, 'email'>>;
  executeEligibleSteps?: Resolver<ResolversTypes['AutoExecuteResult'], ParentType, ContextType, RequireFields<MutationExecuteEligibleStepsArgs, 'planId'>>;
  executeStep?: Resolver<ResolversTypes['ExecuteStepResult'], ParentType, ContextType, RequireFields<MutationExecuteStepArgs, 'planId' | 'stepId'>>;
  expandStepIntoPlan?: Resolver<ResolversTypes['StartJobResult'], ParentType, ContextType, RequireFields<MutationExpandStepIntoPlanArgs, 'input'>>;
  extractSourceItems?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationExtractSourceItemsArgs, 'orgId' | 'sourceItemIds'>>;
  generateAndRunEval?: Resolver<ResolversTypes['Job'], ParentType, ContextType, Partial<MutationGenerateAndRunEvalArgs>>;
  generateGroupSuggestions?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationGenerateGroupSuggestionsArgs, 'orgId'>>;
  generateGuide?: Resolver<ResolversTypes['GuideLanding'], ParentType, ContextType, RequireFields<MutationGenerateGuideArgs, 'prompt'>>;
  generateGuideFromGroup?: Resolver<ResolversTypes['GenerateGuideFromGroupResult'], ParentType, ContextType, RequireFields<MutationGenerateGuideFromGroupArgs, 'groupId'>>;
  generatePlanFromPrompt?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationGeneratePlanFromPromptArgs, 'input'>>;
  generatePreviewOutline?: Resolver<ResolversTypes['PreviewPlanResult'], ParentType, ContextType, RequireFields<MutationGeneratePreviewOutlineArgs, 'prompt'>>;
  getIntakeFileUploadUrl?: Resolver<ResolversTypes['IntakeFileUploadUrl'], ParentType, ContextType, RequireFields<MutationGetIntakeFileUploadUrlArgs, 'fileName' | 'mimeType' | 'slug'>>;
  getThreadFileUploadUrl?: Resolver<ResolversTypes['FileUploadUrl'], ParentType, ContextType, RequireFields<MutationGetThreadFileUploadUrlArgs, 'fileName' | 'mimeType' | 'slug'>>;
  iterateEval?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationIterateEvalArgs, 'evalModelName' | 'generationModelNames' | 'iterations'>>;
  markNotificationRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationMarkNotificationReadArgs, 'notificationId'>>;
  overrideSourceItemClassification?: Resolver<Maybe<ResolversTypes['SourceItem']>, ParentType, ContextType, RequireFields<MutationOverrideSourceItemClassificationArgs, 'id' | 'isProcess'>>;
  participantToggleStepCompletion?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationParticipantToggleStepCompletionArgs, 'completed' | 'planId' | 'stepId'>>;
  participantUpdateStep?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationParticipantUpdateStepArgs, 'context' | 'planId' | 'stepId'>>;
  postThreadMessage?: Resolver<ResolversTypes['PostThreadMessageResult'], ParentType, ContextType, RequireFields<MutationPostThreadMessageArgs, 'input' | 'slug'>>;
  promoteConnectionToUser?: Resolver<ResolversTypes['IntegrationConnection'], ParentType, ContextType, RequireFields<MutationPromoteConnectionToUserArgs, 'id'>>;
  promoteOrganizationBrandProfile?: Resolver<ResolversTypes['OrganizationBrandProfile'], ParentType, ContextType, RequireFields<MutationPromoteOrganizationBrandProfileArgs, 'input'>>;
  publishGuide?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType, RequireFields<MutationPublishGuideArgs, 'guideId'>>;
  publishGuideDraft?: Resolver<ResolversTypes['GuideLanding'], ParentType, ContextType, RequireFields<MutationPublishGuideDraftArgs, 'guideId' | 'versionId'>>;
  recalculateEvalReports?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordOrgUserFallbackConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRecordOrgUserFallbackConsentArgs, 'approvedIntegrationIds' | 'runId'>>;
  regenerateGuideDraft?: Resolver<ResolversTypes['GuideVersion'], ParentType, ContextType, RequireFields<MutationRegenerateGuideDraftArgs, 'guideId' | 'versionId'>>;
  regenerateGuideFromGroup?: Resolver<ResolversTypes['GenerateGuideFromGroupResult'], ParentType, ContextType, RequireFields<MutationRegenerateGuideFromGroupArgs, 'guideId'>>;
  registerConnection?: Resolver<ResolversTypes['IntegrationConnection'], ParentType, ContextType, RequireFields<MutationRegisterConnectionArgs, 'composioConnectedAccountId' | 'integrationId' | 'provider' | 'tier'>>;
  removeGlobalParticipant?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveGlobalParticipantArgs, 'personId' | 'planId'>>;
  removeGroupMember?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveGroupMemberArgs, 'membershipId'>>;
  removeParticipant?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationRemoveParticipantArgs, 'participantId' | 'planId'>>;
  removePlanRole?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationRemovePlanRoleArgs, 'planId' | 'roleId'>>;
  removeStepGuardrail?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationRemoveStepGuardrailArgs, 'guardrailId' | 'planId' | 'stepId'>>;
  removeStepIntake?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationRemoveStepIntakeArgs, 'planId' | 'stepId'>>;
  renameEvalPrompt?: Resolver<ResolversTypes['EvalPrompt'], ParentType, ContextType, RequireFields<MutationRenameEvalPromptArgs, 'newName' | 'oldName'>>;
  requestLoginMagicLink?: Resolver<ResolversTypes['LoginMagicLinkResult'], ParentType, ContextType, RequireFields<MutationRequestLoginMagicLinkArgs, 'email'>>;
  requestPilotInviteByEmail?: Resolver<ResolversTypes['RequestPilotInviteByEmailResult'], ParentType, ContextType, RequireFields<MutationRequestPilotInviteByEmailArgs, 'email'>>;
  rerunEvalCase?: Resolver<ResolversTypes['EvalReport'], ParentType, ContextType, RequireFields<MutationRerunEvalCaseArgs, 'reportId' | 'testCaseId'>>;
  rerunEvalReport?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationRerunEvalReportArgs, 'reportId'>>;
  resendParticipantInvite?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationResendParticipantInviteArgs, 'participantId' | 'planId'>>;
  resetPlan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationResetPlanArgs, 'planId'>>;
  resetStep?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationResetStepArgs, 'planId' | 'stepId'>>;
  retryConnectorStep?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationRetryConnectorStepArgs, 'planId' | 'stepId'>>;
  retryDeadLetterJob?: Resolver<Maybe<ResolversTypes['QueueJobStatus']>, ParentType, ContextType, RequireFields<MutationRetryDeadLetterJobArgs, 'jobId'>>;
  retryJob?: Resolver<ResolversTypes['StartJobResult'], ParentType, ContextType, RequireFields<MutationRetryJobArgs, 'jobId'>>;
  revokeConnection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRevokeConnectionArgs, 'id'>>;
  runEval?: Resolver<ResolversTypes['Job'], ParentType, ContextType, Partial<MutationRunEvalArgs>>;
  runMultiModelEval?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationRunMultiModelEvalArgs, 'modelNames'>>;
  saveEvalPrompt?: Resolver<ResolversTypes['EvalPrompt'], ParentType, ContextType, RequireFields<MutationSaveEvalPromptArgs, 'name' | 'prompt'>>;
  saveGuideDraft?: Resolver<ResolversTypes['GuideVersion'], ParentType, ContextType, RequireFields<MutationSaveGuideDraftArgs, 'guideId' | 'prompt'>>;
  scanLibrary?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationScanLibraryArgs, 'orgId'>>;
  sendChatMessage?: Resolver<ResolversTypes['SendChatMessageResponse'], ParentType, ContextType, RequireFields<MutationSendChatMessageArgs, 'input'>>;
  sendMessageToRecipient?: Resolver<ResolversTypes['SendMessageResult'], ParentType, ContextType, RequireFields<MutationSendMessageToRecipientArgs, 'input'>>;
  setActiveOrganization?: Resolver<ResolversTypes['ActiveOrgResult'], ParentType, ContextType, RequireFields<MutationSetActiveOrganizationArgs, 'orgId'>>;
  setGuideTheme?: Resolver<ResolversTypes['GuideLanding'], ParentType, ContextType, RequireFields<MutationSetGuideThemeArgs, 'guideId' | 'input'>>;
  setOrganizationDefaultBrandProfile?: Resolver<ResolversTypes['OrganizationBrandProfile'], ParentType, ContextType, RequireFields<MutationSetOrganizationDefaultBrandProfileArgs, 'profileId'>>;
  startAnalysis?: Resolver<ResolversTypes['StartJobResult'], ParentType, ContextType, RequireFields<MutationStartAnalysisArgs, 'prompt'>>;
  startAnonymousRunSession?: Resolver<ResolversTypes['AnonymousRunSession'], ParentType, ContextType, RequireFields<MutationStartAnonymousRunSessionArgs, 'runId'>>;
  startGuideGeneration?: Resolver<ResolversTypes['StartJobResult'], ParentType, ContextType, RequireFields<MutationStartGuideGenerationArgs, 'orgSlug' | 'prompt'>>;
  startJourney?: Resolver<ResolversTypes['StartJourneyResult'], ParentType, ContextType, RequireFields<MutationStartJourneyArgs, 'applicantEmail' | 'guideSlug' | 'orgSlug'>>;
  startWebCrawl?: Resolver<ResolversTypes['StartJobResult'], ParentType, ContextType, RequireFields<MutationStartWebCrawlArgs, 'orgId' | 'seedUrl'>>;
  submitIntake?: Resolver<ResolversTypes['IntakeSubmitResult'], ParentType, ContextType, RequireFields<MutationSubmitIntakeArgs, 'input' | 'slug'>>;
  submitPilotLead?: Resolver<ResolversTypes['PilotLeadResult'], ParentType, ContextType, RequireFields<MutationSubmitPilotLeadArgs, 'input'>>;
  submitStepApproval?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationSubmitStepApprovalArgs, 'decision' | 'planId' | 'stepId'>>;
  submitStepIntakeInline?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationSubmitStepIntakeInlineArgs, 'input' | 'planId' | 'stepId'>>;
  toggleStepCompletion?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationToggleStepCompletionArgs, 'completed' | 'planId' | 'stepId'>>;
  trackPilotEvents?: Resolver<ResolversTypes['TrackPilotEventsResult'], ParentType, ContextType, RequireFields<MutationTrackPilotEventsArgs, 'events'>>;
  unbindParticipantFromRole?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUnbindParticipantFromRoleArgs, 'planId' | 'roleId'>>;
  unpublishGuide?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType, RequireFields<MutationUnpublishGuideArgs, 'guideId'>>;
  updateDocumentGroup?: Resolver<ResolversTypes['DocumentGroup'], ParentType, ContextType, RequireFields<MutationUpdateDocumentGroupArgs, 'id'>>;
  updateNotificationPreferences?: Resolver<ResolversTypes['NotificationPreferences'], ParentType, ContextType, Partial<MutationUpdateNotificationPreferencesArgs>>;
  updateOrganizationBrandProfile?: Resolver<ResolversTypes['OrganizationBrandProfile'], ParentType, ContextType, RequireFields<MutationUpdateOrganizationBrandProfileArgs, 'input'>>;
  updateParticipant?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUpdateParticipantArgs, 'participantId' | 'planId' | 'updates'>>;
  updateParticipantAccess?: Resolver<ResolversTypes['GlobalParticipant'], ParentType, ContextType, RequireFields<MutationUpdateParticipantAccessArgs, 'personId' | 'planId'>>;
  updateParticipantRole?: Resolver<ResolversTypes['GlobalParticipant'], ParentType, ContextType, RequireFields<MutationUpdateParticipantRoleArgs, 'personId' | 'planId' | 'role'>>;
  updatePerson?: Resolver<ResolversTypes['Person'], ParentType, ContextType, RequireFields<MutationUpdatePersonArgs, 'personId' | 'updates'>>;
  updatePlanRole?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUpdatePlanRoleArgs, 'planId' | 'roleId' | 'updates'>>;
  updatePlanapusStepStatus?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUpdatePlanapusStepStatusArgs, 'planId' | 'status' | 'stepId'>>;
  updateStepConsentLevel?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUpdateStepConsentLevelArgs, 'consentLevel' | 'planId' | 'stepId'>>;
  updateStepContext?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUpdateStepContextArgs, 'context' | 'planId' | 'stepId'>>;
  updateThreadFields?: Resolver<ResolversTypes['UpdateThreadFieldsResult'], ParentType, ContextType, RequireFields<MutationUpdateThreadFieldsArgs, 'input' | 'slug'>>;
  validatePilotInvite?: Resolver<ResolversTypes['ValidatePilotInviteResult'], ParentType, ContextType, RequireFields<MutationValidatePilotInviteArgs, 'code'>>;
};

export type NotificationPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPreferences'] = ResolversParentTypes['NotificationPreferences']> = {
  channels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  digestFrequency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quietHoursEnd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quietHoursStart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OpenRouterModelPricingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenRouterModelPricing'] = ResolversParentTypes['OpenRouterModelPricing']> = {
  contextLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inputPer1M?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputPer1M?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type OrgAuditEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrgAuditEntry'] = ResolversParentTypes['OrgAuditEntry']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUsedByRunId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  principalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['ConnectionTier'], ParentType, ContextType>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  branding?: Resolver<Maybe<ResolversTypes['OrganizationBrandingSettings']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OrganizationBrandProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationBrandProfile'] = ResolversParentTypes['OrganizationBrandProfile']> = {
  approvedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confidenceScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdFromImportId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  headerLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importedAssetRefs?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organizationDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  palette?: Resolver<ResolversTypes['BrandPalette'], ParentType, ContextType>;
  provenance?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BrandProfileStatus'], ParentType, ContextType>;
  tone?: Resolver<Maybe<ResolversTypes['BrandTone']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrganizationBrandingSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationBrandingSettings'] = ResolversParentTypes['OrganizationBrandingSettings']> = {
  allowedProfileIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  defaultBrandProfileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OrganizationMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationMembership'] = ResolversParentTypes['OrganizationMembership']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OutputContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutputContract'] = ResolversParentTypes['OutputContract']> = {
  allowedKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  maxSizeBytes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type ParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Participant'] = ResolversParentTypes['Participant']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firebaseUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inviteSentAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteStatus?: Resolver<Maybe<ResolversTypes['InviteStatus']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ParticipantStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParticipantStep'] = ResolversParentTypes['ParticipantStep']> = {
  assignedViaRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blocked?: Resolver<ResolversTypes['StepBlockedInfo'], ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['StepContext']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phaseLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StepStatus'], ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ParticipantWorkspaceViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParticipantWorkspaceView'] = ResolversParentTypes['ParticipantWorkspaceView']> = {
  fuzzyContext?: Resolver<ResolversTypes['FuzzyPlanContext'], ParentType, ContextType>;
  mySteps?: Resolver<Array<ResolversTypes['ParticipantStep']>, ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  planStatus?: Resolver<ResolversTypes['PlanStatus'], ParentType, ContextType>;
  planSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  planTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['WorkspaceRole']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewerPersonId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  viewerRoleIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type PersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Person'] = ResolversParentTypes['Person']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PersonProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonProfile'] = ResolversParentTypes['PersonProfile']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enrichedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedInUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sources?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PhaseContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhaseContext'] = ResolversParentTypes['PhaseContext']> = {
  counts?: Resolver<ResolversTypes['StatusCounts'], ParentType, ContextType>;
  phaseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phaseLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PhaseProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhaseProgress'] = ResolversParentTypes['PhaseProgress']> = {
  blockedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inProgressSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  percentComplete?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  phaseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PhaseSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhaseSummary'] = ResolversParentTypes['PhaseSummary']> = {
  countByStatusBucket?: Resolver<ResolversTypes['StatusBucketCounts'], ParentType, ContextType>;
  hiddenSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phaseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phaseLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  visibleSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PilotBreakdownPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotBreakdownPoint'] = ResolversParentTypes['PilotBreakdownPoint']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PilotDashboardOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotDashboardOverview'] = ResolversParentTypes['PilotDashboardOverview']> = {
  campaignBreakdown?: Resolver<Array<ResolversTypes['PilotBreakdownPoint']>, ParentType, ContextType>;
  funnel?: Resolver<Array<ResolversTypes['PilotFunnelStage']>, ParentType, ContextType>;
  kpi?: Resolver<ResolversTypes['PilotKpiTile'], ParentType, ContextType>;
  sourceBreakdown?: Resolver<Array<ResolversTypes['PilotBreakdownPoint']>, ParentType, ContextType>;
  timeSeries?: Resolver<Array<ResolversTypes['PilotTimeSeriesPoint']>, ParentType, ContextType>;
};

export type PilotEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotEvent'] = ResolversParentTypes['PilotEvent']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  occurredAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  visitorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type PilotFunnelStageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotFunnelStage'] = ResolversParentTypes['PilotFunnelStage']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['PilotVisitorStage'], ParentType, ContextType>;
};

export type PilotInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotInvite'] = ResolversParentTypes['PilotInvite']> = {
  audience?: Resolver<ResolversTypes['PilotInviteAudience'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  revokedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PilotInviteStatus'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PilotKpiTileResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotKpiTile'] = ResolversParentTypes['PilotKpiTile']> = {
  conversionRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  events?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  identifiedVisitors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  leads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  visitors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PilotLeadAdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotLeadAdmin'] = ResolversParentTypes['PilotLeadAdmin']> = {
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['PilotLeadKind'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roiPayload?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simPayload?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  visitorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PilotLeadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotLeadResult'] = ResolversParentTypes['PilotLeadResult']> = {
  leadId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PilotSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotSession'] = ResolversParentTypes['PilotSession']> = {
  eventCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastActiveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referrer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type PilotTimeSeriesPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotTimeSeriesPoint'] = ResolversParentTypes['PilotTimeSeriesPoint']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  visits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PilotVisitorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotVisitor'] = ResolversParentTypes['PilotVisitor']> = {
  attribution?: Resolver<ResolversTypes['PilotVisitorAttribution'], ParentType, ContextType>;
  eventCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['PilotEvent']>, ParentType, ContextType>;
  firstSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['PilotVisitorIdentity'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leadCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  leads?: Resolver<Array<ResolversTypes['PilotLeadAdmin']>, ParentType, ContextType>;
  rawParams?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  sessionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessions?: Resolver<Array<ResolversTypes['PilotSession']>, ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['PilotVisitorStage'], ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PilotVisitorAttributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotVisitorAttribution'] = ResolversParentTypes['PilotVisitorAttribution']> = {
  apolloCampaignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apolloContactId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PilotVisitorIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotVisitorIdentity'] = ResolversParentTypes['PilotVisitorIdentity']> = {
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PilotVisitorListResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PilotVisitorListResult'] = ResolversParentTypes['PilotVisitorListResult']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  visitors?: Resolver<Array<ResolversTypes['PilotVisitor']>, ParentType, ContextType>;
};

export type PlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['Plan'] = ResolversParentTypes['Plan']> = {
  artifacts?: Resolver<Maybe<Array<ResolversTypes['PlanArtifact']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  derivedFromTemplateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['PlanEvaluation']>, ParentType, ContextType>;
  factConstraints?: Resolver<Maybe<Array<ResolversTypes['FactConstraint']>>, ParentType, ContextType>;
  facts?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  generationSourceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  goal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  originalPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentPlanId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  parentStepId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  participants?: Resolver<Array<ResolversTypes['Participant']>, ParentType, ContextType>;
  pendingGenerationJobId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  phases?: Resolver<Array<ResolversTypes['PlanPhase']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['PlanRole']>, ParentType, ContextType>;
  sourceGuideId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlanStatus'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['PlanStep']>, ParentType, ContextType>;
  suggestedSaaS?: Resolver<Maybe<ResolversTypes['SuggestedSaaS']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PlanAnalysisResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanAnalysisResult'] = ResolversParentTypes['PlanAnalysisResult']> = {
  clarifyingQuestions?: Resolver<Array<ResolversTypes['ClarifyingQuestion']>, ParentType, ContextType>;
  domainResearch?: Resolver<ResolversTypes['DomainResearch'], ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  goalInterpretation?: Resolver<ResolversTypes['GoalInterpretation'], ParentType, ContextType>;
  originalPrompt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readyToGenerate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PlanArtifactResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanArtifact'] = ResolversParentTypes['PlanArtifact']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sizeBytes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  storagePath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PlanEvaluationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanEvaluation'] = ResolversParentTypes['PlanEvaluation']> = {
  blockedStepIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  blockedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  evaluatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inProgressSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  percentComplete?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  phaseProgress?: Resolver<Array<ResolversTypes['PhaseProgress']>, ParentType, ContextType>;
  readyToStartStepIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PlanEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanEvent'] = ResolversParentTypes['PlanEvent']> = {
  data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  stepId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PlanListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanListItem'] = ResolversParentTypes['PlanListItem']> = {
  accessLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accessLevel?: Resolver<ResolversTypes['ParticipantAccessLevel'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progressPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlanStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalStepCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibleStepCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PlanPhaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanPhase'] = ResolversParentTypes['PlanPhase']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatedDurationDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PlanRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanRole'] = ResolversParentTypes['PlanRole']> = {
  assigneeEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assigneeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canFillRoleIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  defaultAssigneePersonId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isRestricted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type PlanStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanStep'] = ResolversParentTypes['PlanStep']> = {
  actions?: Resolver<Maybe<Array<ResolversTypes['AutomationAction']>>, ParentType, ContextType>;
  allowedFields?: Resolver<Maybe<Array<ResolversTypes['StepAllowedField']>>, ParentType, ContextType>;
  applicability?: Resolver<Maybe<ResolversTypes['StepApplicability']>, ParentType, ContextType>;
  approvalRecords?: Resolver<Maybe<Array<ResolversTypes['ApprovalRecord']>>, ParentType, ContextType>;
  assessment?: Resolver<Maybe<ResolversTypes['StepAssessment']>, ParentType, ContextType>;
  assignedRoleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  assignedToId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  capabilities?: Resolver<Maybe<ResolversTypes['StepCapabilities']>, ParentType, ContextType>;
  connectionRequirement?: Resolver<Maybe<ResolversTypes['ConnectionRequirement']>, ParentType, ContextType>;
  consentLevel?: Resolver<Maybe<ResolversTypes['ConsentLevel']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['StepContext']>, ParentType, ContextType>;
  dependencyStatus?: Resolver<Maybe<ResolversTypes['StepDependencyStatus']>, ParentType, ContextType>;
  dependsOn?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  estimatedDurationDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  executionResults?: Resolver<Maybe<Array<ResolversTypes['ExecutionResult']>>, ParentType, ContextType>;
  expansionPlanId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  guardrails?: Resolver<Maybe<Array<ResolversTypes['Guardrail']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inferredRequirements?: Resolver<Maybe<Array<ResolversTypes['RequiredItem']>>, ParentType, ContextType>;
  intake?: Resolver<Maybe<ResolversTypes['StepIntakeData']>, ParentType, ContextType>;
  intent?: Resolver<Maybe<ResolversTypes['StepIntent']>, ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['StepKind'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  parentStepId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  phaseId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  producesFact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestThreads?: Resolver<Maybe<Array<ResolversTypes['StepRequestThread']>>, ParentType, ContextType>;
  skills?: Resolver<Maybe<Array<ResolversTypes['SkillRef']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StepStatus'], ParentType, ContextType>;
  statusHistory?: Resolver<Array<ResolversTypes['StepStatusEvent']>, ParentType, ContextType>;
  statusReason?: Resolver<Maybe<ResolversTypes['StepStatusReason']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verificationStrategy?: Resolver<Maybe<ResolversTypes['VerificationStrategy']>, ParentType, ContextType>;
};

export type PlansSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlansSummary'] = ResolversParentTypes['PlansSummary']> = {
  blockedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedPlanIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  completedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  generatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recentActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalPlans?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PlatformIntegrationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformIntegrationStatus'] = ResolversParentTypes['PlatformIntegrationStatus']> = {
  composioToolkitSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  healthMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastHealthCheckAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  latencyMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rollingCallCount24h?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rollingErrorRate24h?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PostThreadMessageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostThreadMessageResult'] = ResolversParentTypes['PostThreadMessageResult']> = {
  assistantMessage?: Resolver<Maybe<ResolversTypes['ThreadMessage']>, ParentType, ContextType>;
  requestThread?: Resolver<ResolversTypes['RequestThread'], ParentType, ContextType>;
  satisfactionState?: Resolver<ResolversTypes['SatisfactionState'], ParentType, ContextType>;
  userMessage?: Resolver<ResolversTypes['ThreadMessage'], ParentType, ContextType>;
};

export type PreviewOutlineResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewOutline'] = ResolversParentTypes['PreviewOutline']> = {
  estimatedTimeline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['PreviewOutlineStep']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PreviewOutlineStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewOutlineStep'] = ResolversParentTypes['PreviewOutlineStep']> = {
  automatable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  automationHint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatedDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PreviewPlanResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewPlanResult'] = ResolversParentTypes['PreviewPlanResult']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outline?: Resolver<Maybe<ResolversTypes['PreviewOutline']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectedPlanViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectedPlanView'] = ResolversParentTypes['ProjectedPlanView']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hiddenStepFillers?: Resolver<Array<ResolversTypes['HiddenStepSummary']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phaseSummaries?: Resolver<Array<ResolversTypes['PhaseSummary']>, ParentType, ContextType>;
  phases?: Resolver<Array<ResolversTypes['PlanPhase']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlanStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewerAccessLevel?: Resolver<ResolversTypes['ParticipantAccessLevel'], ParentType, ContextType>;
  viewerPersonId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  viewerRoleIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  visibleSteps?: Resolver<Array<ResolversTypes['PlanStep']>, ParentType, ContextType>;
};

export type PrunedTriggerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrunedTrigger'] = ResolversParentTypes['PrunedTrigger']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  factValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _empty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeOrganization?: Resolver<ResolversTypes['ActiveOrgResult'], ParentType, ContextType>;
  adminListActionItems?: Resolver<Array<ResolversTypes['ActionItem']>, ParentType, ContextType>;
  adminListLeads?: Resolver<Array<ResolversTypes['AdminLead']>, ParentType, ContextType, Partial<QueryAdminListLeadsArgs>>;
  adminListPilotInvites?: Resolver<Array<ResolversTypes['PilotInvite']>, ParentType, ContextType>;
  analyzePlanGoal?: Resolver<ResolversTypes['PlanAnalysisResult'], ParentType, ContextType, RequireFields<QueryAnalyzePlanGoalArgs, 'input'>>;
  analyzeStepContext?: Resolver<ResolversTypes['StepAnalysisResult'], ParentType, ContextType, RequireFields<QueryAnalyzeStepContextArgs, 'planId' | 'stepId'>>;
  automationAlerts?: Resolver<Array<ResolversTypes['AutomationAlert']>, ParentType, ContextType, Partial<QueryAutomationAlertsArgs>>;
  automationQueueHealth?: Resolver<Maybe<ResolversTypes['AutomationQueueHealth']>, ParentType, ContextType>;
  checkSlugAvailability?: Resolver<ResolversTypes['SlugAvailability'], ParentType, ContextType, RequireFields<QueryCheckSlugAvailabilityArgs, 'slug'>>;
  connectionRequirement?: Resolver<Maybe<ResolversTypes['ConnectionRequirement']>, ParentType, ContextType, RequireFields<QueryConnectionRequirementArgs, 'runId' | 'stepId'>>;
  documentGroup?: Resolver<Maybe<ResolversTypes['DocumentGroup']>, ParentType, ContextType, RequireFields<QueryDocumentGroupArgs, 'id'>>;
  documentGroupMembers?: Resolver<Array<ResolversTypes['GroupMembership']>, ParentType, ContextType, RequireFields<QueryDocumentGroupMembersArgs, 'groupId'>>;
  documentGroups?: Resolver<Array<ResolversTypes['DocumentGroup']>, ParentType, ContextType, RequireFields<QueryDocumentGroupsArgs, 'orgId'>>;
  driveFiles?: Resolver<Array<ResolversTypes['DriveFile']>, ParentType, ContextType, Partial<QueryDriveFilesArgs>>;
  evalPrompt?: Resolver<Maybe<ResolversTypes['EvalPrompt']>, ParentType, ContextType, RequireFields<QueryEvalPromptArgs, 'name'>>;
  evalPrompts?: Resolver<Array<ResolversTypes['EvalPrompt']>, ParentType, ContextType>;
  evalReport?: Resolver<Maybe<ResolversTypes['EvalReport']>, ParentType, ContextType, RequireFields<QueryEvalReportArgs, 'id'>>;
  evalReports?: Resolver<Array<ResolversTypes['EvalReportSummary']>, ParentType, ContextType>;
  evalTestCases?: Resolver<Array<ResolversTypes['EvalTestCase']>, ParentType, ContextType>;
  extractDescriptionItems?: Resolver<ResolversTypes['DescriptionExtraction'], ParentType, ContextType, RequireFields<QueryExtractDescriptionItemsArgs, 'description'>>;
  featuredGuides?: Resolver<Array<ResolversTypes['FeaturedGuide']>, ParentType, ContextType>;
  getConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, Partial<QueryGetConversationArgs>>;
  getPlansSummary?: Resolver<ResolversTypes['PlansSummary'], ParentType, ContextType>;
  getPublicPlan?: Resolver<Maybe<ResolversTypes['Plan']>, ParentType, ContextType, RequireFields<QueryGetPublicPlanArgs, 'planId'>>;
  getPublicTemplate?: Resolver<Maybe<ResolversTypes['Plan']>, ParentType, ContextType, RequireFields<QueryGetPublicTemplateArgs, 'templateKey'>>;
  groupSuggestions?: Resolver<Array<ResolversTypes['GroupSuggestion']>, ParentType, ContextType, RequireFields<QueryGroupSuggestionsArgs, 'orgId'>>;
  guideBySourceGroup?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType, RequireFields<QueryGuideBySourceGroupArgs, 'groupId'>>;
  guideCitations?: Resolver<Array<ResolversTypes['GuideCitation']>, ParentType, ContextType, RequireFields<QueryGuideCitationsArgs, 'guideId'>>;
  guideEditData?: Resolver<Maybe<ResolversTypes['GuideEditData']>, ParentType, ContextType, RequireFields<QueryGuideEditDataArgs, 'guideId'>>;
  guideLanding?: Resolver<Maybe<ResolversTypes['GuideLanding']>, ParentType, ContextType, RequireFields<QueryGuideLandingArgs, 'guideSlug' | 'orgSlug'>>;
  guideStarterInfo?: Resolver<Maybe<ResolversTypes['GuideStarterInfo']>, ParentType, ContextType, RequireFields<QueryGuideStarterInfoArgs, 'guideSlug' | 'orgSlug'>>;
  intakePublic?: Resolver<Maybe<ResolversTypes['IntakePublicData']>, ParentType, ContextType, RequireFields<QueryIntakePublicArgs, 'slug'>>;
  intakeRequest?: Resolver<Maybe<ResolversTypes['IntakeRequest']>, ParentType, ContextType, RequireFields<QueryIntakeRequestArgs, 'id'>>;
  intakeRequests?: Resolver<Array<ResolversTypes['IntakeRequest']>, ParentType, ContextType, Partial<QueryIntakeRequestsArgs>>;
  integrationCatalog?: Resolver<Array<ResolversTypes['IntegrationCatalogEntry']>, ParentType, ContextType, Partial<QueryIntegrationCatalogArgs>>;
  job?: Resolver<Maybe<ResolversTypes['Job']>, ParentType, ContextType, RequireFields<QueryJobArgs, 'id'>>;
  jobEventCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryJobEventCountArgs, 'jobId'>>;
  jobEvents?: Resolver<Array<ResolversTypes['JobEvent']>, ParentType, ContextType, RequireFields<QueryJobEventsArgs, 'jobId'>>;
  jobStatus?: Resolver<Maybe<ResolversTypes['QueueJobStatus']>, ParentType, ContextType, RequireFields<QueryJobStatusArgs, 'jobId'>>;
  listGuides?: Resolver<Array<ResolversTypes['GuideLanding']>, ParentType, ContextType>;
  listPlanTemplates?: Resolver<Array<ResolversTypes['Plan']>, ParentType, ContextType>;
  myAccessiblePlans?: Resolver<Array<ResolversTypes['PlanListItem']>, ParentType, ContextType, Partial<QueryMyAccessiblePlansArgs>>;
  myAssignedItems?: Resolver<Array<ResolversTypes['AssignedItem']>, ParentType, ContextType, Partial<QueryMyAssignedItemsArgs>>;
  myConnections?: Resolver<Array<ResolversTypes['IntegrationConnection']>, ParentType, ContextType>;
  myNotificationPreferences?: Resolver<ResolversTypes['NotificationPreferences'], ParentType, ContextType>;
  myNotifications?: Resolver<Array<ResolversTypes['AppNotification']>, ParentType, ContextType, Partial<QueryMyNotificationsArgs>>;
  myOrganizations?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  myParticipants?: Resolver<Array<ResolversTypes['Person']>, ParentType, ContextType>;
  myUnreadNotificationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openRouterModels?: Resolver<Array<ResolversTypes['OpenRouterModelPricing']>, ParentType, ContextType, Partial<QueryOpenRouterModelsArgs>>;
  orgConnectionAudit?: Resolver<Array<ResolversTypes['OrgAuditEntry']>, ParentType, ContextType, RequireFields<QueryOrgConnectionAuditArgs, 'orgId'>>;
  orgConnections?: Resolver<Array<ResolversTypes['IntegrationConnection']>, ParentType, ContextType, RequireFields<QueryOrgConnectionsArgs, 'orgId'>>;
  orgJobs?: Resolver<Array<ResolversTypes['Job']>, ParentType, ContextType, RequireFields<QueryOrgJobsArgs, 'orgId'>>;
  orgWebCrawls?: Resolver<Array<ResolversTypes['WebCrawl']>, ParentType, ContextType, RequireFields<QueryOrgWebCrawlsArgs, 'orgId'>>;
  organizationBrandProfileImpact?: Resolver<ResolversTypes['BrandProfileImpact'], ParentType, ContextType, RequireFields<QueryOrganizationBrandProfileImpactArgs, 'profileId'>>;
  organizationBrandProfiles?: Resolver<Array<ResolversTypes['OrganizationBrandProfile']>, ParentType, ContextType, RequireFields<QueryOrganizationBrandProfilesArgs, 'includeArchived'>>;
  participantPlan?: Resolver<Maybe<ResolversTypes['Plan']>, ParentType, ContextType, RequireFields<QueryParticipantPlanArgs, 'planId'>>;
  participantWorkspace?: Resolver<Maybe<ResolversTypes['ParticipantWorkspaceView']>, ParentType, ContextType, RequireFields<QueryParticipantWorkspaceArgs, 'planId'>>;
  person?: Resolver<Maybe<ResolversTypes['Person']>, ParentType, ContextType, RequireFields<QueryPersonArgs, 'id'>>;
  personProfile?: Resolver<Maybe<ResolversTypes['PersonProfile']>, ParentType, ContextType, RequireFields<QueryPersonProfileArgs, 'email'>>;
  pilotDashboardOverview?: Resolver<ResolversTypes['PilotDashboardOverview'], ParentType, ContextType, RequireFields<QueryPilotDashboardOverviewArgs, 'range'>>;
  pilotVisitor?: Resolver<Maybe<ResolversTypes['PilotVisitor']>, ParentType, ContextType, RequireFields<QueryPilotVisitorArgs, 'id'>>;
  pilotVisitors?: Resolver<ResolversTypes['PilotVisitorListResult'], ParentType, ContextType, Partial<QueryPilotVisitorsArgs>>;
  planAlerts?: Resolver<Array<ResolversTypes['AutomationAlert']>, ParentType, ContextType, RequireFields<QueryPlanAlertsArgs, 'planId'>>;
  planEventLog?: Resolver<Array<ResolversTypes['PlanEvent']>, ParentType, ContextType, RequireFields<QueryPlanEventLogArgs, 'planId'>>;
  planParticipants?: Resolver<Array<ResolversTypes['GlobalParticipant']>, ParentType, ContextType, RequireFields<QueryPlanParticipantsArgs, 'planId'>>;
  planapusPlan?: Resolver<Maybe<ResolversTypes['Plan']>, ParentType, ContextType, RequireFields<QueryPlanapusPlanArgs, 'id'>>;
  planapusPlans?: Resolver<Array<ResolversTypes['Plan']>, ParentType, ContextType, Partial<QueryPlanapusPlansArgs>>;
  platformIntegrations?: Resolver<Array<ResolversTypes['PlatformIntegrationStatus']>, ParentType, ContextType>;
  previewPlan?: Resolver<Maybe<ResolversTypes['PreviewPlanResult']>, ParentType, ContextType, RequireFields<QueryPreviewPlanArgs, 'id'>>;
  projectedPlan?: Resolver<Maybe<ResolversTypes['ProjectedPlanView']>, ParentType, ContextType, RequireFields<QueryProjectedPlanArgs, 'planId'>>;
  requestThread?: Resolver<Maybe<ResolversTypes['RequestThread']>, ParentType, ContextType, RequireFields<QueryRequestThreadArgs, 'id'>>;
  requestThreadPublic?: Resolver<Maybe<ResolversTypes['RequestThreadPublicData']>, ParentType, ContextType, RequireFields<QueryRequestThreadPublicArgs, 'slug'>>;
  requestThreadsForStep?: Resolver<Array<ResolversTypes['RequestThread']>, ParentType, ContextType, RequireFields<QueryRequestThreadsForStepArgs, 'planId' | 'stepId'>>;
  runConnections?: Resolver<Array<ResolversTypes['IntegrationConnection']>, ParentType, ContextType, RequireFields<QueryRunConnectionsArgs, 'runId'>>;
  searchMyParticipants?: Resolver<Array<ResolversTypes['Person']>, ParentType, ContextType, RequireFields<QuerySearchMyParticipantsArgs, 'query'>>;
  searchPersonProfiles?: Resolver<Array<ResolversTypes['PersonProfile']>, ParentType, ContextType, RequireFields<QuerySearchPersonProfilesArgs, 'query'>>;
  sourceItem?: Resolver<Maybe<ResolversTypes['SourceItem']>, ParentType, ContextType, RequireFields<QuerySourceItemArgs, 'id'>>;
  sourceItemDependencies?: Resolver<ResolversTypes['SourceItemDependency'], ParentType, ContextType, RequireFields<QuerySourceItemDependenciesArgs, 'sourceItemId'>>;
  sourceItemTree?: Resolver<Array<ResolversTypes['SourceItemTreeNode']>, ParentType, ContextType, RequireFields<QuerySourceItemTreeArgs, 'orgId'>>;
  sourceItems?: Resolver<Array<ResolversTypes['SourceItem']>, ParentType, ContextType, RequireFields<QuerySourceItemsArgs, 'orgId'>>;
  sourceItemsConnection?: Resolver<ResolversTypes['SourceItemConnection'], ParentType, ContextType, RequireFields<QuerySourceItemsConnectionArgs, 'orgId'>>;
  validateJourneyMagicLink?: Resolver<ResolversTypes['JourneyMagicLinkValidation'], ParentType, ContextType, RequireFields<QueryValidateJourneyMagicLinkArgs, 'token'>>;
  validateLoginMagicLink?: Resolver<ResolversTypes['LoginMagicLinkValidationResult'], ParentType, ContextType, RequireFields<QueryValidateLoginMagicLinkArgs, 'token'>>;
  validateMagicLink?: Resolver<ResolversTypes['MagicLinkValidationResult'], ParentType, ContextType, RequireFields<QueryValidateMagicLinkArgs, 'token'>>;
  webCrawl?: Resolver<Maybe<ResolversTypes['WebCrawl']>, ParentType, ContextType, RequireFields<QueryWebCrawlArgs, 'id'>>;
  webCrawlPages?: Resolver<Array<ResolversTypes['CrawledPage']>, ParentType, ContextType, RequireFields<QueryWebCrawlPagesArgs, 'crawlId'>>;
};

export type QueueJobStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueJobStatus'] = ResolversParentTypes['QueueJobStatus']> = {
  attemptsMade?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finishedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobState'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type ReflowSuggestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReflowSuggestion'] = ResolversParentTypes['ReflowSuggestion']> = {
  affectedStepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiresApproval?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  suggestedChanges?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
};

export type RequestPilotInviteByEmailResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestPilotInviteByEmailResult'] = ResolversParentTypes['RequestPilotInviteByEmailResult']> = {
  sent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type RequestSpecResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestSpec'] = ResolversParentTypes['RequestSpec']> = {
  allowedFields?: Resolver<Array<ResolversTypes['AllowedField']>, ParentType, ContextType>;
  ask?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputContract?: Resolver<ResolversTypes['OutputContract'], ParentType, ContextType>;
  uiMode?: Resolver<Maybe<ResolversTypes['RequestUIMode']>, ParentType, ContextType>;
};

export type RequestThreadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestThread'] = ResolversParentTypes['RequestThread']> = {
  accessMode?: Resolver<ResolversTypes['ThreadAccessMode'], ParentType, ContextType>;
  assigneeIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ThreadMessage']>, ParentType, ContextType>;
  parentPlanId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentStepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentStepTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestSpec?: Resolver<ResolversTypes['RequestSpec'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['BoundedResult']>, ParentType, ContextType>;
  satisfactionState?: Resolver<Maybe<ResolversTypes['SatisfactionState']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RequestThreadStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploads?: Resolver<Array<ResolversTypes['ThreadUpload']>, ParentType, ContextType>;
};

export type RequestThreadPublicDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestThreadPublicData'] = ResolversParentTypes['RequestThreadPublicData']> = {
  accessMode?: Resolver<ResolversTypes['ThreadAccessMode'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ThreadMessage']>, ParentType, ContextType>;
  parentStepTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestSpec?: Resolver<ResolversTypes['RequestSpec'], ParentType, ContextType>;
  satisfactionState?: Resolver<Maybe<ResolversTypes['SatisfactionState']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RequestThreadStatus'], ParentType, ContextType>;
  uploads?: Resolver<Array<ResolversTypes['ThreadUpload']>, ParentType, ContextType>;
};

export type RequiredItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequiredItem'] = ResolversParentTypes['RequiredItem']> = {
  category?: Resolver<Maybe<ResolversTypes['RequiredItemCategory']>, ParentType, ContextType>;
  condition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionMet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  evidence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RequiredItemStatus'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type ResolvedGuideThemeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResolvedGuideTheme'] = ResolversParentTypes['ResolvedGuideTheme']> = {
  accessibilityAdjusted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  backgroundColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidenceScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ctaTextColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headerLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  secondaryColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tone?: Resolver<Maybe<ResolversTypes['BrandTone']>, ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SatisfactionStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SatisfactionState'] = ResolversParentTypes['SatisfactionState']> = {
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  evaluatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extractedFields?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  isReady?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  missingFields?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  progressSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ScoreBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreBreakdown'] = ResolversParentTypes['ScoreBreakdown']> = {
  contentSimilarity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  goalClarity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  personaFit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sharedEntities?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  urlNeighborhood?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type SendChatMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendChatMessageResponse'] = ResolversParentTypes['SendChatMessageResponse']> = {
  assistantMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType>;
  autoAction?: Resolver<Maybe<ResolversTypes['StepAutoAction']>, ParentType, ContextType>;
  conversation?: Resolver<ResolversTypes['Conversation'], ParentType, ContextType>;
  userMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType>;
};

export type SendMessageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendMessageResult'] = ResolversParentTypes['SendMessageResult']> = {
  emailSuccess?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  smsSuccess?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type SkillRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkillRef'] = ResolversParentTypes['SkillRef']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  intent?: Resolver<Maybe<ResolversTypes['StepIntent']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['SkillSource'], ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SlugAvailabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlugAvailability'] = ResolversParentTypes['SlugAvailability']> = {
  available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceAnalysisResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceAnalysisResult'] = ResolversParentTypes['SourceAnalysisResult']> = {
  analyzedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  audience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  guide_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guideable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  guideable_rationale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  wave?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItem'] = ResolversParentTypes['SourceItem']> = {
  analysis?: Resolver<Maybe<ResolversTypes['SourceAnalysisResult']>, ParentType, ContextType>;
  analysisStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classificationOverride?: Resolver<Maybe<ResolversTypes['ClassificationOverride']>, ParentType, ContextType>;
  classificationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classificationWave1?: Resolver<Maybe<ResolversTypes['ClassificationResult']>, ParentType, ContextType>;
  classificationWave2?: Resolver<Maybe<ResolversTypes['ClassificationResult']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extractedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extractionMetadata?: Resolver<Maybe<ResolversTypes['ExtractionMetadata']>, ParentType, ContextType>;
  extractionStatus?: Resolver<ResolversTypes['ExtractionStatus'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  linkedFromPages?: Resolver<Maybe<Array<ResolversTypes['SourceItemLinkedPage']>>, ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  primaryOwnerGroupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reviewStatus?: Resolver<ResolversTypes['ReviewStatus'], ParentType, ContextType>;
  sizeBytes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summarizationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItemConnection'] = ResolversParentTypes['SourceItemConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SourceItemEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['SourceItemPageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type SourceItemDependencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItemDependency'] = ResolversParentTypes['SourceItemDependency']> = {
  canDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  citations?: Resolver<Array<ResolversTypes['DependencyCitationRef']>, ParentType, ContextType>;
  groupMemberships?: Resolver<Array<ResolversTypes['DependencyGroupRef']>, ParentType, ContextType>;
  suggestions?: Resolver<Array<ResolversTypes['DependencySuggestionRef']>, ParentType, ContextType>;
};

export type SourceItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItemEdge'] = ResolversParentTypes['SourceItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SourceItem'], ParentType, ContextType>;
};

export type SourceItemLinkedPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItemLinkedPage'] = ResolversParentTypes['SourceItemLinkedPage']> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceItemPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItemPageInfo'] = ResolversParentTypes['SourceItemPageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type SourceItemTreeNodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceItemTreeNode'] = ResolversParentTypes['SourceItemTreeNode']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasChildren?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SourceLocatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceLocator'] = ResolversParentTypes['SourceLocator']> = {
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paragraphIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  selector?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type StartJobResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartJobResult'] = ResolversParentTypes['StartJobResult']> = {
  deduplicated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  resultRef?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
};

export type StartJourneyResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartJourneyResult'] = ResolversParentTypes['StartJourneyResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type StatusBucketCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatusBucketCounts'] = ResolversParentTypes['StatusBucketCounts']> = {
  active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blocked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  done?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type StatusCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatusCounts'] = ResolversParentTypes['StatusCounts']> = {
  blocked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inProgress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  todo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type StepAllowedFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepAllowedField'] = ResolversParentTypes['StepAllowedField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enumValues?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type StepAnalysisResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepAnalysisResult'] = ResolversParentTypes['StepAnalysisResult']> = {
  capabilities?: Resolver<ResolversTypes['StepCapabilities'], ParentType, ContextType>;
  missingContext?: Resolver<Array<ResolversTypes['ContextRequirementOutput']>, ParentType, ContextType>;
  recommendedSkills?: Resolver<Array<ResolversTypes['SkillRef']>, ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type StepApplicabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepApplicability'] = ResolversParentTypes['StepApplicability']> = {
  applicable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dependsOnFacts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  evaluatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prunedTrigger?: Resolver<Maybe<ResolversTypes['PrunedTrigger']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type StepAssessmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepAssessment'] = ResolversParentTypes['StepAssessment']> = {
  completionConfidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  eligibleForCompletion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  extractedFacts?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['StepProgress'], ParentType, ContextType>;
  suggestedNext?: Resolver<ResolversTypes['SuggestedNextActions'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type StepAutoActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepAutoAction'] = ResolversParentTypes['StepAutoAction']> = {
  action?: Resolver<ResolversTypes['StepAutoActionType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextStepId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  nextStepTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  stepTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type StepBlockedInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepBlockedInfo'] = ResolversParentTypes['StepBlockedInfo']> = {
  blockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canStart?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hiddenPrereqCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isBlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  visiblePrereqIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type StepCapabilitiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepCapabilities'] = ResolversParentTypes['StepCapabilities']> = {
  canDraft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canExecute?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canRecommend?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canResearch?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requiresExternalInput?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requiresHumanDecision?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type StepContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepContext'] = ResolversParentTypes['StepContext']> = {
  collectedData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  connectorActivityLog?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  connectorPollResult?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  connectorResponse?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  connectorWait?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lastConnectorSubmitInput?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  links?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pollResult?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  webhookResult?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type StepDependencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepDependency'] = ResolversParentTypes['StepDependency']> = {
  affectedFields?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  dependencyType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dependsOn?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  stepId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type StepDependencyStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepDependencyStatus'] = ResolversParentTypes['StepDependencyStatus']> = {
  allSatisfied?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  blockedByHiddenSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canStart?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  visibleBlockingStepIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type StepIntakeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepIntakeData'] = ResolversParentTypes['StepIntakeData']> = {
  fileRefs?: Resolver<Maybe<Array<ResolversTypes['IntakeFileRef']>>, ParentType, ContextType>;
  intakeRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  normalizedResult?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IntakeStatus'], ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type StepProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepProgress'] = ResolversParentTypes['StepProgress']> = {
  effortWeighted?: Resolver<ResolversTypes['EffortWeightedProgress'], ParentType, ContextType>;
  structured?: Resolver<ResolversTypes['StructuredProgress'], ParentType, ContextType>;
};

export type StepRequestThreadResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepRequestThread'] = ResolversParentTypes['StepRequestThread']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['StepThreadResult']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RequestThreadStatus'], ParentType, ContextType>;
  threadId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type StepStatusEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepStatusEvent'] = ResolversParentTypes['StepStatusEvent']> = {
  changedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  changedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StepStatus'], ParentType, ContextType>;
};

export type StepThreadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepThreadResult'] = ResolversParentTypes['StepThreadResult']> = {
  completedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type StructuredProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['StructuredProgress'] = ResolversParentTypes['StructuredProgress']> = {
  doneCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fraction?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  requiredItems?: Resolver<Array<ResolversTypes['RequiredItem']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type SuggestedNextActionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedNextActions'] = ResolversParentTypes['SuggestedNextActions']> = {
  missingInfoQuestions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  recommendedActions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SuggestedSaaSResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedSaaS'] = ResolversParentTypes['SuggestedSaaS']> = {
  communication?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  esign?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  pm?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  storage?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
};

export type ThreadMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThreadMessage'] = ResolversParentTypes['ThreadMessage']> = {
  attachmentIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ThreadUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThreadUpload'] = ResolversParentTypes['ThreadUpload']> = {
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TrackPilotEventsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackPilotEventsResult'] = ResolversParentTypes['TrackPilotEventsResult']> = {
  accepted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  visitorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type UpdateThreadFieldsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateThreadFieldsResult'] = ResolversParentTypes['UpdateThreadFieldsResult']> = {
  fieldErrors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  requestThread?: Resolver<ResolversTypes['RequestThread'], ParentType, ContextType>;
  satisfactionState?: Resolver<ResolversTypes['SatisfactionState'], ParentType, ContextType>;
};

export type ValidatePilotInviteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidatePilotInviteResult'] = ResolversParentTypes['ValidatePilotInviteResult']> = {
  audience?: Resolver<Maybe<ResolversTypes['PilotInviteAudience']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type WebCrawlResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebCrawl'] = ResolversParentTypes['WebCrawl']> = {
  allowedDomains?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  brandExtraction?: Resolver<Maybe<ResolversTypes['BrandDiscoveryResult']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentsFound?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  documentsImported?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generationJobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxDepth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxPages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pagesCrawled?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesDiscovered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requestedByUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type WorkspaceRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkspaceRole'] = ResolversParentTypes['WorkspaceRole']> = {
  assigneeEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assigneeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isViewer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActionItem?: ActionItemResolvers<ContextType>;
  ActiveOrgResult?: ActiveOrgResultResolvers<ContextType>;
  AdminLead?: AdminLeadResolvers<ContextType>;
  AllowedField?: AllowedFieldResolvers<ContextType>;
  AnonymousRunSession?: AnonymousRunSessionResolvers<ContextType>;
  AppNotification?: AppNotificationResolvers<ContextType>;
  ApprovalRecord?: ApprovalRecordResolvers<ContextType>;
  AssignedItem?: AssignedItemResolvers<ContextType>;
  AutoExecuteError?: AutoExecuteErrorResolvers<ContextType>;
  AutoExecuteResult?: AutoExecuteResultResolvers<ContextType>;
  AutomationAction?: AutomationActionResolvers<ContextType>;
  AutomationAlert?: AutomationAlertResolvers<ContextType>;
  AutomationQueueHealth?: AutomationQueueHealthResolvers<ContextType>;
  BlockedSourceItem?: BlockedSourceItemResolvers<ContextType>;
  BoundedResult?: BoundedResultResolvers<ContextType>;
  BrandCandidate?: BrandCandidateResolvers<ContextType>;
  BrandDiscoveryResult?: BrandDiscoveryResultResolvers<ContextType>;
  BrandPalette?: BrandPaletteResolvers<ContextType>;
  BrandProfileImpact?: BrandProfileImpactResolvers<ContextType>;
  BrandSelection?: BrandSelectionResolvers<ContextType>;
  CaptureLeadResult?: CaptureLeadResultResolvers<ContextType>;
  ChatMessage?: ChatMessageResolvers<ContextType>;
  ClaimAnonymousRunResult?: ClaimAnonymousRunResultResolvers<ContextType>;
  ClaimPreviewResult?: ClaimPreviewResultResolvers<ContextType>;
  ClarifyingQuestion?: ClarifyingQuestionResolvers<ContextType>;
  ClassificationOverride?: ClassificationOverrideResolvers<ContextType>;
  ClassificationResult?: ClassificationResultResolvers<ContextType>;
  ConfirmThreadResult?: ConfirmThreadResultResolvers<ContextType>;
  ConnectSessionResult?: ConnectSessionResultResolvers<ContextType>;
  ConnectionRequirement?: ConnectionRequirementResolvers<ContextType>;
  ContextRequirementOutput?: ContextRequirementOutputResolvers<ContextType>;
  Conversation?: ConversationResolvers<ContextType>;
  CrawledDocumentRef?: CrawledDocumentRefResolvers<ContextType>;
  CrawledPage?: CrawledPageResolvers<ContextType>;
  CreateIntakeRequestResult?: CreateIntakeRequestResultResolvers<ContextType>;
  CreateRequestThreadResult?: CreateRequestThreadResultResolvers<ContextType>;
  Deadline?: DeadlineResolvers<ContextType>;
  DeleteSourceItemsResult?: DeleteSourceItemsResultResolvers<ContextType>;
  DependencyCitationRef?: DependencyCitationRefResolvers<ContextType>;
  DependencyGroupRef?: DependencyGroupRefResolvers<ContextType>;
  DependencySuggestionRef?: DependencySuggestionRefResolvers<ContextType>;
  DescriptionExtraction?: DescriptionExtractionResolvers<ContextType>;
  DocumentGroup?: DocumentGroupResolvers<ContextType>;
  DocumentGroupWithGuideStatus?: DocumentGroupWithGuideStatusResolvers<ContextType>;
  DomainFinding?: DomainFindingResolvers<ContextType>;
  DomainResearch?: DomainResearchResolvers<ContextType>;
  DriveFile?: DriveFileResolvers<ContextType>;
  EffortWeightedProgress?: EffortWeightedProgressResolvers<ContextType>;
  EnqueuedJob?: EnqueuedJobResolvers<ContextType>;
  EvalCaseExpected?: EvalCaseExpectedResolvers<ContextType>;
  EvalCaseResult?: EvalCaseResultResolvers<ContextType>;
  EvalExpected?: EvalExpectedResolvers<ContextType>;
  EvalFieldAccuracy?: EvalFieldAccuracyResolvers<ContextType>;
  EvalFieldAccuracyReport?: EvalFieldAccuracyReportResolvers<ContextType>;
  EvalPrompt?: EvalPromptResolvers<ContextType>;
  EvalPromptScore?: EvalPromptScoreResolvers<ContextType>;
  EvalReport?: EvalReportResolvers<ContextType>;
  EvalReportSummary?: EvalReportSummaryResolvers<ContextType>;
  EvalTestCase?: EvalTestCaseResolvers<ContextType>;
  ExecuteStepResult?: ExecuteStepResultResolvers<ContextType>;
  ExecutionError?: ExecutionErrorResolvers<ContextType>;
  ExecutionResult?: ExecutionResultResolvers<ContextType>;
  ExtractionMetadata?: ExtractionMetadataResolvers<ContextType>;
  FactConstraint?: FactConstraintResolvers<ContextType>;
  FaqBlock?: FaqBlockResolvers<ContextType>;
  FeaturedGuide?: FeaturedGuideResolvers<ContextType>;
  FileUploadUrl?: FileUploadUrlResolvers<ContextType>;
  FuzzyPlanContext?: FuzzyPlanContextResolvers<ContextType>;
  GenerateGuideFromGroupResult?: GenerateGuideFromGroupResultResolvers<ContextType>;
  GenerationSource?: GenerationSourceResolvers<ContextType>;
  GlobalParticipant?: GlobalParticipantResolvers<ContextType>;
  GoalInterpretation?: GoalInterpretationResolvers<ContextType>;
  GroupMembership?: GroupMembershipResolvers<ContextType>;
  GroupSuggestion?: GroupSuggestionResolvers<ContextType>;
  Guardrail?: GuardrailResolvers<ContextType>;
  GuideCitation?: GuideCitationResolvers<ContextType>;
  GuideEditData?: GuideEditDataResolvers<ContextType>;
  GuideLanding?: GuideLandingResolvers<ContextType>;
  GuideStarterInfo?: GuideStarterInfoResolvers<ContextType>;
  GuideStep?: GuideStepResolvers<ContextType>;
  GuideTheme?: GuideThemeResolvers<ContextType>;
  GuideThemeOverrides?: GuideThemeOverridesResolvers<ContextType>;
  GuideVersion?: GuideVersionResolvers<ContextType>;
  GuideVersionFile?: GuideVersionFileResolvers<ContextType>;
  GuideVersionOutput?: GuideVersionOutputResolvers<ContextType>;
  HiddenStepSummary?: HiddenStepSummaryResolvers<ContextType>;
  IntakeFileRef?: IntakeFileRefResolvers<ContextType>;
  IntakeFileUploadUrl?: IntakeFileUploadUrlResolvers<ContextType>;
  IntakePublicData?: IntakePublicDataResolvers<ContextType>;
  IntakeRequest?: IntakeRequestResolvers<ContextType>;
  IntakeSubmission?: IntakeSubmissionResolvers<ContextType>;
  IntakeSubmitResult?: IntakeSubmitResultResolvers<ContextType>;
  IntegrationCatalogEntry?: IntegrationCatalogEntryResolvers<ContextType>;
  IntegrationConnection?: IntegrationConnectionResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  Job?: JobResolvers<ContextType>;
  JobEvent?: JobEventResolvers<ContextType>;
  JourneyMagicLinkConsumption?: JourneyMagicLinkConsumptionResolvers<ContextType>;
  JourneyMagicLinkValidation?: JourneyMagicLinkValidationResolvers<ContextType>;
  JourneyRole?: JourneyRoleResolvers<ContextType>;
  LinkedPageRef?: LinkedPageRefResolvers<ContextType>;
  LoginMagicLinkResult?: LoginMagicLinkResultResolvers<ContextType>;
  LoginMagicLinkValidationResult?: LoginMagicLinkValidationResultResolvers<ContextType>;
  MagicLinkValidationResult?: MagicLinkValidationResultResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NotificationPreferences?: NotificationPreferencesResolvers<ContextType>;
  OpenRouterModelPricing?: OpenRouterModelPricingResolvers<ContextType>;
  OrgAuditEntry?: OrgAuditEntryResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationBrandProfile?: OrganizationBrandProfileResolvers<ContextType>;
  OrganizationBrandingSettings?: OrganizationBrandingSettingsResolvers<ContextType>;
  OrganizationMembership?: OrganizationMembershipResolvers<ContextType>;
  OutputContract?: OutputContractResolvers<ContextType>;
  Participant?: ParticipantResolvers<ContextType>;
  ParticipantStep?: ParticipantStepResolvers<ContextType>;
  ParticipantWorkspaceView?: ParticipantWorkspaceViewResolvers<ContextType>;
  Person?: PersonResolvers<ContextType>;
  PersonProfile?: PersonProfileResolvers<ContextType>;
  PhaseContext?: PhaseContextResolvers<ContextType>;
  PhaseProgress?: PhaseProgressResolvers<ContextType>;
  PhaseSummary?: PhaseSummaryResolvers<ContextType>;
  PilotBreakdownPoint?: PilotBreakdownPointResolvers<ContextType>;
  PilotDashboardOverview?: PilotDashboardOverviewResolvers<ContextType>;
  PilotEvent?: PilotEventResolvers<ContextType>;
  PilotFunnelStage?: PilotFunnelStageResolvers<ContextType>;
  PilotInvite?: PilotInviteResolvers<ContextType>;
  PilotKpiTile?: PilotKpiTileResolvers<ContextType>;
  PilotLeadAdmin?: PilotLeadAdminResolvers<ContextType>;
  PilotLeadResult?: PilotLeadResultResolvers<ContextType>;
  PilotSession?: PilotSessionResolvers<ContextType>;
  PilotTimeSeriesPoint?: PilotTimeSeriesPointResolvers<ContextType>;
  PilotVisitor?: PilotVisitorResolvers<ContextType>;
  PilotVisitorAttribution?: PilotVisitorAttributionResolvers<ContextType>;
  PilotVisitorIdentity?: PilotVisitorIdentityResolvers<ContextType>;
  PilotVisitorListResult?: PilotVisitorListResultResolvers<ContextType>;
  Plan?: PlanResolvers<ContextType>;
  PlanAnalysisResult?: PlanAnalysisResultResolvers<ContextType>;
  PlanArtifact?: PlanArtifactResolvers<ContextType>;
  PlanEvaluation?: PlanEvaluationResolvers<ContextType>;
  PlanEvent?: PlanEventResolvers<ContextType>;
  PlanListItem?: PlanListItemResolvers<ContextType>;
  PlanPhase?: PlanPhaseResolvers<ContextType>;
  PlanRole?: PlanRoleResolvers<ContextType>;
  PlanStep?: PlanStepResolvers<ContextType>;
  PlansSummary?: PlansSummaryResolvers<ContextType>;
  PlatformIntegrationStatus?: PlatformIntegrationStatusResolvers<ContextType>;
  PostThreadMessageResult?: PostThreadMessageResultResolvers<ContextType>;
  PreviewOutline?: PreviewOutlineResolvers<ContextType>;
  PreviewOutlineStep?: PreviewOutlineStepResolvers<ContextType>;
  PreviewPlanResult?: PreviewPlanResultResolvers<ContextType>;
  ProjectedPlanView?: ProjectedPlanViewResolvers<ContextType>;
  PrunedTrigger?: PrunedTriggerResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueueJobStatus?: QueueJobStatusResolvers<ContextType>;
  ReflowSuggestion?: ReflowSuggestionResolvers<ContextType>;
  RequestPilotInviteByEmailResult?: RequestPilotInviteByEmailResultResolvers<ContextType>;
  RequestSpec?: RequestSpecResolvers<ContextType>;
  RequestThread?: RequestThreadResolvers<ContextType>;
  RequestThreadPublicData?: RequestThreadPublicDataResolvers<ContextType>;
  RequiredItem?: RequiredItemResolvers<ContextType>;
  ResolvedGuideTheme?: ResolvedGuideThemeResolvers<ContextType>;
  SatisfactionState?: SatisfactionStateResolvers<ContextType>;
  ScoreBreakdown?: ScoreBreakdownResolvers<ContextType>;
  SendChatMessageResponse?: SendChatMessageResponseResolvers<ContextType>;
  SendMessageResult?: SendMessageResultResolvers<ContextType>;
  SkillRef?: SkillRefResolvers<ContextType>;
  SlugAvailability?: SlugAvailabilityResolvers<ContextType>;
  SourceAnalysisResult?: SourceAnalysisResultResolvers<ContextType>;
  SourceItem?: SourceItemResolvers<ContextType>;
  SourceItemConnection?: SourceItemConnectionResolvers<ContextType>;
  SourceItemDependency?: SourceItemDependencyResolvers<ContextType>;
  SourceItemEdge?: SourceItemEdgeResolvers<ContextType>;
  SourceItemLinkedPage?: SourceItemLinkedPageResolvers<ContextType>;
  SourceItemPageInfo?: SourceItemPageInfoResolvers<ContextType>;
  SourceItemTreeNode?: SourceItemTreeNodeResolvers<ContextType>;
  SourceLocator?: SourceLocatorResolvers<ContextType>;
  StartJobResult?: StartJobResultResolvers<ContextType>;
  StartJourneyResult?: StartJourneyResultResolvers<ContextType>;
  StatusBucketCounts?: StatusBucketCountsResolvers<ContextType>;
  StatusCounts?: StatusCountsResolvers<ContextType>;
  StepAllowedField?: StepAllowedFieldResolvers<ContextType>;
  StepAnalysisResult?: StepAnalysisResultResolvers<ContextType>;
  StepApplicability?: StepApplicabilityResolvers<ContextType>;
  StepAssessment?: StepAssessmentResolvers<ContextType>;
  StepAutoAction?: StepAutoActionResolvers<ContextType>;
  StepBlockedInfo?: StepBlockedInfoResolvers<ContextType>;
  StepCapabilities?: StepCapabilitiesResolvers<ContextType>;
  StepContext?: StepContextResolvers<ContextType>;
  StepDependency?: StepDependencyResolvers<ContextType>;
  StepDependencyStatus?: StepDependencyStatusResolvers<ContextType>;
  StepIntakeData?: StepIntakeDataResolvers<ContextType>;
  StepProgress?: StepProgressResolvers<ContextType>;
  StepRequestThread?: StepRequestThreadResolvers<ContextType>;
  StepStatusEvent?: StepStatusEventResolvers<ContextType>;
  StepThreadResult?: StepThreadResultResolvers<ContextType>;
  StructuredProgress?: StructuredProgressResolvers<ContextType>;
  SuggestedNextActions?: SuggestedNextActionsResolvers<ContextType>;
  SuggestedSaaS?: SuggestedSaaSResolvers<ContextType>;
  ThreadMessage?: ThreadMessageResolvers<ContextType>;
  ThreadUpload?: ThreadUploadResolvers<ContextType>;
  TrackPilotEventsResult?: TrackPilotEventsResultResolvers<ContextType>;
  UpdateThreadFieldsResult?: UpdateThreadFieldsResultResolvers<ContextType>;
  ValidatePilotInviteResult?: ValidatePilotInviteResultResolvers<ContextType>;
  WebCrawl?: WebCrawlResolvers<ContextType>;
  WorkspaceRole?: WorkspaceRoleResolvers<ContextType>;
};

